/**
 * Landing-page translations (en/hi/mr) — merged into the global STRINGS at
 * module load. Other languages fall back to English (existing i18n behavior).
 * Imported for side-effect from LanguageContext.
 */
import { STRINGS } from "./i18n";

const LANDING = {
    en: {
        // Hero
        heroFamiliesTrust: "Indian families trust us",
        heroTitleA: "Your family's history",
        heroTitleB: "preserved",
        heroTitleC: "forever.",
        heroSub: "Build your family tree, record your elders' voices, preserve photos and documents — all in one private space made for Indian families, in your own language.",
        heroCtaStart: "Start free with mobile OTP",
        heroCtaHow: "See how it works",
        trustPrivate: "Default Private",
        trustLangs: "10 Languages",
        trustFree: "Start Free Today",
        trustSecure: "Bank Level Security",
        trustIndians: "Designed for Indians",
        // Free-start popup
        fsdTitle: "Start Free with Mobile OTP",
        fsdSub: "Get started in 1 minute — completely free.",
        fsdP1T: "100% Free start",
        fsdP1D: "No credit card, no hidden charges. Family tree, photos and stories included in the Free plan.",
        fsdP2T: "Just your mobile number",
        fsdP2D: "Enter your mobile number → receive OTP → you're in. No email or password to remember.",
        fsdP3T: "Your privacy first",
        fsdP3D: "Private by default — only your family can see your data.",
        fsdContinue: "Continue — Start Free",
        fsdLater: "Maybe later",
        // Demos gallery
        dbTitle: "Product Demos & Reels",
        dbSub: "Watch how the full family tree, memories, vault and culture features work — in short videos.",
        dbBtn: "Watch Demos",
        dpHeading: "Demos, Reels & Documentaries",
        dpSub: "Every product and service demonstrated — from full family tree building to the legacy vault.",
        dpFeaturedTag: "Featured Demo",
        dpAll: "All",
        dpComingSoon: "Video coming soon",
        // Header nav (redesigned IA)
        navHome: "Home",
        navAbout: "About Us",
        navProducts: "Product and Services",
        navHowItWorks: "How it works",
        navFeatures: "Features",
        navSolutions: "Solutions",
        navHelp: "Help",
        navPackage: "Package",
        navResources: "Resources",
        navPricing: "Pricing",
        navDemos: "Demos",
        accMenuLabel: "Senior Mode",
        accSenior: "Senior Mode",
        accSeniorDesc: "Bigger text & buttons for elders",
        accTextSize: "Text size",
        // How it works
        howEyebrow: "The Process",
        howHeading: "Five steps, one lifetime",
        howSub: "Follow Simple 5 Steps to Complete Most Important Work of Your Life",
        how1T: "Log in as Head of Family",
        how1D: "Give basis Credential\nStart Family Tree\nBecome Custodian of Repository",
        how2T: "Add Family Members",
        how2D: "Add parents, grandparents,\nAdd Spouses & Children's\nCreate Complete family tree.",
        how3T: "Upload Memories & Stories",
        how3D: "Preserve Photos, Audios & Videos\nPreserve Imp Documents\nPreserve Culture, Traditions, Rituals",
        how4T: "Create & Share Link Close Family",
        how4D: "Invite Relatives to start their family tree\nContinue to Update Imp Information\nVisit Mobile for Daily Updates",
        how5T: "Legacy Continued for generations …",
        how5D: "Children's & Grandchildren's continue..\nAny one call recall required information\nBecomes Permanent Legacy Repository .",
        // Why families choose us
        wcuEyebrow: "Why All Indians Should Use This Platform",
        wcuHeading: "Unique Value Propositions of Family Repository",
        wcu1T: "Family Tree",
        wcu1D: "Six generations, every branch — mapped in a tree anyone can read.",
        wcu2T: "Photos & Memories",
        wcu2D: "Photographs, notes and moments, stored safely and easy to find.",
        wcu3T: "Voice & Audio Stories",
        wcu3D: "Record elders in their own voice, in their own language.",
        wcu4T: "Video Legacy",
        wcu4D: "Video messages and testaments kept for the generations ahead.",
        wcu5T: "Documents Vault",
        wcu5D: "Certificates, deeds and papers — organised and encrypted.",
        wcuCtaT: "Start your family's legacy today",
        wcuCtaD: "Free to begin — just your mobile number. Your grandchildren will thank you.",
        wcuCtaBtn: "Start Free",
        // Journey flow
        jfEyebrow: "Your Journey",
        jfHeading: "Three simple steps from today to forever",
        jfSub: "Most families finish step 1 in under two minutes. The journey itself can last a lifetime.",
        jf1T: "Add your family",
        jf1D: "Mobile OTP signup in 60 seconds. Add parents, spouse, children one by one — speak their names in Hindi/Marathi if typing feels slow.",
        jf1B1: "No password ever",
        jf1B2: "Voice input in 10 Indian languages",
        jf1B3: "Auto-fills relations",
        jf2T: "Capture stories & photos",
        jf2D: "Record your dadi's stories, upload wedding & festival photos, organise into albums. AI transcribes voice in your language.",
        jf2B1: "Audio + photos + documents",
        jf2B2: "Tag people from your tree",
        jf2B3: "Whisper transcription",
        jf3T: "Preserve forever, share safely",
        jf3D: "Encrypted Indian-server storage. Draft wills with audio. Schedule time-capsules for grandchildren. DPDP-compliant by design.",
        jf3B1: "AES-256 encryption",
        jf3B2: "Biometric-gated vaults",
        jf3B3: "Stays in your family always",
        jfCta: "Begin step 1 now",
        jfNote: "Free forever for the first 25 family members. Upgrade only when you outgrow it.",
        // Features
        featEyebrow: "Features",
        featHeading: "Everything a family needs to remember together",
        // What will happen
        wwhEyebrow: "",
        wwhTitleA: "What Happens if You Don't Preserve",
        wwhTitleB: "Your Family Legacy ????",
        wwhHintDesktop: "Auto-plays every 3s · hover to pause · swipe, ← → or dots to browse.",
        wwhHintMobile: "Auto-plays · swipe to browse.",
        // Pain points
        ppHeading: "What happens if family history is not preserved?",
        pp1: "Elders' memories disappear forever",
        pp2: "Old photos get lost or damaged",
        pp3: "Children lose touch with their roots",
        pp4: "Traditions fade with each generation",
        // Testimonials
        tEyebrow: "Testimonials",
        tHeadA: "Families across ",
        tIndia: "India",
        tHeadB: " trust us",
        tSub: "Real families - Real Life Stories & Legacies Preserved Forever.",
        // FAQ
        faqHeading: "Frequently asked questions",
        faq1Q: "Is our family data safe?",
        faq1A: "Yes. Bank-level AES-256 encryption at rest, httpOnly cookie auth, optional fingerprint/Face ID gate on Document & Legal Vault, India-resident MongoDB storage.",
        faq2Q: "Can NRI families use this?",
        faq2A: "Absolutely. Multi-timezone support, browser language auto-detection in 10 Indian languages, and a Family World Map widget that shows where every relative lives.",
        faq3Q: "Is it easy for senior citizens?",
        faq3A: "Yes. Senior Mode shows just 3 huge buttons (Photos / Story / Family). 22px font, larger tap targets, voice-recording first.",
        faq4Q: "Can we add 100+ family members?",
        faq4A: "Free plan covers 25 members; Family ₹999/yr unlocks unlimited members + 10 GB storage; Legacy ₹2999/yr adds Legal Vault, 100 GB, printed tree, and priority support.",
        faq5Q: "What languages are supported?",
        faq5A: "English, Hindi, Marathi, Tamil, Telugu, Kannada, Malayalam, Bengali, Gujarati and Punjabi — full UI translation, with browser language auto-detected on first visit.",
        faq6Q: "Can we export our data?",
        faq6A: "Yes. Settings → My Data → Download All My Data exports your tree, memories, stories and documents in a single archive (DPDP-compliant).",
        faq7Q: "What happens after free trial?",
        faq7A: "There's no trial — Free plan is permanent. Upgrade only when you need >25 members, AI biography or Legal Vault. We have a 7-day grace period and full money-back guarantee on annual plans.",
        faq8Q: "Can multiple members contribute?",
        faq8A: "Yes. Invite siblings, parents and cousins by mobile number. Each gets a role: Family Head / Editor / Viewer — fine-grained per-document privacy controls included.",
        // Mobile sticky CTA
        mscTitle: "Free · Mobile OTP signup",
        mscDpdp: "DPDP compliant",
        mscStart: "Start free",
        // Mobile QR
        qrEyebrow: "Take your family with you",
        qrHeading: "Scan once. Family Repository on your phone.",
        qrSub: "Point your camera at the QR code to install the app. Works on both Android and iPhone — we detect the right store automatically.",
        qrLi1: "One-tap install on Android & iPhone",
        qrLi2: "iOS 14+ — App Store",
        qrLi3: "Android 8+ — Google Play",
        qrOrVisit: "Or visit",
        // Footer
        ftEyebrow: "Stay close to home",
        ftHeadline: "Preserve your family's legacy.",
        ftJoinA: "Join",
        ftJoinB: "Indian families.",
        ftNewsDesc: "Heritage Stories, Culture Nuggets & Product New Updates & Features — Once in fortnight …",
        ftSubscribe: "Subscribe",
        ftJoining: "Joining…",
        ftDpdpNote: "DPDP-compliant · we never sell your data",
        ftBrandDesc: "A private, India-first space where families preserve their stories, record elders' voices, and pass on their legacy across generations.",
        colCompany: "Company",
        colFtServices: "FR Services",
        colAdminSupport: "Admin Support",
        colProduct: "Products / Services",
        colSupport: "Support and help",
        colLegal: "Legal",
        colTechnical: "Technical",
        colMethodology: "Compliance",
        badgeMii: "Made in India · Built in Mumbai",
        badgeDpdp: "DPDP Act 2023 Compliant",
        badgeIso: "ISO 27001 Certified",
        badgeSoc: "SOC 2 Certified",
        badgeEnc: "Bank-level encryption",
        wcu6T: "Health Repository",
        wcu6D: "Family medical history, conditions and blood groups in one place.",
        wcu7T: "Family Calendar & Reminders",
        wcu7D: "Birthdays, anniversaries, shraddha and festivals — nothing missed.",
        wcu8T: "Legal & Legacy Vault",
        wcu8D: "Wills, nominees and succession details, ready when needed.",
        wcu9T: "Traditions & Rituals",
        wcu9D: "How your family does things — written down before it is forgotten.",
        wcu10T: "Recipes & Family Food",
        wcu10D: "The dishes only your family makes, saved with the stories behind them.",
        wcu11T: "Places & Ancestral Village",
        wcu11D: "Your roots on a map — village, home and journeys across the world.",
        wcu12T: "Family Constitution & Values",
        wcu12D: "The principles your family lives by, agreed and recorded.",
        wcu13T: "Time Capsule",
        wcu13D: "Messages sealed today, opened on a date you choose.",
        wcu14T: "Family Achievements & Heroes",
        wcu14D: "Milestones, honours and the unsung heroes of your family.",
        wcu15T: "Biography & Memoir",
        wcu15D: "Full life stories, written with help from our expert writers.",
        wcu16T: "AI Family Tools",
        wcu16D: "Gentle AI help to write, restore photos and build documentaries.",
        wcuSub: "Sixteen everyday things your family needs — all in one private, secure home.",
    },
    hi: {
        heroFamiliesTrust: "भारतीय परिवारों का भरोसा",
        heroTitleA: "आपके परिवार का इतिहास",
        heroTitleB: "सुरक्षित",
        heroTitleC: "हमेशा के लिए।",
        heroSub: "अपना family tree बनाइए, बुज़ुर्गों की आवाज़ रिकॉर्ड कीजिए, फ़ोटो और दस्तावेज़ संजोइए — सब कुछ एक निजी जगह में, भारतीय परिवारों के लिए, आपकी अपनी भाषा में।",
        heroCtaStart: "Mobile OTP से free शुरू करें",
        heroCtaHow: "कैसे काम करता है देखें",
        trustPrivate: "पूरी तरह निजी",
        trustLangs: "10 भारतीय भाषाएँ",
        trustFree: "शुरुआत बिल्कुल free",
        fsdTitle: "Mobile OTP से Free शुरू करें",
        fsdSub: "1 मिनट में शुरू करें — बिल्कुल free.",
        fsdP1T: "100% Free शुरुआत",
        fsdP1D: "कोई credit card नहीं, कोई hidden charge नहीं। Free plan में family tree, photos और stories शामिल।",
        fsdP2T: "सिर्फ़ Mobile Number",
        fsdP2D: "अपना mobile number डालिए → OTP आएगा → login हो गया। कोई email या password याद रखने की ज़रूरत नहीं।",
        fsdP3T: "आपकी Privacy पहले",
        fsdP3D: "Private by default — आपका data सिर्फ़ आपका परिवार देख सकता है।",
        fsdContinue: "आगे बढ़ें — Free शुरू करें",
        fsdLater: "बाद में",
        dbTitle: "Product Demos और Reels",
        dbSub: "छोटे videos में देखिए — family tree, memories, vault और culture features कैसे काम करते हैं।",
        dbBtn: "Demos देखें",
        dpHeading: "Demos, Reels और Documentaries",
        dpSub: "हर product और service का demonstration — full family tree से लेकर legacy vault तक।",
        dpFeaturedTag: "मुख्य Demo",
        dpAll: "सभी",
        dpComingSoon: "Video जल्द आ रहा है",
        navHome: "होम",
        navAbout: "हमारे बारे में",
        navProducts: "उत्पाद और सेवाएँ",
        navHowItWorks: "कैसे काम करता है",
        navFeatures: "विशेषताएँ",
        navSolutions: "समाधान",
        navHelp: "सहायता",
        navPackage: "पैकेज",
        navResources: "संसाधन",
        navPricing: "मूल्य",
        navDemos: "डेमो",
        accMenuLabel: "वरिष्ठ मोड",
        accSenior: "सीनियर मोड",
        accSeniorDesc: "बुज़ुर्गों के लिए बड़ा टेक्स्ट और बटन",
        accTextSize: "टेक्स्ट आकार",
        howEyebrow: "कैसे काम करता है",
        howHeading: "परिवार वृक्ष बनाने के 5 आसान चरण",
        how1T: "परिवार प्रमुख के रूप में लॉगिन करें",
        how1D: "अपने credentials से login कीजिए और परिवार की विरासत की कमान संभालिए।",
        how2T: "परिवार के सदस्य जोड़ें",
        how2D: "माता-पिता, दादा-दादी, बच्चे और जीवनसाथी जोड़कर पूरा family tree बनाइए।",
        how3T: "यादें और कहानियाँ upload करें",
        how3D: "Text, photos और audio — हर याद को मिलता है एक सुरक्षित घर।",
        how4T: "परिवार के साथ share करें",
        how4D: "अपनों को invite कीजिए ताकि पूरा परिवार यादें देखे, जिए और जोड़े।",
        how5T: "अगली पीढ़ी मिलकर विरासत को आगे बढ़ाए",
        how5D: "आपके बच्चे और पोते-पोतियाँ यह परंपरा जारी रखेंगे — विरासत कभी नहीं रुकेगी।",
        wcuEyebrow: "परिवार हमें क्यों चुनते हैं",
        wcuHeading: "आपके परिवार की हर अनमोल चीज़ का एक ही घर",
        wcu1T: "वंश-वृक्ष",
        wcu1D: "छह पीढ़ियाँ, हर शाखा — एक ऐसे वृक्ष में दर्ज जिसे हर कोई समझ सके।",
        wcu2T: "फ़ोटो और यादें",
        wcu2D: "तस्वीरें, नोट्स और पल — सुरक्षित रखे हुए और आसानी से ढूँढने लायक।",
        wcu3T: "आवाज़ और ऑडियो कहानियाँ",
        wcu3D: "बज़ुर्गों की बातें उनकी अपनी आवाज़ और अपनी भाषा में रिकॉर्ड करें।",
        wcu4T: "वीडियो विरासत",
        wcu4D: "वीडियो संदेश और वसीयतें, आने वाली पीढ़ियों के लिए संभालकर रखी जाएँ।",
        wcu5T: "दस्तावेज़ तिजोरी",
        wcu5D: "सर्टिफ़िकेट, कागज़ात और दस्तावेज़ — व्यवस्थित और एन्क्रिप्टेड रूप में।",
        wcuCtaT: "आज ही अपने परिवार की विरासत शुरू करें",
        wcuCtaD: "शुरुआत free है — सिर्फ़ mobile number चाहिए। आपके पोते-पोतियाँ आपको धन्यवाद देंगे।",
        wcuCtaBtn: "Free शुरू करें",
        jfEyebrow: "आपका सफ़र",
        jfHeading: "आज से हमेशा तक — तीन आसान कदम",
        jfSub: "ज़्यादातर परिवार पहला कदम दो मिनट से भी कम में पूरा कर लेते हैं। सफ़र ज़िंदगी भर चल सकता है।",
        jf1T: "अपना परिवार जोड़ें",
        jf1D: "60 सेकंड में mobile OTP signup. माता-पिता, जीवनसाथी, बच्चे एक-एक करके जोड़िए — typing धीमी लगे तो हिंदी/मराठी में बोलकर नाम डालिए।",
        jf1B1: "कभी कोई password नहीं",
        jf1B2: "10 भारतीय भाषाओं में voice input",
        jf1B3: "रिश्ते अपने आप भरते हैं",
        jf2T: "कहानियाँ और photos संजोइए",
        jf2D: "दादी की कहानियाँ रिकॉर्ड कीजिए, शादी और त्योहारों की photos डालिए, albums में सजाइए। AI आपकी भाषा में आवाज़ को text बनाता है।",
        jf2B1: "ऑडियो + फ़ोटो + दस्तावेज़",
        jf2B2: "अपने tree के लोगों को tag करें",
        jf2B3: "Whisper ट्रांसक्रिप्शन",
        jf3T: "हमेशा के लिए सुरक्षित, समझदारी से share",
        jf3D: "भारतीय servers पर encrypted storage. Audio के साथ वसीयत draft कीजिए। पोते-पोतियों के लिए time-capsule schedule कीजिए। DPDP-compliant by design.",
        jf3B1: "AES-256 एन्क्रिप्शन",
        jf3B2: "Biometric-locked vaults",
        jf3B3: "हमेशा आपके परिवार में ही रहता है",
        jfCta: "अभी पहला कदम उठाएँ",
        jfNote: "पहले 25 सदस्यों के लिए हमेशा free. ज़रूरत बढ़े तभी upgrade करें।",
        featEyebrow: "ख़ूबियाँ",
        featHeading: "साथ मिलकर याद रखने के लिए परिवार को जो कुछ चाहिए — सब यहाँ",
        wwhEyebrow: "एक चेतावनी भरी कहानी",
        wwhTitleA: "क्या होगा",
        wwhTitleB: "अगर हमने अपनी कहानी नहीं संजोई?",
        wwhHintDesktop: "हर 3 सेकंड में अपने आप बदलता है · रोकने के लिए hover करें · swipe, ← → या dots से देखें।",
        wwhHintMobile: "अपने आप चलता है · swipe करके देखें।",
        ppHeading: "अगर परिवार का इतिहास संजोया न जाए तो क्या होता है?",
        pp1: "बुज़ुर्गों की यादें हमेशा के लिए खो जाती हैं",
        pp2: "पुरानी photos खो जाती हैं या ख़राब हो जाती हैं",
        pp3: "बच्चे अपनी जड़ों से दूर हो जाते हैं",
        pp4: "परंपराएँ हर पीढ़ी के साथ धुंधली पड़ती हैं",
        tEyebrow: "प्रशंसापत्र",
        tHeadA: "पूरे ",
        tIndia: "भारत",
        tHeadB: " के परिवार हम पर भरोसा करते हैं",
        tSub: "असली परिवार, असली कहानियाँ — हमेशा के लिए सुरक्षित।",
        faqHeading: "अक्सर पूछे जाने वाले सवाल",
        faq1Q: "क्या हमारे परिवार का data सुरक्षित है?",
        faq1A: "हाँ। Bank-स्तरीय AES-256 encryption, httpOnly cookie auth, Document और Legal Vault पर optional fingerprint/Face ID lock, और भारत में स्थित MongoDB storage.",
        faq2Q: "क्या NRI परिवार इसे use कर सकते हैं?",
        faq2A: "बिल्कुल। Multi-timezone support, 10 भारतीय भाषाओं में browser language auto-detection, और Family World Map widget जो दिखाता है कि हर रिश्तेदार कहाँ रहता है।",
        faq3Q: "क्या senior citizens के लिए आसान है?",
        faq3A: "हाँ। Senior Mode में सिर्फ़ 3 बड़े buttons दिखते हैं (Photos / Story / Family)। 22px font, बड़े tap targets, voice-recording सबसे पहले।",
        faq4Q: "क्या हम 100+ सदस्य जोड़ सकते हैं?",
        faq4A: "Free plan में 25 सदस्य; Family ₹999/वर्ष में unlimited सदस्य + 10 GB storage; Legacy ₹2999/वर्ष में Legal Vault, 100 GB, printed tree और priority support.",
        faq5Q: "कौन-कौन सी भाषाएँ supported हैं?",
        faq5A: "English, हिंदी, मराठी, तमिल, तेलुगु, कन्नड़, मलयालम, बांग्ला, गुजराती और पंजाबी — पूरी UI translation, पहली visit पर browser की भाषा अपने आप detect होती है।",
        faq6Q: "क्या हम अपना data export कर सकते हैं?",
        faq6A: "हाँ। Settings → My Data → Download All My Data से आपका tree, memories, stories और documents एक archive में export होते हैं (DPDP-compliant)।",
        faq7Q: "Free trial के बाद क्या होता है?",
        faq7A: "कोई trial नहीं है — Free plan हमेशा के लिए है। सिर्फ़ तभी upgrade करें जब 25+ सदस्य, AI biography या Legal Vault चाहिए। Annual plans पर 7-दिन grace period और पूरी money-back guarantee.",
        faq8Q: "क्या कई सदस्य मिलकर contribute कर सकते हैं?",
        faq8A: "हाँ। भाई-बहन, माता-पिता और cousins को mobile number से invite करें। हर किसी को role मिलती है: Family Head / Editor / Viewer — हर document पर बारीक privacy controls के साथ।",
        mscTitle: "मुफ़्त · मोबाइल OTP साइनअप",
        mscDpdp: "DPDP अनुरूप",
        mscStart: "Free शुरू करें",
        qrEyebrow: "अपना परिवार साथ ले चलिए",
        qrHeading: "एक बार scan कीजिए। Family Repository आपके phone पर।",
        qrSub: "App install करने के लिए camera को QR code पर रखिए। Android और iPhone दोनों पर चलता है — सही store हम खुद detect कर लेते हैं।",
        qrLi1: "Android और iPhone पर one-tap install",
        qrLi2: "iOS 14+ — App Store",
        qrLi3: "Android 8+ — Google Play",
        qrOrVisit: "या visit करें",
        ftEyebrow: "घर के क़रीब रहिए",
        ftHeadline: "अपने परिवार की विरासत संजोइए।",
        ftJoinA: "जुड़िए",
        ftJoinB: "भारतीय परिवारों के साथ।",
        ftNewsDesc: "विरासत की कहानियाँ, संस्कृति की बातें और product news — पखवाड़े में एक बार। Spam कभी नहीं।",
        ftSubscribe: "Subscribe करें",
        ftJoining: "जुड़ रहे हैं…",
        ftDpdpNote: "DPDP-compliant · हम आपका data कभी नहीं बेचते",
        ftBrandDesc: "एक निजी, India-first जगह जहाँ परिवार अपनी कहानियाँ संजोते हैं, बुज़ुर्गों की आवाज़ें रिकॉर्ड करते हैं, और पीढ़ी दर पीढ़ी अपनी विरासत आगे बढ़ाते हैं।",
        colCompany: "कंपनी",
        colFtServices: "पारिवारिक वृक्ष सेवाएँ",
        colAdminSupport: "प्रशासनिक सहायता",
        colProduct: "Products / सेवाएँ",
        colSupport: "सहायता और सहयोग",
        colLegal: "क़ानूनी",
        colTechnical: "तकनीकी",
        colMethodology: "कार्यप्रणाली / अनुपालन",
        badgeMii: "Made in India · Mumbai में निर्मित",
        badgeDpdp: "DPDP Act 2023 Compliant",
        badgeIso: "ISO 27001 Certified",
        badgeSoc: "SOC 2 Certified",
        badgeEnc: "Bank-स्तरीय encryption",
        wcu6T: "स्वास्थ्य भंडार",
        wcu6D: "परिवार का मेडिकल इतिहास, बीमारियाँ और ब्लड ग्रुप — सब एक ही जगह।",
        wcu7T: "परिवार कैलेंडर और रिमाइंडर",
        wcu7D: "जन्मदिन, सालगिरह, श्राद्ध और त्योहार — कुछ भी भूले बिना।",
        wcu8T: "कानूनी और विरासत तिजोरी",
        wcu8D: "वसीयतें, नामित व्यक्ति और उत्तराधिकार से जुड़ी जानकारी, ज़रूरत पड़ते ही तैयार।",
        wcu9T: "परंपराएँ और रीति-रिवाज़",
        wcu9D: "आपका परिवार चीज़ें जैसे करता है — भूलने से पहले लिखकर सुरक्षित रखें।",
        wcu10T: "रेसिपी और पारिवारिक खाने",
        wcu10D: "वे पकवान जो सिर्फ़ आपका परिवार बनाता है, उनके पीछे की कहानियों के साथ सहेजकर रखें।",
        wcu11T: "स्थान और पैतृक गाँव",
        wcu11D: "आपकी जड़ें नक्शे पर — गाँव, घर और दुनिया भर की आपकी यात्राएँ।",
        wcu12T: "परिवार संविधान और मूल्य",
        wcu12D: "वे सिद्धांत जिन पर आपका परिवार चलता है, मिलकर तय किए गए और दर्ज किए गए।",
        wcu13T: "टाइम कैप्सूल",
        wcu13D: "आज लिखे गए संदेश, आपकी चुनी हुई तारीख पर खोले जाएँगे।",
        wcu14T: "परिवार की उपलब्धियाँ और नायक",
        wcu14D: "मील के पत्थर, सम्मान और आपके परिवार के अनसुने नायक।",
        wcu15T: "जीवनी और संस्मरण",
        wcu15D: "पूरी जीवन-कथाएँ, हमारे विशेषज्ञ लेखकों की मदद से लिखी गईं।",
        wcu16T: "AI परिवार टूल्स",
        wcu16D: "लेखन, फोटो सुधारने और डॉक्युमेंट्री बनाने में आपकी मदद करने वाला सहज AI सहायक।",
        wcuSub: "आपके परिवार की रोज़मर्रा की सोलह ज़रूरतें — सब एक ही निजी और सुरक्षित घर में।",
    },
    mr: {
        heroFamiliesTrust: "भारतीय कुटुंबांचा विश्वास",
        heroTitleA: "तुमच्या कुटुंबाचा इतिहास",
        heroTitleB: "जपलेला",
        heroTitleC: "कायमचा.",
        heroSub: "तुमचा family tree तयार करा, ज्येष्ठांचे आवाज रेकॉर्ड करा, फोटो आणि कागदपत्रे जपून ठेवा — सर्व काही एका खासगी जागेत, भारतीय कुटुंबांसाठी, तुमच्याच भाषेत.",
        heroCtaStart: "Mobile OTP ने free सुरुवात करा",
        heroCtaHow: "कसे काम करते ते पहा",
        trustPrivate: "पूर्णपणे खासगी",
        trustLangs: "10 भारतीय भाषा",
        trustFree: "सुरुवात पूर्ण free",
        fsdTitle: "Mobile OTP ने Free सुरुवात करा",
        fsdSub: "1 मिनिटात सुरुवात — पूर्णपणे free.",
        fsdP1T: "100% Free सुरुवात",
        fsdP1D: "कोणतेही credit card नाही, कोणतेही hidden charge नाहीत. Free plan मध्ये family tree, photos आणि stories समाविष्ट.",
        fsdP2T: "फक्त Mobile Number",
        fsdP2D: "तुमचा mobile number टाका → OTP येईल → login झाले. कोणताही email किंवा password लक्षात ठेवण्याची गरज नाही.",
        fsdP3T: "तुमची Privacy आधी",
        fsdP3D: "Private by default — तुमचा data फक्त तुमचे कुटुंबच पाहू शकते.",
        fsdContinue: "पुढे जा — Free सुरुवात करा",
        fsdLater: "नंतर",
        dbTitle: "Product Demos आणि Reels",
        dbSub: "छोट्या videos मध्ये पहा — family tree, memories, vault आणि culture features कसे काम करतात.",
        dbBtn: "Demos पहा",
        dpHeading: "Demos, Reels आणि Documentaries",
        dpSub: "प्रत्येक product आणि service चे demonstration — full family tree पासून legacy vault पर्यंत.",
        dpFeaturedTag: "मुख्य Demo",
        dpAll: "सर्व",
        dpComingSoon: "Video लवकरच येत आहे",
        navHome: "होम",
        navAbout: "आमच्याविषयी",
        navProducts: "उत्पादने आणि सेवा",
        navHowItWorks: "कसे कार्य करते",
        navFeatures: "वैशिष्ट्ये",
        navSolutions: "उपाय",
        navHelp: "मदत",
        navPackage: "पॅकेज",
        navResources: "संसाधने",
        navPricing: "किंमत",
        navDemos: "डेमो",
        accMenuLabel: "ज्येष्ठ मोड",
        accSenior: "सीनियर मोड",
        accSeniorDesc: "ज्येष्ठांसाठी मोठा मजकूर आणि मोठी बटणे",
        accTextSize: "मजकूर आकार",
        howEyebrow: "कसे काम करते",
        howHeading: "कौटुंबिक वंशावळीचे झाड तयार करण्याची सोपी ५ पावले",
        how1T: "कुटुंबप्रमुख म्हणून लॉगिन करा",
        how1D: "तुमच्या credentials ने login करा आणि कुटुंबाच्या वारशाची सूत्रे हाती घ्या.",
        how2T: "कुटुंबातील सदस्य जोडा",
        how2D: "आई-वडील, आजी-आजोबा, मुले आणि जोडीदार जोडून संपूर्ण family tree तयार करा.",
        how3T: "आठवणी आणि गोष्टी upload करा",
        how3D: "Text, photos आणि audio — प्रत्येक आठवणीला मिळते एक सुरक्षित घर.",
        how4T: "कुटुंबासोबत share करा",
        how4D: "आपल्या माणसांना invite करा म्हणजे संपूर्ण कुटुंब आठवणी पाहील, जगेल आणि जोडेल.",
        how5T: "पुढील पिढी परंपरा पुढे नेत राहील",
        how5D: "तुमची मुले आणि नातवंडे ही परंपरा पुढे नेतील — वारसा कधीही थांबणार नाही.",
        wcuEyebrow: "कुटुंबे आम्हाला का निवडतात",
        wcuHeading: "तुमच्या कुटुंबाच्या प्रत्येक मौल्यवान गोष्टीचे एकच घर",
        wcu1T: "कुलवृक्ष",
        wcu1D: "सहा पिढ्यांचा, प्रत्येक फांदीचा – असा वृक्ष, जो कुणालाही सहज समजेल.",
        wcu2T: "छायाचित्रे व आठवणी",
        wcu2D: "फोटो, नोंदी आणि आठवणी, सुरक्षितरीत्या साठवलेल्या आणि सहज सापडतील अशा.",
        wcu3T: "आवाज व ध्वनिकथा",
        wcu3D: "ज्येष्ठांचा आवाज त्यांच्या स्वतःच्या भाषेत, त्यांच्या स्वतःच्या शब्दांत रेकॉर्ड करा.",
        wcu4T: "व्हिडिओ वारसा",
        wcu4D: "पुढच्या पिढ्यांसाठी जपून ठेवलेले व्हिडिओ संदेश आणि वसीयतवजा नोंदी.",
        wcu5T: "दस्तऐवज तिजोरी",
        wcu5D: "प्रमाणपत्रे, कागदपत्रे व दस्तऐवज – नीट वर्गीकरण करून सुरक्षितपणे कूटबद्ध.",
        wcuCtaT: "आजच तुमच्या कुटुंबाचा वारसा सुरू करा",
        wcuCtaD: "सुरुवात free आहे — फक्त mobile number हवा. तुमची नातवंडे तुमचे आभार मानतील.",
        wcuCtaBtn: "Free सुरू करा",
        jfEyebrow: "तुमचा प्रवास",
        jfHeading: "आजपासून कायमपर्यंत — तीन सोप्या पायऱ्या",
        jfSub: "बहुतेक कुटुंबे पहिली पायरी दोन मिनिटांच्या आत पूर्ण करतात. प्रवास मात्र आयुष्यभराचा असू शकतो.",
        jf1T: "तुमचे कुटुंब जोडा",
        jf1D: "60 सेकंदात mobile OTP signup. आई-वडील, जोडीदार, मुले एक-एक करून जोडा — typing हळू वाटत असेल तर हिंदी/मराठीत बोलून नावे टाका.",
        jf1B1: "कधीही password नाही",
        jf1B2: "10 भारतीय भाषांमध्ये voice input",
        jf1B3: "नाती आपोआप भरली जातात",
        jf2T: "गोष्टी आणि photos जपा",
        jf2D: "आजीच्या गोष्टी रेकॉर्ड करा, लग्न आणि सणांचे photos टाका, albums मध्ये लावा. AI तुमच्या भाषेतील आवाजाचे text करते.",
        jf2B1: "ऑडिओ + फोटो + कागदपत्रे",
        jf2B2: "तुमच्या tree मधील लोकांना tag करा",
        jf2B3: "Whisper ट्रान्सक्रिप्शन",
        jf3T: "कायमचे जपा, सुरक्षितपणे share करा",
        jf3D: "भारतीय servers वर encrypted storage. Audio सह मृत्युपत्राचा draft करा. नातवंडांसाठी time-capsule schedule करा. DPDP-compliant by design.",
        jf3B1: "AES-256 एन्क्रिप्शन",
        jf3B2: "Biometric-locked vaults",
        jf3B3: "नेहमी तुमच्या कुटुंबातच राहते",
        jfCta: "आत्ताच पहिली पायरी घ्या",
        jfNote: "पहिल्या 25 सदस्यांसाठी कायम free. गरज वाढली तरच upgrade करा.",
        featEyebrow: "वैशिष्ट्ये",
        featHeading: "एकत्र आठवणी जपण्यासाठी कुटुंबाला जे जे हवे — ते सर्व येथे",
        wwhEyebrow: "एक सावधगिरीची गोष्ट",
        wwhTitleA: "काय होईल",
        wwhTitleB: "जर आपण आपली गोष्ट जपली नाही तर?",
        wwhHintDesktop: "दर 3 सेकंदांनी आपोआप बदलते · थांबवण्यासाठी hover करा · swipe, ← → किंवा dots ने पहा.",
        wwhHintMobile: "आपोआप चालते · swipe करून पहा.",
        ppHeading: "कुटुंबाचा इतिहास जपला नाही तर काय होते?",
        pp1: "ज्येष्ठांच्या आठवणी कायमच्या हरवतात",
        pp2: "जुने photos हरवतात किंवा खराब होतात",
        pp3: "मुले आपल्या मुळांपासून दुरावतात",
        pp4: "परंपरा प्रत्येक पिढीगणिक पुसट होतात",
        tEyebrow: "अभिप्राय",
        tHeadA: "संपूर्ण ",
        tIndia: "भारतातील",
        tHeadB: " कुटुंबांचा आमच्यावर विश्वास",
        tSub: "खरी कुटुंबे, खऱ्या गोष्टी — कायमच्या जपलेल्या.",
        faqHeading: "वारंवार विचारले जाणारे प्रश्न",
        faq1Q: "आमच्या कुटुंबाचा data सुरक्षित आहे का?",
        faq1A: "होय. Bank-दर्जाचे AES-256 encryption, httpOnly cookie auth, Document आणि Legal Vault वर optional fingerprint/Face ID lock, आणि भारतातच असलेले MongoDB storage.",
        faq2Q: "NRI कुटुंबे हे वापरू शकतात का?",
        faq2A: "नक्कीच. Multi-timezone support, 10 भारतीय भाषांमध्ये browser language auto-detection, आणि प्रत्येक नातेवाईक कुठे राहतो हे दाखवणारा Family World Map widget.",
        faq3Q: "ज्येष्ठ नागरिकांसाठी सोपे आहे का?",
        faq3A: "होय. Senior Mode मध्ये फक्त 3 मोठी buttons दिसतात (Photos / Story / Family). 22px font, मोठे tap targets, voice-recording सर्वात आधी.",
        faq4Q: "आम्ही 100+ सदस्य जोडू शकतो का?",
        faq4A: "Free plan मध्ये 25 सदस्य; Family ₹999/वर्ष मध्ये unlimited सदस्य + 10 GB storage; Legacy ₹2999/वर्ष मध्ये Legal Vault, 100 GB, printed tree आणि priority support.",
        faq5Q: "कोणत्या भाषा supported आहेत?",
        faq5A: "English, हिंदी, मराठी, तमिळ, तेलुगू, कन्नड, मल्याळम, बंगाली, गुजराती आणि पंजाबी — संपूर्ण UI translation, पहिल्या भेटीत browser ची भाषा आपोआप detect होते.",
        faq6Q: "आम्ही आमचा data export करू शकतो का?",
        faq6A: "होय. Settings → My Data → Download All My Data मधून तुमचा tree, memories, stories आणि documents एका archive मध्ये export होतात (DPDP-compliant).",
        faq7Q: "Free trial नंतर काय होते?",
        faq7A: "Trial नाहीच — Free plan कायमचा आहे. 25+ सदस्य, AI biography किंवा Legal Vault हवे असेल तेव्हाच upgrade करा. Annual plans वर 7-दिवस grace period आणि संपूर्ण money-back guarantee.",
        faq8Q: "अनेक सदस्य मिळून contribute करू शकतात का?",
        faq8A: "होय. भावंडे, आई-वडील आणि cousins ना mobile number ने invite करा. प्रत्येकाला role मिळते: Family Head / Editor / Viewer — प्रत्येक document वर बारीक privacy controls सह.",
        mscTitle: "मोफत · मोबाइल OTP साइनअप",
        mscDpdp: "DPDP अनुरूप",
        mscStart: "Free सुरुवात",
        qrEyebrow: "तुमचे कुटुंब सोबत न्या",
        qrHeading: "एकदाच scan करा. Family Repository तुमच्या phone वर.",
        qrSub: "App install करण्यासाठी camera QR code वर धरा. Android आणि iPhone दोन्हींवर चालते — योग्य store आम्हीच detect करतो.",
        qrLi1: "Android आणि iPhone वर one-tap install",
        qrLi2: "iOS 14+ — App Store",
        qrLi3: "Android 8+ — Google Play",
        qrOrVisit: "किंवा भेट द्या",
        ftEyebrow: "घराच्या जवळ राहा",
        ftHeadline: "तुमच्या कुटुंबाचा वारसा जपा.",
        ftJoinA: "सामील व्हा",
        ftJoinB: "भारतीय कुटुंबांसोबत.",
        ftNewsDesc: "वारशाच्या गोष्टी, संस्कृतीच्या गप्पा आणि product news — पंधरवड्यातून एकदा. Spam कधीही नाही.",
        ftSubscribe: "Subscribe करा",
        ftJoining: "जोडत आहोत…",
        ftDpdpNote: "DPDP-compliant · आम्ही तुमचा data कधीही विकत नाही",
        ftBrandDesc: "एक खासगी, India-first जागा जिथे कुटुंबे आपल्या गोष्टी जपतात, ज्येष्ठांचे आवाज रेकॉर्ड करतात, आणि पिढ्यानपिढ्या आपला वारसा पुढे नेतात.",
        colCompany: "कंपनी",
        colFtServices: "वंशावळ सेवा",
        colAdminSupport: "प्रशासनिक सहाय्य",
        colProduct: "Products / सेवा",
        colSupport: "सपोर्ट आणि मदत",
        colLegal: "कायदेशीर",
        colTechnical: "तांत्रिक",
        colMethodology: "कार्यपद्धती / अनुपालन",
        badgeMii: "Made in India · Mumbai मध्ये निर्मित",
        badgeDpdp: "DPDP Act 2023 Compliant",
        badgeIso: "ISO 27001 Certified",
        badgeSoc: "SOC 2 Certified",
        badgeEnc: "Bank-दर्जाचे encryption",
        wcu6T: "आरोग्य संग्राहक",
        wcu6D: "कुटुंबाचा वैद्यकीय इतिहास, आजारपणाची माहिती व रक्तगट – सर्व एकाच ठिकाणी.",
        wcu7T: "कुटुंब दिनदर्शिका व स्मरणपत्रे",
        wcu7D: "वाढदिवस, लग्नदिन, श्राद्ध आणि सणवार – काहीही विसरले जाणार नाही.",
        wcu8T: "कायदेशीर व वारसा तिजोरी",
        wcu8D: "वसीयतपत्रे, नॉमिनी आणि वारसाहक्काची माहिती – गरज भासेल तेव्हा तयार.",
        wcu9T: "परंपरा व विधी",
        wcu9D: "आपल्या कुटुंबातील रितीरिवाज – विसरले जाण्यापूर्वी नीट लिहून ठेवलेले.",
        wcu10T: "पाककृती व कुटुंबीय पदार्थ",
        wcu10D: "फक्त तुमच्या कुटुंबात बनणारे खास पदार्थ, त्यांच्या मागच्या कथा जपून नोंदवलेल्या.",
        wcu11T: "ठिकाणे आणि पिढीजात गाव",
        wcu11D: "तुमच्या मुळांचा नकाशा — गाव, घर आणि जगभरच्या प्रवासांची नोंद.",
        wcu12T: "कौटुंबिक घटनेचा धागा आणि मूल्ये",
        wcu12D: "तुमच्या कुटुंबाचे जगण्याचे तत्त्व — परस्पर संमतीने ठरवलेले आणि लिहून ठेवलेले.",
        wcu13T: "टाइम कॅप्सूल",
        wcu13D: "आज लिहिलेले संदेश, तुमच्या पसंतीच्या दिवशी उघडण्यासाठी जतन केलेले.",
        wcu14T: "कौटुंबिक कर्तृत्व आणि वीर",
        wcu14D: "मोलाचे टप्पे, सन्मान आणि कुटुंबातील अव्यक्त राहिलेले हिरो.",
        wcu15T: "चरित्र आणि आठवणींचा लेखाजोखा",
        wcu15D: "पूर्ण आयुष्यकथा, आमच्या तज्ज्ञ लेखकांच्या मदतीने लिहिलेल्या.",
        wcu16T: "AI कुटुंब साधने",
        wcu16D: "हलकी, सुलभ AI मदत — लिहिण्यास, फोटो दुरुस्त करण्यास आणि माहितीपट तयार करण्यास.",
        wcuSub: "दररोज लागणाऱ्या सोळा कौटुंबिक गोष्टी — सगळे एका खासगी, सुरक्षित घरात.",
    },
    ta: {
        heroFamiliesTrust: "இந்திய குடும்பங்கள் எங்களை நம்புகின்றனர்",
        heroTitleA: "உங்கள் குடும்பத்தின் வரலாறு",
        heroTitleB: "பாதுகாப்பாக",
        heroTitleC: "என்றென்றும்.",
        heroSub: "உங்கள் குடும்ப மரத்தை உருவாக்குங்கள், உங்கள் மூத்தவர்களின் குரல்களை பதிவு செய்யுங்கள், புகைப்படங்கள் மற்றும் ஆவணங்களை பாதுகாக்குங்கள் — இந்திய குடும்பங்களுக்கு, உங்கள் சொந்த மொழியிலேயே உருவாக்கப்பட்ட ஒரு தனியார் இடத்தில் இவை அனைத்தையும் ஒரே இடத்தில் செய்யலாம்.",
        heroCtaStart: "மொபைல் OTP மூலம் இலவசமாக தொடங்குங்கள்",
        heroCtaHow: "இது எப்படி வேலை செய்கிறது என்று பாருங்கள்",
        trustPrivate: "இயல்பாகவே தனியார்",
        trustLangs: "10 இந்திய மொழிகள்",
        trustFree: "தொடங்குவது இலவசம்",
        fsdTitle: "மொபைல் OTP மூலம் இலவசமாக தொடங்குங்கள்",
        fsdSub: "1 நிமிடத்தில் துவங்கி விடுங்கள் — முழுவதும் இலவசம்.",
        fsdP1T: "100% இலவச தொடக்கம்",
        fsdP1D: "கிரெடிட் கார்டு தேவையில்லை, மறைமுக கட்டணங்கள் இல்லை. குடும்ப மரம், புகைப்படங்கள், கதைகள் — இவை அனைத்தும் Free plan-இல் சேர்க்கப்பட்டுள்ளன.",
        fsdP2T: "உங்கள் மொபைல் எண் மட்டும்",
        fsdP2D: "உங்கள் மொபைல் எண்ணை உள்ளிடுங்கள் → OTP பெறுங்கள் → உடனே உள்ளே செல்லலாம். நினைவில் வைத்துக்கொள்ள வேண்டிய email அல்லது password எதுவும் இல்லை.",
        fsdP3T: "உங்கள் தனியுரிமை முந்தினது",
        fsdP3D: "இயல்பாகவே தனியார் — உங்கள் தகவலை உங்கள் குடும்பத்தார் மட்டுமே பார்க்க முடியும்.",
        fsdContinue: "தொடரவும் — இலவசமாக தொடங்குங்கள்",
        fsdLater: "பின்னர் பார்க்கலாம்",
        dbTitle: "தயாரிப்பு டெமோக்களும் ரீல்களும்",
        dbSub: "முழு குடும்ப மரம், நினைவுகள், வால்ட் மற்றும் கலாச்சாரம் போன்ற அம்சங்கள் எப்படி செயல்படுகின்றன என்பதை சுருக்கமான வீடியோக்களில் பாருங்கள்.",
        dbBtn: "டெமோ பார்க்க",
        dpHeading: "டெமோக்கள், ரீல்களும் ஆவணப்படங்களும்",
        dpSub: "முழு குடும்ப மரம் அமைப்பதிலிருந்து மரபு வால்ட் வரை — ஒவ்வொரு தயாரிப்பும் சேவையும் விளக்கமாக காட்டப்படுகிறது.",
        dpFeaturedTag: "சிறப்பு டெமோ",
        dpAll: "அனைத்து",
        dpComingSoon: "வீடியோ விரைவில் வருகிறது",
        navHome: "முகப்பு",
        navAbout: "எங்களைப் பற்றி",
        navProducts: "தயாரிப்புகள் மற்றும் சேவைகள்",
        navHowItWorks: "இது எப்படி செயல்படுகிறது",
        navFeatures: "அம்சங்கள்",
        navSolutions: "தீர்வுகள்",
        navHelp: "உதவி",
        navPackage: "பேக்கேஜ்",
        navResources: "வளங்கள்",
        navPricing: "விலை நிரல்",
        navDemos: "டெமோக்கள்",
        accMenuLabel: "மூத்தோர் முறையில்",
        accSenior: "மூத்தோர் பயன்முறை",
        accSeniorDesc: "மூத்தவர்களுக்கு பெரிய எழுத்து & பொத்தான்கள்",
        accTextSize: "எழுத்து அளவு",
        howEyebrow: "இது எப்படி செயல்படுகிறது",
        howHeading: "குடும்ப மரத்தை உருவாக்க 5 எளிய படிகள்",
        how1T: "குடும்பத் தலைவராக உள்நுழைக",
        how1D: "குடும்பத் தலைவராக உங்கள் கணக்கில் உள்நுழைந்து, உங்கள் குடும்பத்தின் பாரம்பரியத்தை நீங்கள் பொறுப்பேற்கவும்.",
        how2T: "குடும்ப உறுப்பினரைச் சேர்க்கவும்",
        how2D: "தந்தை, தாய், பாட்டி-தாத்தா, குழந்தைகள் மற்றும் வாழ்க்கைத் துணைகளை சேர்த்து உங்கள் முழு குடும்ப மரத்தை உருவாக்கவும்.",
        how3T: "நினைவுகள் & கதைகளை பதிவேற்றவும்",
        how3D: "உரை, படங்கள் மற்றும் ஒலிகளை பாதுகாக்கவும் — ஒவ்வொரு நினைவும் பாதுகாப்பான இடம் பெறும்.",
        how4T: "குடும்பத்துடன் பகிர்ந்து கொள்ளவும்",
        how4D: "உறவினர்களை அழைத்து, முழு குடும்பமும் ஒன்றாகக் கண்டு, மீண்டும் அனுபவித்து, இந்தச் சேகரிப்பில் மேலும் சேர்க்கலாம்.",
        how5T: "அடுத்த தலைமுறை வழித்தோழியைத் தொடர்ந்து கொண்டு செல்கிறது",
        how5D: "உங்கள் குழந்தைகளும் பேரக்குழந்தைகளும் இந்த மரபைத் தொடர்ந்து கொண்டுசெல்லுவர் — பாரம்பரியம் ஒருபோதும் நிற்காது.",
        wcuEyebrow: "குடும்பங்கள் எங்களை ஏன் தேர்வு செய்கிறார்கள்",
        wcuHeading: "உங்கள் குடும்பம் நேசிக்கும் அனைத்திற்கும் ஒரு வீட்டே போதும்",
        wcu1T: "குடும்ப மரம்",
        wcu1D: "ஆறு தலைமுறைகளும், ஒவ்வொரு கிளையும் — யாரும் எளிதில் படிக்க கூடிய மர வடிவில் வரைபடமாக.",
        wcu2T: "புகைப்படங்கள் & நினைவுகள்",
        wcu2D: "புகைப்படங்கள், குறிப்புகள் மற்றும் நினைவுப் தருணங்கள் — பாதுகாப்பாக சேமிக்கப்பட்டு, எளிதில் கண்டுபிடிக்க.",
        wcu3T: "குரல் & ஒலி கதைகள்",
        wcu3D: "மூத்தவர்களை அவர்களுடைய சொந்த குரலிலும், அவர்களுடைய சொந்த மொழியிலும் பதிவு செய்யுங்கள்.",
        wcu4T: "காணொளி மரபு",
        wcu4D: "வருங்கால தலைமுறைக்காக பாதுகாக்கப்பட்ட காணொளி செய்திகள் மற்றும் கடைசி சாசனங்கள்.",
        wcu5T: "ஆவணக் களஞ்சியம்",
        wcu5D: "சான்றிதழ்கள், பட்டா-பத்திரங்கள் மற்றும் ஆவணங்கள் — ஒழுங்குபடுத்தப்பட்டும் குறியாக்கத்துடன் பாதுகாப்பாகவும்.",
        wcuCtaT: "இன்றே உங்கள் குடும்பத்தின் மரபை தொடங்குங்கள்",
        wcuCtaD: "தொடங்குவது இலவசம் — உங்கள் மொபைல் எண் மட்டும் போதும். உங்கள் பேரக்குழந்தைகள் இதற்குப் நன்றி கூறுவார்கள்.",
        wcuCtaBtn: "இலவசமாக தொடங்குங்கள்",
        jfEyebrow: "உங்கள் பயணம்",
        jfHeading: "இன்றிலிருந்து என்றைக்கும் மூன்று எளிய படிகள்",
        jfSub: "பெரும்பாலான குடும்பங்கள் முதல் படியை இரண்டு நிமிடங்களுக்கு குறைவாகவே முடித்து விடுகிறார்கள். ஆனால் பயணம் ஒரு ஆயுள் முழுவதும் நீடிக்கலாம்.",
        jf1T: "உங்கள் குடும்பத்தைச் சேர்க்கவும்",
        jf1D: "60 விநாடிகளில் மொபைல் OTP மூலம் சேருங்கள். பெற்றோர், வாழ்க்கைத்துணை, குழந்தைகள் என்று ஒருவருக்கொருவர் சேர்க்கவும் — டைப் செய்ய சிரமமாக இருந்தால், அவர்களது பெயர்களை இந்தி/மராத்தியில் சொல்லலாம்.",
        jf1B1: "எந்த கடவுச்சொல்லும் தேவையில்லை",
        jf1B2: "இந்தியாவின் 10 மொழிகளில் குரல் உள்ளீடு",
        jf1B3: "உறவுகளை தானாக நிரப்பும்",
        jf2T: "கதைகள் மற்றும் புகைப்படங்களை பதிவு செய்யுங்கள்",
        jf2D: "உங்கள் பாட்டியின் கதைகளை பதிவு செய்யுங்கள், திருமணம் மற்றும் திருவிழா புகைப்படங்களை பதிவேற்றுங்கள், ஆல்பங்களாக ஒழுங்குபடுத்துங்கள். AI உங்கள் மொழியிலேயே குரல் பதிவுகளை எழுத்தாக மாற்றும்.",
        jf2B1: "குரல் + புகைப்படங்கள் + ஆவணங்கள்",
        jf2B2: "உங்கள் மரக் குடும்பத்திலிருந்து நபர்களை டேக் செய்யுங்கள்",
        jf2B3: "Whisper எழுத்து மாற்றம்",
        jf3T: "என்றைக்கும் பாதுகாக்கவும், பாதுகாப்பாக பகிரவும்",
        jf3D: "என்க்ரிப்ட் செய்யப்பட்ட இந்திய சர்வர் சேமிப்பு. ஆடியோ மூலம் உயில் (வசீயத்) வரைவு உருவாக்கலாம். பேரக்குழந்தைகளுக்காக காலக் காப்ஸ்யூல்களைத் திட்டமிடலாம். வடிவமைப்பிலேயே DPDP இணக்கம்.",
        jf3B1: "AES-256 குறியீட்டமிடல்",
        jf3B2: "உடல்ரீதி அடையாளத்தால் பாதுகாக்கப்பட்ட பாதுகாப்புக் களஞ்சியங்கள்",
        jf3B3: "எப்போதும் உங்கள் குடும்பத்திலேயே மிஞ்சுகிறது",
        jfCta: "உடனே படி 1 ஐ தொடங்குங்கள்",
        jfNote: "முதல் 25 குடும்ப உறுப்பினர்களுக்கு எப்போதும் இலவசம். அது போதாமல் போகும்போது மட்டும் மேம்படுத்துங்கள்.",
        featEyebrow: "வசதிகள்",
        featHeading: "குடும்பம் ஒன்றாக நினைவில் வைத்துக்கொள்ள வேண்டிய எல்லாவற்றையும் உள்ளடக்குகிறது",
        wwhEyebrow: "ஒரு எச்சரிக்கைக் கதை",
        wwhTitleA: "என்ன நடக்கும்",
        wwhTitleB: "நாம் நம்முடைய கதையைக் காப்பாற்றாமல் விட்டால்?",
        wwhHintDesktop: "3 வினாடிக்கு ஒருமுறை தானாக இயங்கும் · நிறுத்த hover செய்யவும் · swipe, ← → அல்லது புள்ளிகளை அழுத்தி உலாவவும்.",
        wwhHintMobile: "தானாக இயங்கும் · swipe செய்து உலாவவும்.",
        ppHeading: "குடும்ப வரலாறு பாதுகாக்கப்படாவிட்டால் என்ன நடக்கும்?",
        pp1: "மூத்தோரின் நினைவுகள் என்றும் மறைந்து விடும்",
        pp2: "பழைய புகைப்படங்கள் தொலைந்து போகும் அல்லது சேதமடையும்",
        pp3: "குழந்தைகள் தங்கள் வேர்களோடு உள்ள தொடர்பை இழந்து விடுவர்",
        pp4: "ஒவ்வொரு தலைமுறையிலும் வழக்கங்கள் மங்கித் தொலைந்து விடும்",
        tEyebrow: "சான்றுகள்",
        tHeadA: "இந்தியா முழுவதும் உள்ள குடும்பங்கள்",
        tIndia: "இந்தியா",
        tHeadB: "எங்களை நம்புங்கள்",
        tSub: "உண்மையான குடும்பங்கள், உண்மையான வாழ்க்கைக் கதைகள் – என்றென்றும் பாதுகாப்பாக.",
        faqHeading: "அடிக்கடி கேட்கப்படும் கேள்விகள்",
        faq1Q: "எங்கள் குடும்பத் தகவல்கள் பாதுகாப்பாக உள்ளதா?",
        faq1A: "ஆம். வங்கிப் பாதுகாப்பு நிலை AES-256 குறியாக்கம் (encryption) சேமிப்பில், httpOnly cookie அங்கீகாரம், Document & Legal Vault-க்கு விருப்பமான விரலடிப்பம் / Face ID பூட்டு, இந்தியாவில் இருக்கும் MongoDB சேமிப்பு.",
        faq2Q: "NRI குடும்பங்களும் இதைப் பயன்படுத்த முடியுமா?",
        faq2A: "நிச்சயமாக. பல நேரமண்டல (multi-timezone) ஆதரவு, 10 இந்திய மொழிகளில் உலாவி மொழியை தானாக கண்டறிதல், ஒவ்வொரு உறவினரும் எங்கே இருக்கிறார்கள் என்பதைக் காட்டும் Family World Map widget.",
        faq3Q: "மூத்த குடிமக்களுக்கு இது எளிதா?",
        faq3A: "ஆம். Senior Mode-ல் 3 பெரிய பொத்தான்கள் (Photos / Story / Family) மட்டும். 22px எழுத்து, பெரிய தொடுதல் பகுதிகள், முதலில் குரல் பதிவு வசதி.",
        faq4Q: "நாம் 100+ குடும்ப உறுப்பினர்களை சேர்க்க முடியுமா?",
        faq4A: "இலவச திட்டம் 25 உறுப்பினர்கள் வரை கவரும்; Family ₹999/வருடம் திட்டம் வரம்பற்ற உறுப்பினர்கள் + 10 GB சேமிப்பு; Legacy ₹2999/வருடம் திட்டம் Legal Vault, 100 GB, அச்சு குடும்ப மரம், மற்றும் முன்னுரிமை உதவியை சேர்க்கிறது.",
        faq5Q: "எந்தெந்த மொழிகள் ஆதரிக்கப்படுகின்றன?",
        faq5A: "English, Hindi, Marathi, Tamil, Telugu, Kannada, Malayalam, Bengali, Gujarati மற்றும் Punjabi — முழு UI மொழிபெயர்ப்பு, முதல் முறை வரும்போது உலாவி மொழி தானாக கண்டறியப்படும்.",
        faq6Q: "நாம் எங்கள் தரவுகளை வெளியேற்ற (export) முடியுமா?",
        faq6A: "ஆம். Settings → My Data → Download All My Data மூலம் உங்கள் மரம், நினைவுகள், கதைகள், ஆவணங்கள் அனைத்தையும் ஒரே archive-ஆக (DPDP-compliant) பதிவிறக்கம் செய்யலாம்.",
        faq7Q: "இலவச திட்டம் முடிந்த பிறகு என்ன ஆகும்?",
        faq7A: "இது ட்ரயல் அல்ல — இலவச திட்டம் நிரந்தரம். 25-க்கும் மேற்பட்ட உறுப்பினர்கள், AI biography அல்லது Legal Vault தேவையான போது மட்டும் மேம்படுத்தலாம். ஆண்டு திட்டங்களுக்கு 7 நாள் கூடுதல் அவகாசமும் முழு பணம் திரும்பக் கொடுக்கும் உத்தரவாதமும் உள்ளது.",
        faq8Q: "பல குடும்ப உறுப்பினர்கள் சேர்ந்து பதிவு செய்ய முடியுமா?",
        faq8A: "ஆம். சகோதரர்கள், பெற்றோர், சகோதரச்செல்வங்களை அவர்களுடைய மொபைல் எண்ணின் மூலம் அழைக்கலாம். ஒவ்வொருவருக்கும் Family Head / Editor / Viewer என்று ஒரு பங்கு கொடுக்கலாம் — ஒவ்வொரு ஆவணத்துக்கும் தனிப்பட்ட தனியுரிமை கட்டுப்பாடுகள் உண்டு.",
        mscTitle: "இலவசம் · மொபைல் OTP பதிவு",
        mscDpdp: "DPDP விதிகளுக்கு ஏற்ப",
        mscStart: "இலவசமாக தொடங்குங்கள்",
        qrEyebrow: "உங்கள் குடும்பத்தையும் உடன் எடுத்துச் செல்லுங்கள்",
        qrHeading: "ஒருமுறை ஸ்கேன் செய்யுங்கள். Family Repository உங்கள் தொலைபேசியில்.",
        qrSub: "ஆப்பை நிறுவ உங்கள் கேமராவை QR குறியீட்டின் மீது செலுத்துங்கள். Android, iPhone இரண்டிலும் வேலை செய்கிறது — நாங்கள் சரியான store-ஐ தானாக கண்டறிகிறோம்.",
        qrLi1: "Android & iPhone-ல் ஒரு-தட்டில் install",
        qrLi2: "iOS 14+ — App Store",
        qrLi3: "Android 8+ — Google Play",
        qrOrVisit: "அல்லது பாருங்கள்",
        ftEyebrow: "வீட்டுடன் நெருக்கமாக இருங்கள்",
        ftHeadline: "உங்கள் குடும்பத்தின் பாரம்பரியத்தை காக்குங்கள்.",
        ftJoinA: "சேரும்",
        ftJoinB: "இந்திய குடும்பங்கள்.",
        ftNewsDesc: "பாரம்பரியக் கதைகள், கலாச்சாரச் சுருக்கங்கள், மற்றும் தயாரிப்பு செய்திகள் — இரு வாரத்திற்கு ஒருமுறை. எப்போதும் spam இல்லை.",
        ftSubscribe: "Subscribe செய்யுங்கள்",
        ftJoining: "சேர்ந்து கொண்டிருக்கிறது…",
        ftDpdpNote: "DPDP-க்கு ஏற்ப · உங்கள் தரவை நாங்கள் ஒருபோதும் விற்பதில்லை",
        ftBrandDesc: "இந்தியக் குடும்பங்களுக்கு மட்டும், தனியுரிமை உள்ள ஓர் இடம் — இங்கு அனைவரும் தங்கள் கதைகளை பாதுகாத்து, மூத்தோரின் குரலை பதிவு செய்து, தங்கள் பாரம்பரியத்தை தலைமுறை தலைமுறையாக வழங்கிச் செல்கின்றனர்.",
        colCompany: "நிறுவனம்",
        colFtServices: "குடும்ப மர சேவைகள்",
        colAdminSupport: "நிர்வாகி ஆதரவு",
        colProduct: "தயாரிப்புகள் / சேவைகள்",
        colSupport: "ஆதரவு மற்றும் உதவி",
        colLegal: "சட்டம் சார்ந்தது",
        colTechnical: "தொழில்நுட்பம்",
        colMethodology: "முறை / இணக்கம்",
        badgeMii: "இந்தியாவில் உருவாக்கப்பட்டது · மும்பையில் கட்டப்பட்டது",
        badgeDpdp: "DPDP Act 2023 விதிகளுக்கு இணக்கம்",
        badgeIso: "ISO 27001 சான்றளிக்கப்பட்டது",
        badgeSoc: "SOC 2 சான்றளிக்கப்பட்டது",
        badgeEnc: "வங்கி மட்ட பாதுகாப்பு குறியாக்கம்",
        wcu6T: "ஆரோக்கியத் தகவல் களஞ்சியம்",
        wcu6D: "குடும்ப மருத்துவ வரலாறு, உடல்நிலை தகவல்கள் மற்றும் இரத்தக் குழுக்கள் — அனைத்தும் ஒரே இடத்தில்.",
        wcu7T: "குடும்ப நாட்காட்டி & நினைவூட்டல்கள்",
        wcu7D: "பிறந்தநாள்கள், திருமண நாள்கள், ஸ்ராத்தம் மற்றும் திருவிழாக்கள் — எதுவும் மறக்காமல்.",
        wcu8T: "சட்ட & மரபுக் களஞ்சியம்",
        wcu8D: "உத்தரவுகள், நியமனக்காரர்கள் மற்றும் வாரிசு தகவல்கள் — தேவையான நேரத்தில் தயார் நிலையில்.",
        wcu9T: "சம்பிரதாயங்கள் & சடங்குகள்",
        wcu9D: "உங்கள் குடும்பம் எப்படிப் பழக்க வழக்கங்களை நடத்துகிறது — மறந்து போகும் முன் எழுதிப் பாதுகாக்க.",
        wcu10T: "சமையல் குறிப்புகள் & குடும்ப உணவு",
        wcu10D: "உங்கள் குடும்பம் மட்டுமே செய்யும் அந்த சிறப்பு உணவுகள் — அதற்குப் பின்னுள்ள கதைகளுடன் சேர்த்து சேமிக்கப்படுகின்றன.",
        wcu11T: "இடங்கள் & மூதாதையர் ஊர்",
        wcu11D: "உங்கள் வேர் வரைபடத்தில் — ஊர், வீடு மற்றும் உலகம் முழுவதும் நடந்த பயணங்கள்.",
        wcu12T: "குடும்ப அரசியல் & மதிப்புகள்",
        wcu12D: "உங்கள் குடும்பம் வாழும் கொள்கைகள், எல்லோரும் ஒப்புக்கொண்டு பதிவுசெய்யப்பட்டவை.",
        wcu13T: "காலக் களஞ்சியம்",
        wcu13D: "இன்று எழுதிப் பூட்டிய செய்திகள், நீங்கள் தேர்ந்தெடுக்கும் நாளில் திறக்க.",
        wcu14T: "குடும்ப சாதனைகள் & முன்னோர்கள்",
        wcu14D: "சாதனைகள், பெருமைக்குரிய மரியாதைகள் மற்றும் உங்கள் குடும்பத்தின் சொல்லப்படாத வீரர்கள்.",
        wcu15T: "சுயசரிதை & நினைவுக் குறிப்புகள்",
        wcu15D: "உங்கள் முழு வாழ்க்கைக் கதைகள், எங்கள் நிபுணர் எழுத்தாளர்களின் உதவியுடன் எழுதப்பட்டவை.",
        wcu16T: "AI குடும்ப கருவிகள்",
        wcu16D: "எழுத, புகைப்படங்களை மீட்டெடுக்க, ஆவணப்படங்கள் உருவாக்க மென்மையான AI உதவி.",
        wcuSub: "உங்கள் குடும்பத்துக்கு தேவைப்படும் பதினாறு அன்றாட அம்சங்கள் — அனைத்தும் ஒரு தனிப்பட்ட, பாதுகாப்பான இல்லத்தில்.",
    },
    bn: {
        heroFamiliesTrust: "ভারতীয় পরিবারগুলো আমাদের ভরসা করে",
        heroTitleA: "আপনার পরিবারের ইতিহাস",
        heroTitleB: "সংরক্ষিত থাকবে",
        heroTitleC: "চিরদিনের জন্য।",
        heroSub: "আপনার পারিবারিক বংশবৃক্ষ তৈরি করুন, বয়োজ্যেষ্ঠদের কণ্ঠ রেকর্ড করুন, পুরোনো ছবি ও নথি সংরক্ষণ করুন — সবকিছু এক ব্যক্তিগত জায়গায়, ভারতীয় পরিবারদের জন্য তৈরি, আপনার নিজের ভাষায়।",
        heroCtaStart: "মোবাইল OTP দিয়ে ফ্রি শুরু করুন",
        heroCtaHow: "কীভাবে কাজ করে দেখুন",
        trustPrivate: "ডিফল্টভাবেই ব্যক্তিগত",
        trustLangs: "১০টি ভারতীয় ভাষা",
        trustFree: "শুরু করতে ফ্রি",
        fsdTitle: "মোবাইল OTP দিয়ে ফ্রি শুরু করুন",
        fsdSub: "১ মিনিটে শুরু করুন — সম্পূর্ণ ফ্রি।",
        fsdP1T: "১০০% ফ্রি শুরু",
        fsdP1D: "কোনও ক্রেডিট কার্ড নয়, কোনও লুকোনো চার্জ নয়। ফ্রি প্ল্যানে বংশবৃক্ষ, ছবি এবং গল্প সবই অন্তর্ভুক্ত।",
        fsdP2T: "শুধু আপনার মোবাইল নম্বর",
        fsdP2D: "মোবাইল নম্বর দিন → OTP পান → কাজ শেষ। কোনও ইমেল বা পাসওয়ার্ড মনে রাখার ঝামেলা নেই।",
        fsdP3T: "আপনার গোপনীয়তা সবার আগে",
        fsdP3D: "ডিফল্টভাবেই ব্যক্তিগত — কেবল আপনার পরিবারই আপনার তথ্য দেখতে পারবে।",
        fsdContinue: "চালিয়ে যান — ফ্রি শুরু করুন",
        fsdLater: "পরে হয়তো",
        dbTitle: "পণ্য ডেমো ও রিলস",
        dbSub: "ছোট ছোট ভিডিওতে দেখে নিন কীভাবে পুরো ফ্যামিলি ট্রি, স্মৃতি, ভল্ট ও কালচার ফিচারগুলো কাজ করে।",
        dbBtn: "ডেমো দেখুন",
        dpHeading: "ডেমো, রিলস ও ডকুমেন্টারি",
        dpSub: "প্রতিটি পণ্য ও পরিষেবার ডেমো — পুরো ফ্যামিলি ট্রি বানানো থেকে শুরু করে লেগেসি ভল্ট পর্যন্ত।",
        dpFeaturedTag: "ফিচারড ডেমো",
        dpAll: "সব",
        dpComingSoon: "ভিডিও শীঘ্রই আসছে",
        navHome: "হোম",
        navAbout: "আমাদের সম্পর্কে",
        navProducts: "প্রোডাক্ট এবং সার্ভিস",
        navHowItWorks: "কীভাবে কাজ করে",
        navFeatures: "ফিচারসমূহ",
        navSolutions: "সমাধানসমূহ",
        navHelp: "সাহায্য",
        navPackage: "প্যাকেজ",
        navResources: "রিসোর্স",
        navPricing: "প্রাইসিং",
        navDemos: "ডেমো",
        accMenuLabel: "সিনিয়র মোড",
        accSenior: "সিনিয়র মোড",
        accSeniorDesc: "বয়োজ্যেষ্ঠদের জন্য বড় লেখা ও বোতাম",
        accTextSize: "লেখার আকার",
        howEyebrow: "কীভাবে কাজ করে",
        howHeading: "ফ্যামিলি ট্রি তৈরি করার সহজ ৫টি ধাপ",
        how1T: "পরিবারের প্রধান হিসেবে লগইন করুন",
        how1D: "পরিবারের প্রধান হিসেবে আপনার প্রমাণপত্র ব্যবহার করে সাইন ইন করুন এবং আপনার পরিবারের উত্তরাধিকার নিজের নিয়ন্ত্রণে নিন।",
        how2T: "পরিবারের সদস্য যোগ করুন",
        how2D: "মা-বাবা, দাদা-দাদি-নানা-নানী, সন্তান ও জীবনসঙ্গী যোগ করে সম্পূর্ণ পারিবারিক গাছ তৈরি করুন।",
        how3T: "স্মৃতি ও গল্প আপলোড করুন",
        how3D: "লেখা, ছবি ও অডিও সংরক্ষণ করুন — প্রতিটি স্মৃতির জন্য এখানে নিরাপদ ঠিকানা আছে।",
        how4T: "পরিবারের সঙ্গে ভাগ করে নিন",
        how4D: "আপনার প্রিয়জনদের আমন্ত্রণ করুন, যাতে সবাই একসঙ্গে দেখেতে পারে, স্মৃতিচারণ করতে পারে এবং নতুন কিছু যোগ করতে পারে।",
        how5T: "পরবর্তী প্রজন্ম উত্তরাধিকার বহন করে নিয়ে যাবে",
        how5D: "আপনার সন্তান ও নাতি-নাতনিরা এই ধারাকে এগিয়ে নিয়ে যাবে — উত্তরাধিকার কখনও থেমে থাকবে না।",
        wcuEyebrow: "পরিবারগুলো আমাদেরই কেন বেছে নেয়",
        wcuHeading: "আপনার পরিবারের সব প্রিয় জিনিসের জন্য একটাই ঘর",
        wcu1T: "পরিবারের বংশতালিকা",
        wcu1D: "ছয় প্রজন্ম, প্রতিটি শাখা—একটি গাছের মতো সাজানো, যেন যে কেউ বুঝতে পারে।",
        wcu2T: "ছবি ও স্মৃতি",
        wcu2D: "ছবি, নোট আর স্মৃতিগুলো নিরাপদে রাখুন, সহজেই আবার খুঁজে পান।",
        wcu3T: "কণ্ঠস্বর ও অডিও গল্প",
        wcu3D: "বড়দের গল্প তাঁদেরই কণ্ঠে, তাঁদেরই ভাষায় রেকর্ড করে রাখুন।",
        wcu4T: "ভিডিও উত্তরাধিকার",
        wcu4D: "ভিডিও বার্তা ও শেষ ইচ্ছাগুলো আগামী প্রজন্মের জন্য সযত্নে সংরক্ষিত।",
        wcu5T: "দস্তাবেজ ভল্ট",
        wcu5D: "সার্টিফিকেট, দলিল আর গুরুত্বপূর্ণ কাগজ—গোছানো ও এনক্রিপ্টেড অবস্থায়।",
        wcuCtaT: "আজই শুরু করুন আপনার পরিবারের উত্তরাধিকার",
        wcuCtaD: "শুরু করতে একেবারে ফ্রি — শুধু আপনার মোবাইল নম্বর। আপনার নাতি-নাতনিরা আপনার প্রতি কৃতজ্ঞ থাকবে।",
        wcuCtaBtn: "ফ্রি-তে শুরু করুন",
        jfEyebrow: "আপনার যাত্রা",
        jfHeading: "আজ থেকে অনন্তকাল — মাত্র তিনটি সহজ ধাপ",
        jfSub: "বেশিরভাগ পরিবার দুই মিনিটেরও কম সময়ে ধাপ ১ শেষ করেন। কিন্তু এই যাত্রা চলতে পারে সারা জীবন।",
        jf1T: "আপনার পরিবার যোগ করুন",
        jf1D: "৬০ সেকেন্ডে মোবাইল OTP দিয়ে সাইন আপ। বাবা-মা, জীবনসঙ্গী, সন্তানদের একে একে যোগ করুন — টাইপ করা ধীর লাগলে তাদের নাম হিন্দি/মারাঠিতে বলেও যোগ করতে পারেন।",
        jf1B1: "কোনও পাসওয়ার্ডের ঝামেলা নেই",
        jf1B2: "১০টি ভারতীয় ভাষায় ভয়েস ইনপুট",
        jf1B3: "আপনাআপনি সম্পর্ক বসিয়ে দেয়",
        jf2T: "গল্প আর ছবি ধরে রাখুন",
        jf2D: "দিদা/দাদির গল্প রেকর্ড করুন, বিয়ে আর উৎসবের ছবি আপলোড করুন, অ্যালবামে সাজান। AI আপনার ভাষায় বলা কথা লিখে দেয়।",
        jf2B1: "অডিও + ছবি + নথি",
        jf2B2: "আপনার ফ্যামিলি ট্রি থেকে মানুষ ট্যাগ করুন",
        jf2B3: "Whisper ট্রান্সক্রিপশন",
        jf3T: "চিরদিনের জন্য সংরক্ষণ, নিরাপদে ভাগাভাগি করুন",
        jf3D: "এনক্রিপ্টেড ভারতীয়-সার্ভার স্টোরেজ। অডিও দিয়ে খসড়া উইল তৈরি করুন। নাতি-নাতনিদের জন্য টাইম-ক্যাপসুল শিডিউল করুন। ডিজাইন থেকেই DPDP-সম্মত।",
        jf3B1: "AES-256 এনক্রিপশন",
        jf3B2: "বায়োমেট্রিক-নিয়ন্ত্রিত ভল্ট",
        jf3B3: "সবসময় আপনার পরিবারেই থেকে যায়",
        jfCta: "এখনই ধাপ ১ শুরু করুন",
        jfNote: "প্রথম ২৫ জন পরিবারের সদস্যের জন্য চিরদিন ফ্রি। প্রয়োজন বাড়লেই তবেই আপগ্রেড করুন।",
        featEyebrow: "ফিচারসমূহ",
        featHeading: "একটি পরিবারকে একসাথে মনে রাখতে যা যা দরকার",
        wwhEyebrow: "একটি সতর্কতামূলক গল্প",
        wwhTitleA: "কি হবে",
        wwhTitleB: "যদি আমরা আমাদের গল্প ধরে না রাখি?",
        wwhHintDesktop: "প্রতি ৩ সেকেন্ডে নিজে থেকে চলে · থামাতে হোভার করুন · ব্রাউজ করতে সোয়াইপ করুন, ← → অথবা ডটস ব্যবহার করুন।",
        wwhHintMobile: "নিজে থেকে চলে · ব্রাউজ করতে সোয়াইপ করুন।",
        ppHeading: "পারিবারিক ইতিহাস সংরক্ষণ না করলে কী হয়?",
        pp1: "বয়োজ্যেষ্ঠদের স্মৃতিগুলো চিরতরে হারিয়ে যায়",
        pp2: "পুরনো ছবি হারিয়ে যায় বা নষ্ট হয়ে যায়",
        pp3: "শিশুরা শেকড়ের সাথে সংযোগ হারায়",
        pp4: "প্রতিটি প্রজন্মের সাথে সাথে রীতিনীতি ফিকে হয়ে যায়",
        tEyebrow: "প্রশংসাপত্র",
        tHeadA: "পরিবারেরা সারা",
        tIndia: "ভারত",
        tHeadB: "আমাদের ওপর ভরসা রাখুন",
        tSub: "বাস্তব পরিবার, বাস্তব জীবনের গল্প – সংরক্ষিত থাকবে চিরদিনের জন্য।",
        faqHeading: "প্রায় জিজ্ঞাসিত প্রশ্নাবলি",
        faq1Q: "আমাদের পারিবারিক তথ্য কি নিরাপদ?",
        faq1A: "হ্যাঁ। ডাটা স্টোরেজে ব্যাংক-স্তরের AES-256 এনক্রিপশন, httpOnly কুকি অথ, Document & Legal Vault‑এ ঐচ্ছিক ফিঙ্গারপ্রিন্ট/Face ID গেট, ভারত-ভিত্তিক MongoDB স্টোরেজ।",
        faq2Q: "এটা কি NRI পরিবাররা ব্যবহার করতে পারবেন?",
        faq2A: "নিশ্চয়ই। মাল্টি-টাইমজোন সাপোর্ট, ১০টি ভারতীয় ভাষায় ব্রাউজার ভাষা অটো-ডিটেকশন, আর Family World Map উইজেট যা দেখায় প্রতিটি আত্মীয় কোথায় থাকেন।",
        faq3Q: "বয়স্কদের জন্য কি এটা সহজ?",
        faq3A: "হ্যাঁ। সিনিয়র মোডে শুধু ৩টি বড় বোতাম থাকে (ছবি / গল্প / পরিবার)। ২২px ফন্ট, বড় ট্যাপ টার্গেট, আগে ভয়েস-রেকর্ডিং অপশন।",
        faq4Q: "আমরা কি ১০০+ পরিবারের সদস্য যোগ করতে পারি?",
        faq4A: "ফ্রি প্ল্যানে ২৫ জন সদস্য পর্যন্ত; Family ₹999/বছর প্ল্যানে আনলিমিটেড সদস্য + ১০ GB স্টোরেজ; Legacy ₹2999/বছর প্ল্যানে Legal Vault, ১০০ GB, প্রিন্টেড ফ্যামিলি ট্রি এবং প্রায়োরিটি সাপোর্ট।",
        faq5Q: "কোন কোন ভাষা সাপোর্ট করে?",
        faq5A: "English, Hindi, Marathi, Tamil, Telugu, Kannada, Malayalam, Bengali, Gujarati এবং Punjabi — পুরো UI‑এর অনুবাদ, প্রথম ভিজিটেই ব্রাউজার ভাষা অটো-ডিটেক্ট হয়।",
        faq6Q: "আমরা কি আমাদের ডাটা এক্সপোর্ট করতে পারি?",
        faq6A: "হ্যাঁ। Settings → My Data → Download All My Data থেকে আপনার ট্রি, স্মৃতি, গল্প এবং ডকুমেন্ট সব একসাথে একটি আর্কাইভে এক্সপোর্ট হয় (DPDP‑compliant)।",
        faq7Q: "ফ্রি ট্রায়াল শেষ হলে কী হয়?",
        faq7A: "কোনো ট্রায়াল নেই — ফ্রি প্ল্যান স্থায়ী। যখন ২৫ জনের বেশি সদস্য, AI biography বা Legal Vault দরকার হবে তখনই আপগ্রেড করুন। বার্ষিক প্ল্যানে ৭ দিনের গ্রেস পিরিয়ড এবং সম্পূর্ণ টাকা ফেরতের গ্যারান্টি আছে।",
        faq8Q: "একাধিক সদস্য কি অবদান রাখতে পারবেন?",
        faq8A: "হ্যাঁ। ভাইবোন, বাবা-মা আর কাজিনদের মোবাইল নম্বর দিয়ে ইনভাইট করুন। প্রত্যেকে একটি ভূমিকা পান: Family Head / Editor / Viewer — প্রতিটি ডকুমেন্টের জন্য আলাদা প্রাইভেসি কন্ট্রোল থাকে।",
        mscTitle: "ফ্রি · মোবাইল OTP সাইনআপ",
        mscDpdp: "DPDP অনুগত",
        mscStart: "ফ্রি শুরু করুন",
        qrEyebrow: "আপনার পরিবারকে সঙ্গে রাখুন",
        qrHeading: "একবার স্ক্যান করুন। ফোনেই আপনার Family Repository।",
        qrSub: "অ্যাপ ইনস্টল করতে ক্যামেরা দিয়ে QR কোডটির দিকে তাক করুন। Android আর iPhone – দুটোর জন্যই কাজ করে, আমরা নিজে থেকেই সঠিক স্টোর ধরে নেব।",
        qrLi1: "এক ট্যাপেই ইনস্টল – Android ও iPhone",
        qrLi2: "iOS 14+ — App Store",
        qrLi3: "Android 8+ — Google Play",
        qrOrVisit: "অথবা যান",
        ftEyebrow: "বাড়ির সঙ্গেই থাকুন",
        ftHeadline: "আপনার পরিবারের উত্তরাধিকার সংরক্ষণ করুন।",
        ftJoinA: "যুগুন",
        ftJoinB: "ভারতের পরিবারগুলোর সঙ্গে।",
        ftNewsDesc: "ঐতিহ্যের গল্প, সংস্কৃতির টুকরো আর প্রোডাক্টের খবর — পাক্ষিকে একবার। কোনো স্প্যাম নয়, কখনওই না।",
        ftSubscribe: "সাবস্ক্রাইব করুন",
        ftJoining: "যুগছি…",
        ftDpdpNote: "DPDP-অনুগত · আমরা আপনার ডেটা কখনও বিক্রি করি না",
        ftBrandDesc: "একটি ব্যক্তিগত, ভারত-কেন্দ্রিক জায়গা যেখানে পরিবারগুলি তাদের গল্প সংরক্ষণ করে, বয়োজ্যেষ্ঠদের কণ্ঠ রেকর্ড করে এবং প্রজন্মের পর প্রজন্ম তাদের উত্তরাধিকার পৌঁছে দেয়।",
        colCompany: "কোম্পানি",
        colFtServices: "ফ্যামিলি ট্রি সার্ভিস",
        colAdminSupport: "অ্যাডমিন সাপোর্ট",
        colProduct: "প্রোডাক্ট / পরিষেবা",
        colSupport: "সাপোর্ট এবং সাহায্য",
        colLegal: "লিগ্যাল",
        colTechnical: "টেকনিক্যাল",
        colMethodology: "পদ্ধতি / কমপ্লায়েন্স",
        badgeMii: "মেড ইন ইন্ডিয়া · মুম্বাইয়ে তৈরি",
        badgeDpdp: "DPDP Act 2023 Compliant",
        badgeIso: "ISO 27001 Certified",
        badgeSoc: "SOC 2 Certified",
        badgeEnc: "ব্যাংক-স্তরের এনক্রিপশন",
        wcu6T: "স্বাস্থ্য ভান্ডার",
        wcu6D: "পরিবারের চিকিৎসা ইতিহাস, অসুস্থতা আর রক্তের গ্রুপ—সব এক জায়গায়।",
        wcu7T: "পারিবারিক ক্যালেন্ডার ও মনে করিয়ে দেওয়া",
        wcu7D: "জন্মদিন, বিবাহবার্ষিকী, শ্রাদ্ধ আর উৎসব—কিছুই আর চোখ এড়াবে না।",
        wcu8T: "আইনি ও উত্তরাধিকার ভল্ট",
        wcu8D: "উইল, নমিনি আর উত্তরাধিকার সংক্রান্ত সব তথ্য, প্রয়োজনের সময় হাতের কাছে।",
        wcu9T: "রীতি-নীতি ও আচার",
        wcu9D: "আপনাদের পরিবার কীভাবে কোন কাজ করে—ভুলে যাওয়ার আগেই লিখে সংরক্ষণ করুন।",
        wcu10T: "রেসিপি ও পারিবারিক রান্না",
        wcu10D: "শুধু আপনাদের বাড়িতেই যে সব খাবার হয়, সেগুলো পেছনের গল্পসহ সুরক্ষিত রাখুন।",
        wcu11T: "স্থান ও পৈতৃক গ্রাম",
        wcu11D: "মানচিত্রে আপনার শিকড় — গ্রাম, বাড়ি এবং সারা পৃথিবী জুড়ে আপনার যাত্রাপথ।",
        wcu12T: "পারিবারিক সংবিধান ও মূল্যবোধ",
        wcu12D: "আপনাদের পরিবার যে নীতিগুলো মেনে চলে, সবার সম্মতিতে লেখা ও সংরক্ষিত।",
        wcu13T: "টাইম ক্যাপসুল",
        wcu13D: "আজ লেখা বার্তা, আপনার পছন্দ করা ভবিষ্যতের কোনও দিনে খুলে দেখার জন্য সিল করে রাখা।",
        wcu14T: "পারিবারিক কৃতিত্ব ও বীরেরা",
        wcu14D: "মাইলস্টোন, সম্মাননা এবং আপনার পরিবারের অজানা ও অবহেলিত বীরদের গল্প।",
        wcu15T: "জীবনী ও স্মৃতিচারণ",
        wcu15D: "আপনার পুরো জীবনকাহিনি, আমাদের অভিজ্ঞ লেখকদের সহায়তায় সাজিয়ে লেখা।",
        wcu16T: "AI পারিবারিক সরঞ্জাম",
        wcu16D: "নরম সহায়ক AI, যা লেখা, ছবি পুনরুদ্ধার এবং ডকুমেন্টারি তৈরি করতে সাহায্য করে।",
        wcuSub: "পরিবারের দরকারি ষোলোটি দৈনন্দিন জিনিস — সব এক জায়গায়, ব্যক্তিগত ও নিরাপদ পরিবেশে।",
    },
    gu: {
        heroFamiliesTrust: "ભારતીય પરિવારો અમારો વિશ્વાસ કરે છે",
        heroTitleA: "તમારા પરિવારનો ઈતિહાસ",
        heroTitleB: "સંગ્રહિત",
        heroTitleC: "હંમેશા માટે.",
        heroSub: "તમારું વંશવૃક્ષ બનાવો, વડીલોના અવાજો રેકોર્ડ કરો, ફોટા અને દસ્તાવેજો સાચવો — આ બધું ભારતીય પરિવારો માટે બનાવાયેલી, તમારી પોતાની ભાષામાં, એક ખાનગી જગ્યામાં.",
        heroCtaStart: "મોબાઇલ OTP સાથે મફતમાં શરૂ કરો",
        heroCtaHow: "કેમ કામ કરે છે તે જુઓ",
        trustPrivate: "મૂળભૂત રીતે ખાનગી",
        trustLangs: "10 ભારતીય ભાષાઓ",
        trustFree: "શરૂઆત મફત",
        fsdTitle: "મોબાઇલ OTP સાથે મફતમાં શરૂ કરો",
        fsdSub: "ફક્ત 1 મિનિટમાં શરૂઆત કરો — સંપૂર્ણ મફત.",
        fsdP1T: "100% મફત શરૂઆત",
        fsdP1D: "કોઈ ક્રેડિટ કાર્ડ નહીં, કોઈ છુપાયેલા ચાર્જિસ નહીં. ફ્રી પ્લાનમાં વંશવૃક્ષ, ફોટા અને વાર્તાઓ બધું સામેલ છે.",
        fsdP2T: "ફક્ત તમારો મોબાઈલ નંબર",
        fsdP2D: "તમારો મોબાઇલ નંબર નાખો → OTP મેળવો → કામ પૂર્ણ. કોઈ ઇમેઇલ કે પાસવર્ડ યાદ રાખવાની જરૂર નહીં.",
        fsdP3T: "તમારી ખાનગીતા પહેલા",
        fsdP3D: "મૂળભૂત રીતે ખાનગી — ફક્ત તમારો પરિવાર જ તમારો ડેટા જોઈ શકે.",
        fsdContinue: "ચાલુ રાખો — મફતમાં શરૂ કરો",
        fsdLater: "પછી કદાચ",
        dbTitle: "પ્રોડક્ટ ડેમો અને રીલ્સ",
        dbSub: "આખું કુટુંબ વૃક્ષ, યાદો, વોલ્ટ અને સંસ્કૃતિ ફીચર્સ કેવી રીતે કામ કરે છે તે ટૂંકા વિડિયોમાં જુઓ.",
        dbBtn: "ડેમો જુઓ",
        dpHeading: "ડેમો, રીલ્સ અને ડોક્યુમેન્ટરીઝ",
        dpSub: "દરેક પ્રોડક્ટ અને સર્વિસનો ડેમો — પૂરું કુટુંબ વૃક્ષ બનાવવા થી લઇને લેગેસી વોલ્ટ સુધી.",
        dpFeaturedTag: "વિશેષ ડેમો",
        dpAll: "બધા",
        dpComingSoon: "વિડિયો ટૂંક સમયમાં આવી રહ્યો છે",
        navHome: "ઘર",
        navAbout: "અમારા વિશે",
        navProducts: "ઉત્પાદનો અને સેવાઓ",
        navHowItWorks: "કેવી રીતે કામ કરે છે",
        navFeatures: "ફીચર્સ",
        navSolutions: "સોલ્યુશન્સ",
        navHelp: "મદદ",
        navPackage: "પેકેજ",
        navResources: "સ્રોતો",
        navPricing: "કિંમતો",
        navDemos: "ડેમો",
        accMenuLabel: "વરિષ્ઠ મોડ",
        accSenior: "વડીલો માટે મોડ",
        accSeniorDesc: "વડીલો માટે મોટું લખાણ અને મોટા બટન",
        accTextSize: "લખાણનું આકાર",
        howEyebrow: "કેવી રીતે કામ કરે છે",
        howHeading: "ફેમિલી ટ્રી બનાવવા માટે સરળ 5 પગલાં",
        how1T: "પરિવારના વડા તરીકે લોગિન કરો",
        how1D: "પરિવારના મુખિયાના રૂપમાં તમારી ઓળખથી સાઇન ઇન કરીને તમારા પરિવારની વારસાગાથાનું નેતૃત્વ સંભાળો.",
        how2T: "પરિવારના સભ્યો ઉમેરો",
        how2D: "માતા–પિતા, દાદા–દાદી, બાળકો અને જીવનસાથીઓ ઉમેરો અને તમારો સંપૂર્ણ કુટુંબ વૃક્ષ બનાવો.",
        how3T: "સ્મૃતિઓ અને કથાઓ અપલોડ કરો",
        how3D: "લખાણ, તસવીરો અને અવાજની ઝાંખીઓ સાચવો — દરેક યાદીને અહીં સુરક્ષિત ઘર મળે છે.",
        how4T: "પરિવાર સાથે વહેંચો",
        how4D: "તમારા સ્નેહીજનોને આમંત્રિત કરો જેથી આખો પરિવાર આ સંગ્રહને જોઈ શકે, ફરી જીવી શકે અને તેમાં પોતાનું ઉમેરો કરી શકે.",
        how5T: "અગામી પેઢી વારસો આગળ વધારે",
        how5D: "તમારા સંતાન અને પૌત્રો આ પરંપરાને આગળ વધારશે — વારસો ક્યારેય અટકશે નહીં.",
        wcuEyebrow: "પરિવારો અમને કેમ પસંદ કરે છે",
        wcuHeading: "તમારા પરિવારને પ્રિય બધી વસ્તુઓ માટે એક જ ઘર",
        wcu1T: "કુટુંબ વૃક્ષ",
        wcu1D: "છ પેઢીઓ, દરેક ડાળ – દરેકને વાંચી શકે એવું વૃક્ષમાં દર્શાવેલું.",
        wcu2T: "ફોટાઓ અને યાદો",
        wcu2D: "ફોટોગ્રાફ, નોંધો અને પળો – સુરક્ષિત રીતે સંગ્રહિત અને સરળતાથી શોધવા જેવું.",
        wcu3T: "આવાજ અને ઓડિયો વાર્તાઓ",
        wcu3D: "મોટાઓને તેમના પોતાના અવાજમાં, તેમની પોતાની ભાષામાં રેકોર્ડ કરો.",
        wcu4T: "વિડિયો ધરોહર",
        wcu4D: "આગામી પેઢીઓ માટે સાચવી રાખેલા વિડિયો સંદેશા અને હુકમનામા.",
        wcu5T: "દસ્તાવેજ તિજોરી",
        wcu5D: "પ્રમાણપત્રો, કાગળો અને હુકમનામા – ગોઠવેલા અને એન્ક્રિપ્ટેડ.",
        wcuCtaT: "આજથી જ તમારા કુટુંબનું વારસો શરૂ કરો",
        wcuCtaD: "શરૂઆત મફત — ફક્ત તમારો મોબાઇલ નંબર. તમારા પૌત્રો તમને આ માટે આભાર કહેશે.",
        wcuCtaBtn: "મફતમાં શરૂ કરો",
        jfEyebrow: "તમારી સફર",
        jfHeading: "આજથી સદાકાળ સુધીના માત્ર ત્રણ સરળ પગલા",
        jfSub: "ઘણા કુટુંબો પહેલો પગલું બે મિનિટથી પણ ઓછા સમયમાં પૂરો કરે છે. સફર ખુદ જીવનભર ચાલી શકે છે.",
        jf1T: "તમારો કુટુંબ ઉમેરો",
        jf1D: "મોબાઇલ OTP સાઇનઅપ 60 સેકન્ડમાં. માતા-પિતા, જીવનસાથી, સંતાનોને એક પછી એક ઉમેરો — ટાઇપ કરવું ધીમું લાગે તો તેમના નામ હિન્દી/મરાઠીમાં બોલી શકો છો.",
        jf1B1: "ક્યારેય પાસવર્ડ નહીં",
        jf1B2: "ભારતની 10 ભાષાઓમાં વોઇસ ઇનપુટ",
        jf1B3: "સંબંધી આપમેળે ભરે",
        jf2T: "કથાઓ અને ફોટા સંગ્રહો",
        jf2D: "તમારી દાદીની વાર્તાઓ રેકોર્ડ કરો, લગ્ન અને તહેવારોના ફોટા અપલોડ કરો, અને આલ્બમમાં ગોઠવો. AI તમારા ભાષામાં અવાજને લખાણમાં બદલે છે.",
        jf2B1: "ઓડિયો + ફોટા + દસ્તાવેજો",
        jf2B2: "તમારા કુટુંબ વૃક્ષમાંથી લોકોને ટૅગ કરો",
        jf2B3: "Whisper ટ્રાન્સક્રિપ્શન",
        jf3T: "સદાકાળ માટે સાચવો, સુરક્ષિત રીતે વહેંચો",
        jf3D: "એન્ક્રિપ્ટેડ ભારતીય સર્વર પર સંગ્રહ. ઑડિયો સાથે ડ્રાફ્ટ વસીયતો બનાવો. પૌત્રો માટે ટાઈમ-કેપ્સ્યુલ્સનું શેડ્યૂલ કરો. ડિઝાઇનથી જ DPDP-અનુરૂપ.",
        jf3B1: "AES-256 એનક્રિપ્શન",
        jf3B2: "બાયોમેટ્રિકથી સુરક્ષિત વોલ્ટ્સ",
        jf3B3: "હંમેશાં તમારી જ પરિવારની અંદર રહે છે",
        jfCta: "હમણાં જ પગલું 1 શરૂ કરો",
        jfNote: "પહેલા 25 પરિવારજનો માટે હંમેશા માટે મફત. જ્યારે જરૂરિયાત વધે ત્યારે જ અપગ્રેડ કરો.",
        featEyebrow: "વિશેષતાઓ",
        featHeading: "પરિવારે મળીને યાદ રાખવા માટે જરૂરી બધી જ વસ્તુઓ",
        wwhEyebrow: "એક ચેતવણીભરી વાત",
        wwhTitleA: "શું થશે",
        wwhTitleB: "જો આપણે આપણી વાર્તા જ સાચવી ન રાખીએ?",
        wwhHintDesktop: "દર 3 સેકન્ડે આપમેળે ચલાવે · વિરામ માટે_hover કરો · બ્રાઉઝ કરવા માટે સ્વાઈપ કરો, ← → અથવા ડોટ્સ વાપરો.",
        wwhHintMobile: "આપમેળે ચલાવે · બ્રાઉઝ કરવા માટે સ્વાઈપ કરો.",
        ppHeading: "જો પરિવારનો ઈતિહાસ સાચવાયો ન હોય તો શું થાય?",
        pp1: "વડીલોની યાદો સદાકાળ માટે ગાયબ થઈ જાય છે",
        pp2: "જૂના ફોટા ખોવાઈ જાય છે અથવા બગડી જાય છે",
        pp3: "બાળકો પોતાની મૂળિયાઓથી દૂર થઈ જાય છે",
        pp4: "દરેક પેઢી સાથે પરંપરાઓ ધીમે ધીમે ઓછી થઈ જાય છે",
        tEyebrow: "પ્રશંસાપત્રો",
        tHeadA: "પરિવારો સમગ્ર",
        tIndia: "ભારત",
        tHeadB: "અમારો વિશ્વાસ કરો",
        tSub: "ખરા કુટુંબો, સાચી જીવન કથાઓ હંમેશ માટે સંભાળેલી.",
        faqHeading: "વારંવાર પૂછાતા પ્રશ્નો",
        faq1Q: "શું અમારી કુટુંબની માહિતી સુરક્ષિત છે?",
        faq1A: "હા. બેંક-સ્તરના AES-256 એન્ક્રિપ્શન (ડેટા સ્ટોર પર), httpOnly કૂકી ઓથ, Document & Legal Vault પર વૈકલ્પિક fingerprint/Face ID લૉક, અને ભારતમાં હોસ્ટેડ MongoDB સ્ટોરેજ.",
        faq2Q: "શું NRI કુટુંબો આનો ઉપયોગ કરી શકે?",
        faq2A: "બિલ્કુલ. બહુસ્ટ સમય ઝોન સપોર્ટ, 10 ભારતીય ભાષાઓમાં બ્રાઉઝર ભાષા આપમેળે ઓળખ, અને Family World Map વિજેટ કે જેમાં દરેક સગા ક્યાં રહે છે તે દેખાય છે.",
        faq3Q: "શું વડીલો માટે સરળ છે?",
        faq3A: "હા. Senior Mode માં માત્ર 3 મોટા બટન દેખાય છે (Photos / Story / Family). 22px ફૉન્ટ, મોટા ટેપ વિસ્તાર, અને સૌપ્રથમ વૉઇસ-રેકોર્ડિંગ.",
        faq4Q: "શું અમે 100થી વધુ કુટુંબ સભ્યો ઉમેરી શકીએ?",
        faq4A: "ફ્રી પ્લાનમાં 25 સભ્યો સુધી; Family ₹999/વર્ષ પ્લાનમાં અમર્યાદ સભ્યો + 10 GB સ્ટોરેજ; Legacy ₹2999/વર્ષ સાથે Legal Vault, 100 GB, છપાયેલ વંશવૃક્ષ, અને પ્રાથમિકતા આધાર.",
        faq5Q: "કઈ ભાષાઓ સપોર્ટેડ છે?",
        faq5A: "English, Hindi, Marathi, Tamil, Telugu, Kannada, Malayalam, Bengali, Gujarati અને Punjabi — સંપૂર્ણ UI અનુવાદ, અને પહેલી મુલાકાતે બ્રાઉઝર ભાષા આપમેળે ઓળખાય છે.",
        faq6Q: "શું અમે અમારી માહિતી એક્સપોર્ટ કરી શકીએ?",
        faq6A: "હા. Settings → My Data → Download All My Data થી તમારું વંશવૃક્ષ, યાદો, કથાઓ અને દસ્તાવેજો એક જ આર્કાઇવમાં એક્સપોર્ટ થાય છે (DPDP-અનુરૂપ).",
        faq7Q: "ફ્રી ટ્રાયલ પછી શું થાય?",
        faq7A: "અલગથી કોઈ ટ્રાયલ નથી — ફ્રી પ્લાન કાયમી છે. જ્યારે 25થી વધુ સભ્યો, AI biography કે Legal Vaultની જરૂર પડે ત્યારે જ અપગ્રેડ કરો. વાર્ષિક પ્લાન પર 7 દિવસનો ગ્રેસ પિરિયડ અને સંપૂર્ણ પૈસા પરતની ખાતરી છે.",
        faq8Q: "શું ઘણા સભ્યો મળીને યોગદાન આપી શકે?",
        faq8A: "હા. ભાઈ-બહેન, માતા-પિતા અને કઝિન્સને મોબાઇલ નંબર દ્વારા ઇન્વાઇટ કરો. દરેકને એક ભૂમિકા મળે: Family Head / Editor / Viewer — અને દરેક દસ્તાવેજ માટે વિગતવાર પ્રાઇવસી નિયંત્રણ.",
        mscTitle: "મફત · Mobile OTP સાઇનઅપ",
        mscDpdp: "DPDP અનુરૂપ",
        mscStart: "ફ્રી શરૂ કરો",
        qrEyebrow: "તમારા પરિવારને સાથે રાખો",
        qrHeading: "એક વખત સ્કેન કરો. તમારા ફોનમાં Family Repository.",
        qrSub: "એપ ઇન્સ્ટોલ કરવા માટે તમારો કેમેરો QR કોડ તરફ કરો. Android અને iPhone બંને પર કામ કરે છે — અમે તમારા માટે યોગ્ય સ્ટોર આપમેળે શોધી લઈએ છીએ.",
        qrLi1: "Android અને iPhone પર એક-ટેપ ઇન્સ્ટોલ",
        qrLi2: "iOS 14+ — App Store",
        qrLi3: "Android 8+ — Google Play",
        qrOrVisit: "અથવા મુલાકાત લો",
        ftEyebrow: "ઘર સાથે જોડાયેલા રહો",
        ftHeadline: "તમારા પરિવારની વારસાગાથા જાળવો.",
        ftJoinA: "જોડાયો",
        ftJoinB: "ભારતીય પરિવારો સાથે.",
        ftNewsDesc: "વારસાગાથાઓ, સાંસ્કૃતિક રસપ્રદ વાતો અને પ્રોડક્ટ અંગેની માહિતી — પંદર દિવસે એક વખત. ક્યારેય પણ સ્પામ નહીં.",
        ftSubscribe: "સબ્સ્ક્રાઇબ કરો",
        ftJoining: "જોડાઈ રહ્યું છે…",
        ftDpdpNote: "DPDP-અનુરૂપ · અમે તમારા ડેટા ક્યારેય વેચતા નથી",
        ftBrandDesc: "એક ખાનગી, ભારત-પ્રથમ જગ્યા જ્યાં પરિવારો તેમની કહાનીઓ સાચવે છે, વડીલોનો અવાજ રેકોર્ડ કરે છે અને પેઢીથી પેઢી સુધી તેમની વારસાગાથા પહોંચાડે છે.",
        colCompany: "કમ્પની",
        colFtServices: "ફેમિલી ટ્રી સેવાઓ",
        colAdminSupport: "એડમિન સપોર્ટ",
        colProduct: "ઉત્પાદનો / સેવાઓ",
        colSupport: "સપોર્ટ અને મદદ",
        colLegal: "કાનૂની",
        colTechnical: "તકનીકી",
        colMethodology: "પદ્ધતિ / અનુસરણ",
        badgeMii: "મેડ ઇન ઇન્ડિયા · મુંબઈમાં બનાવેલ",
        badgeDpdp: "DPDP Act 2023 અનુસાર",
        badgeIso: "ISO 27001 પ્રમાણિત",
        badgeSoc: "SOC 2 પ્રમાણિત",
        badgeEnc: "બૅંક-સ્તરની એન્ક્રિપ્શન",
        wcu6T: "હેલ્થ રિપોઝિટરી",
        wcu6D: "કુટુંબનો તબીબી ઇતિહાસ, તકલીફો અને બ્લડ ગ્રૂપ – બધું એક જ જગ્યાએ.",
        wcu7T: "કુટુંબ કેલેન્ડર અને રિમાઇન્ડર્સ",
        wcu7D: "જન્મદિવસ, લગ્નવાર્ષિકી, શ્રાદ્ધ અને તહેવારો – કંઈયું ચૂકી ન જાય.",
        wcu8T: "કાનૂની અને ધરોહર તિજોરી",
        wcu8D: "વસીયતો, નામાંકિતો અને વારસાગત વિગતો – જરૂર પડે ત્યારે તરત તૈયાર.",
        wcu9T: "પરંપરાઓ અને વિધિઓ",
        wcu9D: "તમેનું કુટુંબ શું રીતે કામ કરે છે – ભુલાઈ જાય એ પહેલાં લખીને સાચવેલું.",
        wcu10T: "રેસીપી અને કુટુંબનું ખાવા-પીવાનું",
        wcu10D: "માત્ર તમારું કુટુંબ બનાવે એવા વાનગીઓ, તેમની પાછળની વાર્તાઓ સાથે સાચવેલી.",
        wcu11T: "સ્થળો અને પૂર્વજોના ગામ",
        wcu11D: "તમારી મૂળિયાઓ નકશા પર — ગામ, ઘર અને દુનિયાભરના પ્રવાસો.",
        wcu12T: "કુટુંબ બંધારણ અને મૂલ્યો",
        wcu12D: "જે સિદ્ધાંતો પર તમારું કુટુંબ જીવે છે, જે પરસ્પર સંમતિથી નક્કી કરીને લખી રાખ્યાં છે.",
        wcu13T: "ટાઈમ કેપ્સ્યુલ",
        wcu13D: "આજે લખેલા સંદેશા, તમે પસંદ કરેલી તારીખે ખોલવા માટે સીલ કરેલા.",
        wcu14T: "કુટુંબ સિદ્ધિઓ અને નાયક",
        wcu14D: "મહત્વના પડાવ, સન્માન અને તમારા કુટુંબના નિરસંગે સેવક એવા નાયકો.",
        wcu15T: "જીવનચરિત્ર અને સ્મૃતિલેખ",
        wcu15D: "નિષ્ણાત લેખકોની મદદથી લખાયેલ સંપૂર્ણ જીવન કથાઓ.",
        wcu16T: "AI કુટુંબ સાધનો",
        wcu16D: "લખવા, ફોટા પુનઃસ્થાપિત કરવા અને ડોક્યુમેન્ટરી બનાવવા માટે સૌમ્ય AI મદદ.",
        wcuSub: "તમે રોજબરોજ જેની જરૂર હોય એવી સોળ કુટુંબ બાબતો — બધું એક જ ખાનગી, સુરક્ષિત ઘરે.",
    },
    te: {
        heroFamiliesTrust: "భారతీయ కుటుంబాలు మమ్మల్ని నమ్ముతున్నాయి",
        heroTitleA: "మీ కుటుంబ చరిత్ర",
        heroTitleB: "సంరక్షించబడుతుంది",
        heroTitleC: "శాశ్వతంగా.",
        heroSub: "మీ కుటుంబ వృక్షాన్ని నిర్మించండి, పెద్దల గొంతులను రికార్డు చేయండి, ఫోటోలు మరియు పత్రాలను నిల్వ చేసుకోండి — ఇవన్నీ భారతీయ కుటుంబాల కోసం, మీ భాషలో, ఒక ప్రైవేట్ స్థలంలో.",
        heroCtaStart: "మొబైల్ OTPతో ఉచితంగా ప్రారంభించండి",
        heroCtaHow: "ఇది ఎలా పనిచేస్తుందో చూడండి",
        trustPrivate: "మూలంగా ప్రైవేట్‌గానే",
        trustLangs: "10 భారతీయ భాషలు",
        trustFree: "ఉచిత ప్రారంభం",
        fsdTitle: "మొబైల్ OTPతో ఉచితంగా ప్రారంభించండి",
        fsdSub: "1 నిమిషంలో మొదలు — పూర్తిగా ఉచితం.",
        fsdP1T: "100% ఉచిత ప్రారంభం",
        fsdP1D: "క్రెడిట్ కార్డు అవసరం లేదు, దాచిన చార్జీలు లేవు. ఫ్రీ ప్లాన్‌లో కుటుంబ వృక్షం, ఫోటోలు, కథలు ఉంటాయి.",
        fsdP2T: "మీ మొబైల్ నంబర్ ఒక్కటే చాలును",
        fsdP2D: "మీ మొబైల్ నంబర్ నమోదు చేయండి → OTP రిసీవ్ అవుతుంది → అంతే, లోపలికి. గుర్తుంచుకోవాల్సిన ఇమెయిల్ లేదా పాస్‌వర్డ్ ఏమీ లేదు.",
        fsdP3T: "ముందు మీ గోప్యతే",
        fsdP3D: "మూలంగా ప్రైవేట్ — మీ డేటాను చూడగలరు మీ కుటుంబ సభ్యులే.",
        fsdContinue: "కొనసాగించండి — ఉచితంగా ప్రారంభించండి",
        fsdLater: "తర్వాత చూద్దాం",
        dbTitle: "ఉత్పత్తి డెమోలు & రీల్స్",
        dbSub: "కుటుంబ వృక్షం, జ్ఞాపకాలు, వాల్ట్, సంస్కృతి వంటి ఫీచర్లు ఎలా పనిచేస్తాయో — చిన్న వీడియోలలో చూడండి.",
        dbBtn: "డెమోలు చూడండి",
        dpHeading: "డెమోలు, రీల్స్ & డాక్యుమెంటరీలు",
        dpSub: "పూర్తి కుటుంబ వృక్షం నిర్మాణం నుంచి లెగసీ వాల్ట్ వరకు — ప్రతి ఉత్పత్తి, సేవను చూపించే డెమోలు.",
        dpFeaturedTag: "ప్రత్యేక డెమో",
        dpAll: "అన్నీ",
        dpComingSoon: "వీడియో త్వరలో రాబోతోంది",
        navHome: "హోమ్",
        navAbout: "మా గురించి",
        navProducts: "ఉత్పత్తులు మరియు సేవలు",
        navHowItWorks: "ఇది ఎలా పనిచేస్తుంది",
        navFeatures: "ఫీచర్లు",
        navSolutions: "సొల్యూషన్లు",
        navHelp: "సహాయం",
        navPackage: "ప్యాకేజ్",
        navResources: "వనరులు",
        navPricing: "ధరలు",
        navDemos: "డెమోలు",
        accMenuLabel: "సీనియర్ మోడ్",
        accSenior: "సీనియర్ మోడ్",
        accSeniorDesc: "పెద్ద అక్షరాలు & బటన్లు పెద్దలకు సౌకర్యంగా",
        accTextSize: "అక్షరాల పరిమాణం",
        howEyebrow: "ఇది ఎలా పనిచేస్తుంది",
        howHeading: "ఫ్యామిలీ ట్రీ సృష్టించేందుకు సులభమైన 5 మెట్లు",
        how1T: "కుటుంబ పెద్దగా లాగిన్ అవ్వండి",
        how1D: "మీ కుటుంబ పెద్దగా మీ వివరాలతో సైన్ ఇన్ చేసి, మీ కుటుంబ వారసత్వ బాధ్యతను మీ చేతుల్లోకి తీసుకోండి.",
        how2T: "కుటుంబ సభ్యులను జోడించండి",
        how2D: "తల్లిదండ్రులు, తాతలు-అమ్మమ్మలు, పిల్లలు, జీవిత భాగస్వాములను జోడించి మీ పూర్తి కుటుంబ వృక్షాన్ని నిర్మించండి.",
        how3T: "స్మృతులు & కథలను అప్లోడ్ చేయండి",
        how3D: "పాఠ్యాలు, చిత్రాలు, ఆడియోలను భద్రపరచండి — ప్రతి జ్ఞాపకానికి సురక్షిత స్థానం దొరుకుతుంది.",
        how4T: "కుటుంబంతో పంచుకోండి",
        how4D: "మీ ప్రియమైన వారిని ఆహ్వానించి, మొత్తం కుటుంబం కలిసి చూడటానికి, మళ్లీ అనుభవించటానికి, ఇంకా కొత్త జ్ఞాపకాలను జోడించటానికి అవకాశం ఇవ్వండి.",
        how5T: "తరువాతి తరం వారసత్వాన్ని కొనసాగిస్తుంది",
        how5D: "మీ పిల్లలు, మనవలు ఈ సంప్రదాయాన్ని కొనసాగిస్తారు — మీ వారసత్వం ఎప్పటికీ ఆగదు.",
        wcuEyebrow: "కుటుంబాలు మమ్మల్ని ఎందుకు ఎంచుకుంటాయి",
        wcuHeading: "మీ కుటుంబానికి అమూల్యమైన ప్రతిదీ ఉండే ఒకే గృహం",
        wcu1T: "కుటుంబ వృక్షం",
        wcu1D: "ఆరు తరాలు, ప్రతి కొమ్మ — ఎవరికైనా అర్థమయ్యేలా వృక్ష రూపంలో.",
        wcu2T: "ఫోటోలు & జ్ఞాపకాలు",
        wcu2D: "ఫోటోలు, నోట్లు మరియు జ్ఞాపక క్షణాలు — సురక్షితంగా నిల్వ చేసి, సులభంగా వెతికేలా.",
        wcu3T: "గళం & ఆడియో కథలు",
        wcu3D: "పెద్దలను వారి స్వరంతో, వారి స్వభాషలోనే రికార్డ్ చేసుకోండి.",
        wcu4T: "వీడియో వారసత్వం",
        wcu4D: "వచ్చే తరాల కోసం భద్రపరచిన వీడియో సందేశాలు, చివరి ఇష్ట ప్రకటనలు.",
        wcu5T: "పత్రాల నిల్వగది",
        wcu5D: "సర్టిఫికెట్లు, రిజిస్ట్రీ పత్రాలు, ఇతర డాక్యుమెంట్లు — సమగ్రమైన క్రమంలో, గుప్తీకరించి.",
        wcuCtaT: "ఈ రోజే మీ కుటుంబ వారసత్వాన్ని ప్రారంభించండి",
        wcuCtaD: "ప్రారంభం ఉచితం — మీ మొబైల్ నంబర్ చాలు. మీ మనవలు, మనవరాళ్లు మీకు కృతజ్ఞతలు చెబుతారు.",
        wcuCtaBtn: "ఉచితంగా ప్రారంభించండి",
        jfEyebrow: "మీ ప్రయాణం",
        jfHeading: "ఈ రోజు నుంచి ఎప్పటికీ — మూడు సులభమైన దశలు",
        jfSub: "చాలా కుటుంబాలు మొదటి దశను రెండో నిమిషం లోపే పూర్తి చేస్తారు. కానీ ప్రయాణం మాత్రం జీవితాంతం కొనసాగుతుంది.",
        jf1T: "మీ కుటుంబాన్ని జోడించండి",
        jf1D: "60 సెకండ్లలో మొబైల్ OTP తో సైన్ అప్. తల్లిదండ్రులు, జీవిత భాగస్వామి, పిల్లలను ఒక్కొక్కరిగా జోడించండి — టైప్ చేయడం నెమ్మదిగా అనిపిస్తే, వారి పేర్లు హిందీ/మరాఠీ లో మాట్లాడవచ్చు.",
        jf1B1: "ఎప్పటికీ పాస్వర్డ్ అవసరం లేదు",
        jf1B2: "10 భారతీయ భాషల్లో వాయిస్ ఇన్‌పుట్",
        jf1B3: "సంబంధాలు ఆటోమేటిక్‌గా నింపడం",
        jf2T: "కథలు & ఫోటోలు కాప్చర్ చేయండి",
        jf2D: "మీ దాదీ కథలను రికార్డ్ చేయండి, పెళ్లి & పండుగ ఫోటోలు అప్‌లోడ్ చేయండి, ఆల్బములుగా సర్దండి. AI మీ భాషలో వాయిస్‌ను టెక్స్ట్‌గా మారుస్తుంది.",
        jf2B1: "ఆడియో + ఫోటోలు + డాక్యుమెంట్లు",
        jf2B2: "మీ ట్రీలోని వ్యక్తులను ట్యాగ్ చేయండి",
        jf2B3: "Whisper ట్రాన్స్క్రిప్షన్",
        jf3T: "ఎప్పటికీ నిలుపుకోండి, సురక్షితంగా పంచుకోండి",
        jf3D: "ఎన్‌క్రిప్ట్ చేసిన భారతీయ సర్వర్లలో భద్రపరిచిన సేకరణ. ఆడియోతో విల్ డ్రాఫ్ట్‌లు తయారుచేయండి. మనవలు, మనవరాళ్ల కోసం టైమ్ క్యాప్సూల్‌లను ప్లాన్ చేయండి. రూపకల్పన నుంచే DPDPకి అనుగుణంగా.",
        jf3B1: "AES-256 ఎన్‌క్రిప్షన్",
        jf3B2: "బయోమెట్రిక్‌తో రక్షించిన వాల్ట్‌లు",
        jf3B3: "శాశ్వతంగా మీ కుటుంబంలోనే ఉంటుంది",
        jfCta: "దశ 1ను ఇప్పుడు మొదలుపెట్టండి",
        jfNote: "మొదటి 25 కుటుంబ సభ్యులకు ఎప్పటికీ ఉచితం. మీ అవసరాలు పెరిగినప్పుడు మాత్రమే అప్గ్రేడ్ చేసుకోండి.",
        featEyebrow: "లక్షణాలు",
        featHeading: "కుటుంబం కలిసి గుర్తుంచుకోవడానికి కావాల్సిన ప్రతిదీ",
        wwhEyebrow: "ఒక జాగ్రత్త చేసే కథ",
        wwhTitleA: "ఏమవుతుంది",
        wwhTitleB: "మన కథను భద్రపరచకపోతే?",
        wwhHintDesktop: "ప్రతి 3 సెకండ్లకు ఆటో-ప్లే · ఆపేందుకు హోవర్ చేయండి · చూసేందుకు స్వైప్, ← → లేదా డాట్స్ ఉపయోగించండి.",
        wwhHintMobile: "ఆటో-ప్లే · చూసేందుకు స్వైప్ చేయండి.",
        ppHeading: "కుటుంబ చరిత్రను భద్రపరచకపోతే ఏమవుతుంది?",
        pp1: "ముదుసలి వారి జ్ఞాపకాలు శాశ్వతంగా కనుమరుగవుతాయి",
        pp2: "పాత ఫోటోలు పోతాయి లేదా పాడైపోతాయి",
        pp3: "పిల్లలు తమ మూలాలతో అనుబంధాన్ని కోల్పోతారు",
        pp4: "ప్రతి తరం గడుస్తున్న కొద్దీ సంప్రదాయాలు వెలిసిపోతాయి",
        tEyebrow: "ప్రశంసలు",
        tHeadA: "దేశమంతటా ఉన్న కుటుంబాలు –",
        tIndia: "భారతదేశం",
        tHeadB: "మమ్మల్ని నమ్మండి",
        tSub: "నిజమైన కుటుంబాలు, నిజ జీవిత కథలు — శాశ్వతంగా భద్రం.",
        faqHeading: "తరచూ అడిగే ప్రశ్నలు",
        faq1Q: "మా కుటుంబ సమాచారం సురక్షితంగానే ఉందా?",
        faq1A: "అవును. బ్యాంకు-స్థాయి AES-256 ఎన్క్రిప్షన్ (storage వద్ద), httpOnly cookie ధృవీకరణ, Document & Legal Vault‌కు ఐచ్ఛిక fingerprint/Face ID రక్షణ, భారతదేశంలో ఉన్న MongoDB storage.",
        faq2Q: "NRI కుటుంబాలు దీన్ని ఉపయోగించగలరా?",
        faq2A: "ఖచ్చితంగా. బహుళ టైమ్‌జోన్‌లు, 10 భారతీయ భాషల్లో బ్రౌజర్ language ఆటో-డిటెక్షన్, ప్రతి బంధువు ఎక్కడ ఉంటున్నాడో చూపించే Family World Map విడ్జెట్.",
        faq3Q: "పెద్దలకి ఇది సులభంగా ఉంటుందా?",
        faq3A: "అవును. Senior Mode‌లో కేవలం 3 పెద్ద బటన్లు మాత్రమే కనిపిస్తాయి (Photos / Story / Family). 22px ఫాంట్, పెద్ద ట్యాప్ టార్గెట్లు, ముందుగా వాయిస్-రికార్డింగ్ ఎంపిక.",
        faq4Q: "మేము 100+ కుటుంబ సభ్యులను జోడించగలమా?",
        faq4A: "Free ప్లాన్‌లో 25 మంది వరకు. Family ₹999/yr ప్లాన్‌లో అమితమైన సభ్యులు + 10 GB స్టోరేజ్. Legacy ₹2999/yr‌లో Legal Vault, 100 GB, ముద్రించిన ఫ్యామిలీ ట్రీ, మరియు ప్రాధాన్య సహాయం ఉంటాయి.",
        faq5Q: "ఏఏ భాషలు అందుబాటులో ఉన్నాయి?",
        faq5A: "English, Hindi, Marathi, Tamil, Telugu, Kannada, Malayalam, Bengali, Gujarati మరియు Punjabi — పూర్తి UI అనువాదం, మొదటి సందర్శనలో బ్రౌజర్ భాష ఆటో-డిటెక్షన్‌తో.",
        faq6Q: "మా సమాచారాన్ని ఎక్స్‌పోర్ట్ చేసుకోవచ్చా?",
        faq6A: "అవును. Settings → My Data → Download All My Data ద్వారా మీ ట్రీ, జ్ఞాపకాలు, కథలు, మరియు డాక్యుమెంట్‌లు అన్నీ ఒక్క ఆర్కైవ్‌గా (DPDP-compliant) ఎక్స్‌పోర్ట్ అవుతాయి.",
        faq7Q: "ఉచిత ప్లాన్ తర్వాత ఏమవుతుంది?",
        faq7A: "ఇక్కడ ట్రయల్ లేదు — Free ప్లాన్ శాశ్వతం. 25 మందికంటే ఎక్కువ సభ్యులు, AI biography లేదా Legal Vault అవసరమైనప్పుడు మాత్రమే అప్‌గ్రేడ్ చేయండి. వార్షిక ప్లాన్‌లపై 7 రోజుల grace period మరియు పూర్తి money-back హామీ ఉంది.",
        faq8Q: "అనేక మంది కుటుంబ సభ్యులు కలిసి జోడించగలరా?",
        faq8A: "అవును. అన్నదమ్ములు, తల్లిదండ్రులు, మరిది/బంధువులను మొబైల్ నెంబర్ ద్వారా ఆహ్వానించండి. ప్రతి ఒక్కరికీ ఒక పాత్ర ఉంటుంది: Family Head / Editor / Viewer — ప్రతి డాక్యుమెంట్‌కి విడిగా privacy నియంత్రణలు ఉంటాయి.",
        mscTitle: "ఉచితం · Mobile OTP సైన్‌అప్",
        mscDpdp: "DPDP కు అనుగుణంగా",
        mscStart: "ఉచితంగా ప్రారంభించండి",
        qrEyebrow: "మీ కుటుంబాన్ని మీతో తీసుకెళ్లండి",
        qrHeading: "ఒక్కసారి స్కాన్ చేయండి. మీ ఫోన్లో కుటుంబ Repository.",
        qrSub: "యాప్ ఇన్‌స్టాల్ చేయడానికి QR కోడ్‌పై మీ కెమెరాను చూపించండి. Android, iPhone రెండింటిలో పని చేస్తుంది — మేము మీకు సరైన స్టోర్‌ను ఆటోమేటిక్‌గా గుర్తిస్తాము.",
        qrLi1: "Android & iPhone పై ఒక్క ట్యాప్‌తో ఇన్‌స్టాల్",
        qrLi2: "iOS 14+ — App Store",
        qrLi3: "Android 8+ — Google Play",
        qrOrVisit: "లేదా సందర్శించండి",
        ftEyebrow: "ఇంటితో దగ్గరగా ఉండండి",
        ftHeadline: "మీ కుటుంబ వారసత్వాన్ని కాపాడుకోండి.",
        ftJoinA: "చేరండి",
        ftJoinB: "భారతీయ కుటుంబాలతో.",
        ftNewsDesc: "వారసత్వ కథలు, సంస్కృతి విశేషాలు, ఇంకా ఉత్పత్తి సమాచారం — పదిహేను రోజులకు ఒక్కసారి. ఎప్పుడూ స్పామ్ ఉండదు.",
        ftSubscribe: "చందా తీసుకోండి",
        ftJoining: "చేరుతున్నాం…",
        ftDpdpNote: "DPDP కు అనుగుణంగా · మీ డేటాను మేము ఎప్పుడూ అమ్మం",
        ftBrandDesc: "భారత కుటుంబాల కోసం, పూర్తిగా ప్రైవేట్, భారత్-ముందు స్థలం — ఇక్కడ మీరు మీ కుటుంబ కథలను భద్రపరచవచ్చు, పెద్దల గొంతుస్వరాలను రికార్డ్ చేయవచ్చు, మీ వారసత్వాన్ని తరతరాలకు అందించవచ్చు.",
        colCompany: "కంపెనీ",
        colFtServices: "ఫ్యామిలీ ట్రీ సేవలు",
        colAdminSupport: "అడ్మిన్ సహాయం",
        colProduct: "ఉత్పత్తులు / సేవలు",
        colSupport: "సహాయం మరియు మద్దతు",
        colLegal: "న్యాయ సంబంధిత",
        colTechnical: "సాంకేతిక",
        colMethodology: "పద్ధతి / అనుసరణ",
        badgeMii: "మెడ్ ఇన్ ఇండియా · ముంబైలో నిర్మించబడింది",
        badgeDpdp: "DPDP Act 2023 కు అనుగుణం",
        badgeIso: "ISO 27001 సర్టిఫైడ్",
        badgeSoc: "SOC 2 సర్టిఫైడ్",
        badgeEnc: "బ్యాంకు-స్థాయి గుప్తీకరణ",
        wcu6T: "ఆరోగ్య సమాచార నిధి",
        wcu6D: "కుటుంబ ఆరోగ్య చరిత్ర, వ్యాధి వివరాలు, రక్తగ్రూపులు — ఒకేచోట.",
        wcu7T: "కుటుంబ క్యాలెండర్ & గుర్తుచేప్పులు",
        wcu7D: "పుట్టినరోజులు, వార్షికోత్సవాలు, శ్రాద్ధలు, పండుగలు — ఏదీ మిస్సవకుండా.",
        wcu8T: "చట్టపరమైన & వారసత్వ పత్రాల నిల్వ",
        wcu8D: "ఇచ్చాపత్రాలు, నామినీలు, వారసత్వ వివరాలు — అవసరమైనప్పుడు సిద్ధంగా.",
        wcu9T: "సంప్రదాయాలు & ఆచారాలు",
        wcu9D: "మీ కుటుంబంలో ఎలా చేస్తారు అన్నది — మర్చి పోయే ముందు వ్రాసి ఉంచుకోవడానికి.",
        wcu10T: "వంటకాలు & కుటుంబ భోజనం",
        wcu10D: "మీ కుటుంబంలో మాత్రమే చేసే ప్రత్యేక వంటకాలు — వాటి వెనకున్న కథలతో కలిసి భద్రపరచండి.",
        wcu11T: "ప్రదేశాలు & పూర్వీకుల గ్రామం",
        wcu11D: "మీ వేర్లు పటంలో — గ్రామం, ఇల్లు మరియు ప్రపంచం మీద చేసిన ప్రయాణాలు.",
        wcu12T: "కుటుంబ రాజ్యాంగం & విలువలు",
        wcu12D: "మీ కుటుంబం అనుసరించే సూత్రాలు — అందరూ అంగీకరించి, నమోదు చేసుకున్నవి.",
        wcu13T: "టైమ్ క్యాప్సుల్",
        wcu13D: "ఈరోజు రాసిన సందేశాలు, మీరు ఎంచుకున్న తేదీన తెరవబడేలా మూసివేయబడతాయి.",
        wcu14T: "కుటుంబ విజయాలు & వీరులు",
        wcu14D: "మైలురాళ్లు, గౌరవాలు మరియు మీ కుటుంబంలోని తెలియని వీరులు.",
        wcu15T: "జీవితచరిత్ర & జ్ఞాపకాలు",
        wcu15D: "మన నిపుణ రచయితల సహాయంతో పూర్తిగా రాసిన జీవితకథలు.",
        wcu16T: "AI కుటుంబ సాధనాలు",
        wcu16D: "వ్రాయడానికి, ఫోటోలను పునరుద్ధరించడానికి, డాక్యుమెంటరీలు తయారు చేయడానికి స్నిగ్ధమైన AI సహాయం.",
        wcuSub: "మీ కుటుంబానికి అవసరమైన పదహారు రోజువారీ విషయాలు — అంతా ఒకే వ్యక్తిగత, సురక్షిత గృహంలో.",
    },
    kn: {
        heroFamiliesTrust: "ಭಾರತೀಯ ಕುಟುಂಬಗಳು ನಮ್ಮನ್ನು ನಂಬುತ್ತವೆ",
        heroTitleA: "ನಿಮ್ಮ ಕುಟುಂಬದ ಇತಿಹಾಸ",
        heroTitleB: "ಸಂಗ್ರಹವಾಗಿರುತ್ತದೆ",
        heroTitleC: "ಯಾವತ್ತಿಗೂ.",
        heroSub: "ನಿಮ್ಮ ಕುಟುಂಬ ವಂಶಾವಳಿ ಮರವನ್ನು ಕಟ್ಟಿಕೊಳ್ಳಿ, ಹಿರಿಯರ ಮಾತು/ಸ್ಮೃತಿಗಳನ್ನು ದಾಖಲಿಸಿ, ಫೋಟೋಗಳು ಮತ್ತು ದಾಖಲೆಗಳನ್ನು ಉಳಿಸಿಕೊಳ್ಳಿ — ಇವೆಲ್ಲವೂ ಭಾರತೀಯ ಕುಟುಂಬಗಳಿಗೆ ಸೂಕ್ತವಾದ, ನಿಮ್ಮದೇ ಭಾಷೆಯ ಖಾಸಗಿ ಜಾಗದಲ್ಲಿ.",
        heroCtaStart: "ಮೊಬೈಲ್ OTP ಮೂಲಕ ಉಚಿತವಾಗಿ ಆರಂಭಿಸಿ",
        heroCtaHow: "ಇದು ಹೇಗೆ ಕೆಲಸ ಮಾಡುತ್ತದೆ ನೋಡಿ",
        trustPrivate: "ಡೀಫಾಲ್ಟ್‌ನಲ್ಲೇ ಖಾಸಗಿ",
        trustLangs: "10 ಭಾರತೀಯ ಭಾಷೆಗಳು",
        trustFree: "ಆರಂಭಿಸಲು ಉಚಿತ",
        fsdTitle: "ಮೊಬೈಲ್ OTP ಮೂಲಕ ಉಚಿತವಾಗಿ ಆರಂಭಿಸಿ",
        fsdSub: "ಒಂದು ನಿಮಿಷದಲ್ಲೇ ಪ್ರಾರಂಭಿಸಿ — ಸಂಪೂರ್ಣ ಉಚಿತ.",
        fsdP1T: "100% ಉಚಿತ ಆರಂಭ",
        fsdP1D: "ಯಾವುದೇ ಕ್ರೆಡಿಟ್ ಕಾರ್ಡ್ ಬೇಡ, ಯಾವುದೇ ಮರೆಮಾಡಿದ ಶುಲ್ಕಗಳಿಲ್ಲ. ಉಚಿತ ಯೋಜನೆಯಲ್ಲಿ ಕುಟುಂಬ ವಂಶಾವಳಿ, ಫೋಟೋಗಳು ಮತ್ತು ಕಥೆಗಳು ಸೇರಿವೆ.",
        fsdP2T: "ನಿಮ್ಮ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ಮಾತ್ರ",
        fsdP2D: "ನಿಮ್ಮ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ → OTP ಸ್ವೀಕರಿಸಿ → ಆಗಲೇ ಒಳಗೆ. ನೆನಪಿಡಬೇಕಾದ ಇಮೇಲ್ ಅಥವಾ ಪಾಸ್‌ವರ್ಡ್ ಬೇಡ.",
        fsdP3T: "ನಿಮ್ಮ ಗೌಪ್ಯತೆ ಮೊದಲು",
        fsdP3D: "ಡೀಫಾಲ್ಟ್‌ನಲ್ಲೇ ಖಾಸಗಿ — ನಿಮ್ಮ ಮಾಹಿತಿಯನ್ನು ನೋಡುವವರು ನಿಮ್ಮ ಕುಟುಂಬದವರು ಮಾತ್ರ.",
        fsdContinue: "ಮುಂದುವರಿಸಿ — ಉಚಿತವಾಗಿ ಆರಂಭಿಸಿ",
        fsdLater: "ನಂತರ ನೋಡೋಣ",
        dbTitle: "ಉತ್ಪನ್ನ ಡೆಮೊಗಳು ಮತ್ತು ರೀಲ್ಸ್",
        dbSub: "ಸಂಪೂರ್ಣ ಕುಟುಂಬ ವೃಕ್ಷ, ನೆನಪುಗಳು, ವಾಲ್ಟ್ ಮತ್ತು ಸಂಸ್ಕೃತಿ ವೈಶಿಷ್ಟ್ಯಗಳು ಹೇಗೆ ಕೆಲಸ ಮಾಡುತ್ತವೆ ಎಂಬುದನ್ನು — ಚಿಕ್ಕ ವಿಡಿಯೋಗಳಲ್ಲಿ ನೋಡಿ.",
        dbBtn: "ಡೆಮೊಗಳನ್ನು ನೋಡಿ",
        dpHeading: "ಡೆಮೊಗಳು, ರೀಲ್ಸ್ ಮತ್ತು ಡಾಕ್ಯುಮೆಂಟರಿಗಳು",
        dpSub: "ಸಂಪೂರ್ಣ ಕುಟುಂಬ ವೃಕ್ಷ ನಿರ್ಮಾಣದಿಂದ ಹಿಡಿದು ಲೆಗಸಿ ವಾಲ್ಟ್‌ವರೆಗಿನ — ಪ್ರತಿಯೊಂದು ಉತ್ಪನ್ನ ಮತ್ತು ಸೇವೆಗೆ ಡೆಮೊ.",
        dpFeaturedTag: "ಪ್ರಮುಖ ಡೆಮೊ",
        dpAll: "ಎಲ್ಲ",
        dpComingSoon: "ವೀಡಿಯೊ ಶೀಘ್ರದಲ್ಲೇ ಬರುತ್ತಿದೆ",
        navHome: "ಮುಖ್ಯಪುಟ",
        navAbout: "ನಮ್ಮ ಬಗ್ಗೆ",
        navProducts: "ಉತ್ಪನ್ನಗಳು ಮತ್ತು ಸೇವೆಗಳು",
        navHowItWorks: "ಹೇಗೆ ಕೆಲಸ ಮಾಡುತ್ತದೆ",
        navFeatures: "ವೈಶಿಷ್ಟ್ಯಗಳು",
        navSolutions: "ಉಪಾಯಗಳು",
        navHelp: "ಸಹಾಯ",
        navPackage: "ಪ್ಯಾಕೇಜ್",
        navResources: "ಮಾಹಿತಿ ಸಂಪನ್ಮೂಲಗಳು",
        navPricing: "ಬೆಲೆಪಟ್ಟಿ",
        navDemos: "ಡೆಮೊಗಳು",
        accMenuLabel: "ಹಿರಿಯರ ಕ್ರಮ",
        accSenior: "ಹಿರಿಯರ ಮೋಡ್",
        accSeniorDesc: "ಹಿರಿಯರಿಗೆ ದೊಡ್ಡ ಅಕ್ಷರಗಳು ಮತ್ತು ಗುಂಡಿಗಳು",
        accTextSize: "ಅಕ್ಷರದ ಗಾತ್ರ",
        howEyebrow: "ಇದು ಹೇಗೆ ಕೆಲಸ ಮಾಡುತ್ತದೆ",
        howHeading: "ಕುಟುಂಬ ವಂಶವೃಕ್ಷ ರಚಿಸಲು ಸರಳ 5 ಹಂತಗಳು",
        how1T: "ಕುಟುಂಬದ ಮುಖ್ಯಸ್ಥರಾಗಿ ಲಾಗಿನ್ ಆಗಿ",
        how1D: "ಕುಟುಂಬ ಮುಖ್ಯಸ್ಥರಾಗಿ ನಿಮ್ಮ ವಿವರಗಳಿಂದ ಸೈನ್ ಇನ್ ಆಗಿ ಮತ್ತು ನಿಮ್ಮ ಕುಟುಂಬದ ಪರಂಪರೆಯನ್ನು ನೀವು ಸ್ವತಃ ನೋಡಿಕೊಳ್ಳಿ.",
        how2T: "ಕುಟುಂಬ ಸದಸ್ಯರನ್ನು ಸೇರಿಸಿ",
        how2D: "ತಾಯಿ-ತಂದೆ, ಅಜ್ಜ-ಅಜ್ಜಿ, ಮಕ್ಕಳು ಮತ್ತು ಜೀವನ ಸಂಗಾತಿಗಳನ್ನು ಸೇರಿಸಿ, ಸಂಪೂರ್ಣ ಕುಟುಂಬ ವೃಕ್ಷವನ್ನು ನಿರ್ಮಿಸಿ.",
        how3T: "ಸ್ಮೃತಿಗಳು ಮತ್ತು ಕಥೆಗಳನ್ನೂ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ",
        how3D: "ಪಠ್ಯ, ಚಿತ್ರಗಳು ಮತ್ತು ಧ್ವನಿಗಳನ್ನು ಸಂರಕ್ಷಿಸಿ — ಪ್ರತಿಯೊಂದು ನೆನಪಿಗೂ ಇಲ್ಲಿ ಸುರಕ್ಷಿತ ಸ್ಥಳ ಸಿಗುತ್ತದೆ.",
        how4T: "ಕುಟುಂಬದವರ ಜೊತೆ ಹಂಚಿಕೊಳ್ಳಿ",
        how4D: "ಹಿತೈಷಿಗಳನ್ನು ಆಹ್ವಾನಿಸಿ, ಎಲ್ಲರೂ ನೋಡಿ, ಪುನಃ ಅನುಭವಿಸಿ ಮತ್ತು ತಮ್ಮ ನೆನಪುಗಳನ್ನು ಸೇರಿಸಿಕೊಳ್ಳುವಂತೆ ಮಾಡಿ.",
        how5T: "ಮುಂದಿನ ಪೀಳಿಗೆ ಪರಂಪರೆಯನ್ನು ಮುಂದುವರಿಸಿ ಸಾಗಿಸುತ್ತದೆ",
        how5D: "ನಿಮ್ಮ ಮಕ್ಕಳು ಮತ್ತು ಮೊಮ್ಮಕ್ಕಳು ಈ ಸಂಪ್ರದಾಯವನ್ನು ಮುಂದುವರಿಸುತ್ತಾರೆ — ಪರಂಪರೆ ಎಂದಿಗೂ ನಿಲ್ಲುವುದಿಲ್ಲ.",
        wcuEyebrow: "ಕುಟುಂಬಗಳು ನಮ್ಮನ್ನು ಏಕೆ ಆರಿಸುತ್ತಾರೆ",
        wcuHeading: "ನಿಮ್ಮ ಕುಟುಂಬಕ್ಕೆ ಅಮೂಲ್ಯವಾದ ಎಲ್ಲದರಿಗೂ ಒಂದೇ ಮನೆ",
        wcu1T: "ಕುಟುಂಬ ವಂಶವೃಕ್ಷ",
        wcu1D: "ಆರು ತಲೆಮಾರುಗಳು, ಪ್ರತೀ ಶಾಖೆ — ಯಾರಿಗೂ ಸುಲಭವಾಗಿ ಓದಲಾಗುವ ಮರದ ರೂಪದಲ್ಲಿ.",
        wcu2T: "ಫೋಟೋಗಳು ಮತ್ತು ನೆನಪುಗಳು",
        wcu2D: "ಫೋಟೋಗಳು, ಟಿಪ್ಪಣಿಗಳು ಮತ್ತು ಕ್ಷಣಗಳನ್ನು ಸುರಕ್ಷಿತವಾಗಿ ಸಂಗ್ರಹಿಸಿ, ಸುಲಭವಾಗಿ ಹುಡುಕಬಹುದಾದಂತೆ.",
        wcu3T: "ಧ್ವನಿ ಮತ್ತು ಆಡಿಯೋ ಕಥೆಗಳು",
        wcu3D: "ಹಿರಿಯರನ್ನೇ ಅವರದೇ ಶಬ್ದದಲ್ಲಿ, ಅವರದೇ ಭಾಷೆಯಲ್ಲಿ ದಾಖಲಿಸಿ.",
        wcu4T: "ವೀಡಿಯೋ ಪರಂಪರೆ",
        wcu4D: "ಮುಂದಿನ ತಲೆಮಾರುಗಳಿಗಾಗಿ ಉಳಿಸಿರಬಹುದಾದ ವೀಡಿಯೋ ಸಂದೇಶಗಳು ಹಾಗೂ ವಚನಗಳು.",
        wcu5T: "ದಾಖಲೆಗಳ ಸಂಗ್ರಹ ಕೋಣೆ",
        wcu5D: "ಸಾಕ್ಷ್ಯಪತ್ರಗಳು, ಹಕ್ಕುಪತ್ರಗಳು ಹಾಗೂ ಇತರೆ ಕಾಗದಗಳನ್ನು — ಸರಿಯಾಗಿ ಜೋಡಿಸಿ, ಗುಪ್ತೀಕರಿಸಿ.",
        wcuCtaT: "ಇಂದೇ ನಿಮ್ಮ ಕುಟುಂಬದ ಪರಂಪರೆಯನ್ನು ಆರಂಭಿಸಿ",
        wcuCtaD: "ಪ್ರಾರಂಭಿಸಲು ಸಂಪೂರ್ಣ ಉಚಿತ — ನಿಮ್ಮ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯಷ್ಟೇ ಸಾಕು. ನಿಮ್ಮ ಮೊಮ್ಮಕ್ಕಳು ನಿಮಗೆ ಕೃತಜ್ಞರಾಗಿರುತ್ತಾರೆ.",
        wcuCtaBtn: "ಉಚಿತವಾಗಿ ಆರಂಭಿಸಿ",
        jfEyebrow: "ನಿಮ್ಮ ಪ್ರಯಾಣ",
        jfHeading: "ಇಂದಿನಿಂದ ಸದಾಕಾಲದವರೆಗೆ — ಕೇವಲ ಮೂರು ಸರಳ ಹಂತಗಳು",
        jfSub: "ಬಹುತೇಕ ಕುಟುಂಬಗಳು ಮೊದಲ ಹಂತವನ್ನು ಎರಡು ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ ಸಮಯದಲ್ಲಿ ಪೂರ್ಣಗೊಳಿಸುತ್ತವೆ. ಆದರೆ ಈ ಪ್ರಯಾಣವೇ ಜೀವನಪರ್ಯಂತ ಮುಂದುವರಿಯಬಹುದು.",
        jf1T: "ನಿಮ್ಮ ಕುಟುಂಬವನ್ನು ಸೇರಿಸಿ",
        jf1D: "ಮೊಬೈಲ್ OTP ಮೂಲಕ 60 ಸೆಕೆಂಡ್‍ಗಳಲ್ಲಿ ಸೈನ್ ಅಪ್. ಪಾಲಕರು, ಜೀವನಸಂಗಾತಿ, ಮಕ್ಕಳು ಅವರನ್ನು ತಲಾ ಒಬ್ಬರಂತೆ ಸೇರಿಸಿ — ಟೈಪ್ ಮಾಡಲು ನಿಧಾನವೆನಿಸಿದರೆ ಅವರ ಹೆಸರುಗಳನ್ನು ಹಿಂದಿ/ಮರಾಠಿಯಲ್ಲಿ ಬಾಯಾರಿಸಿ ಹೇಳಬಹುದು.",
        jf1B1: "ಪಾಸ್‌ವರ್ಡ್ ಬೇಕಾಗುವುದೇ ಇಲ್ಲ",
        jf1B2: "10 ಭಾರತೀಯ ಭಾಷೆಗಳಲ್ಲಿ ಧ್ವನಿ ನಮೂದು",
        jf1B3: "ಸಂಬಂಧಗಳನ್ನು ಸ್ವಯಂ‑ಪೂರ್ತಿ ಮಾಡುತ್ತದೆ",
        jf2T: "ಕಥೆಗಳು ಮತ್ತು ಫೋಟೋಗಳನ್ನು ಸಂಗ್ರಹಿಸಿ",
        jf2D: "ನಿಮ್ಮ ದಾದಿಯ ಕಥೆಗಳನ್ನು ರೆಕಾರ್ಡ್ ಮಾಡಿ, ಮದುವೆ ಮತ್ತು ಹಬ್ಬದ ಫೋಟೋಗಳನ್ನು ಅಪ್ಲೋಡ್ ಮಾಡಿ, ಆಲ್ಬಮ್‌ಗಳಾಗಿ ಅಡ್ಡಗಟ್ಟಿರಿ. AI ನಿಮ್ಮ ಭಾಷೆಯಲ್ಲೇ ಧ್ವನಿಯನ್ನು ಬರಹಕ್ಕೆ ರೂಪಾಂತರಿಸುತ್ತದೆ.",
        jf2B1: "ಆಡಿಯೋ + ಫೋಟೋಗಳು + ದಾಖಲೆಗಳು",
        jf2B2: "ನಿಮ್ಮ ವಂಶವೃಕ್ಷದಲ್ಲಿನ ಜನರನ್ನು ಟ್ಯಾಗ್ ಮಾಡಿ",
        jf2B3: "Whisper ಲಿಖಿತರೂಪಕ್ಕೆ ಪರಿವರ್ತನೆ",
        jf3T: "ಶಾಶ್ವತವಾಗಿ ಉಳಿಸಿ, ಸುರಕ್ಷಿತವಾಗಿ ಹಂಚಿಕೊಳ್ಳಿ",
        jf3D: "ಭಾರತದಲ್ಲಿನ ಎನ್‌ಕ್ರಿಪ್ಟ್ ಮಾಡಿದ ಸರ್ವರ್‌ ಸಂಗ್ರಹಣೆ. ಧ್ವನಿಯ ಮೂಲಕ ವಿಲ್‌ ಮಸೂದೆಗಳನ್ನು ರಚಿಸಿ. ಮೊಮ್ಮಕ್ಕಳಿಗಾಗಿ ಟೈಮ್–ಕ್ಯಾಪ್‌ಸುಲ್‌ಗಳನ್ನು ಸಮಯ ನಿಗದಿ ಮಾಡಿ. ವಿನ್ಯಾಸದಲ್ಲೇ DPDP ಅನುಸರಣೆಯಿದೆ.",
        jf3B1: "AES-256 ಎನ್‌ಕ್ರಿಪ್ಷನ್",
        jf3B2: "ಬಯೋಮೆಟ್ರಿಕ್‌ ರಕ್ಷಿತ ಸೈಫ್‌ ವಾಲ್ಟ್‌ಗಳು",
        jf3B3: "ಯಾವಾಗಲೂ ನಿಮ್ಮ ಕುಟುಂಬದಲ್ಲೇ ಉಳಿಯುತ್ತದೆ",
        jfCta: "ಈಗಲೇ ಹಂತ 1 ಆರಂಭಿಸಿ",
        jfNote: "ಮೊದಲ 25 ಕುಟುಂಬ ಸದಸ್ಯರಿಗೆ ಸದಾಕಾಲ ಉಚಿತ. ನಿಮಗೆ ಸಾಕಾಗದಾಗ ಮಾತ್ರ ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಿ.",
        featEyebrow: "ವೈಶಿಷ್ಟ್ಯಗಳು",
        featHeading: "ಕುಟುಂಬ ಒಟ್ಟಾಗಿ ನೆನಪಿಡಲು ಬೇಕಾದ ಎಲ್ಲವೂ ಇಲ್ಲಿ",
        wwhEyebrow: "ಒಂದು ಎಚ್ಚರಿಸುವ ಕಥೆ",
        wwhTitleA: "ಏನು ಆಗಬಹುದು",
        wwhTitleB: "ನಾವು ನಮ್ಮ ಕಥೆಯನ್ನು ಉಳಿಸಿಕೊಳ್ಳದಿದ್ದರೆ?",
        wwhHintDesktop: "ಪ್ರತಿ 3 ಸೆಕೆಂಡಿಗೆ ಸ್ವಯಂಚಾಲಿತವಾಗಿ ಪ್ಲೇ ಆಗುತ್ತದೆ · ನಿಂತಿರಿಸಲು ಹೋವರ್ ಮಾಡಿ · ಬ್ರೌಸ್ ಮಾಡಲು ಸ್ವೈಪ್, ← → ಅಥವಾ ಡಾಟ್‌ಗಳನ್ನು ಬಳಸಿ.",
        wwhHintMobile: "ಸ್ವಯಂಚಾಲಿತವಾಗಿ ಪ್ಲೇ ಆಗುತ್ತದೆ · ಬ್ರೌಸ್ ಮಾಡಲು ಸ್ವೈಪ್ ಮಾಡಿ.",
        ppHeading: "ಕುಟುಂಬದ ಇತಿಹಾಸವನ್ನು ಉಳಿಸದಿದ್ದರೆ ಏನು ಆಗುತ್ತದೆ?",
        pp1: "ಹಿರಿಯರ ನೆನಪುಗಳು ಶಾಶ್ವತವಾಗಿ ಕಣ್ಮರೆಯಾಗುತ್ತವೆ",
        pp2: "ಹಳೆಯ ಫೋಟೋಗಳು ಕಳೆದುಹೋಗುತ್ತವೆ ಅಥವಾ ಹಾನಿಗೊಳಗಾಗುತ್ತವೆ",
        pp3: "ಮಕ್ಕಳು ತಮ್ಮ ಬೇರುಗಳ ಜೊತೆಯ ಸಂಪರ್ಕ ಕಳೆದುಕೊಳ್ಳುತ್ತಾರೆ",
        pp4: "ಪ್ರತಿ ತಲೆಮಾರಿನೊಡನೆ ಪರಂಪರೆ ನಿಧಾನವಾಗಿ ಮಾಯವಾಗುತ್ತದೆ",
        tEyebrow: "ಅಭಿಪ್ರಾಯಗಳು",
        tHeadA: "ಇಡೀ",
        tIndia: "ಭಾರತದ ಕುಟುಂಬಗಳು",
        tHeadB: "ನಮ್ಮ ಮೇಲೆ ನಂಬಿಕೆ ಇಡಿ",
        tSub: "ನಿಜವಾದ ಕುಟುಂಬಗಳು, ನಿಜವಾದ ಜೀವನ ಕಥೆಗಳು – ಸದಾಕಾಲಕ್ಕೂ ಉಳಿಯುವಂತೆ.",
        faqHeading: "ಹೆಚ್ಚಾಗಿ ಕೇಳಲಾಗುವ ಪ್ರಶ್ನೆಗಳು",
        faq1Q: "ನಮ್ಮ ಕುಟುಂಬದ ಮಾಹಿತಿ ಸುರಕ್ಷಿತವೇ?",
        faq1A: "ಹೌದು. ಬ್ಯಾಂಕ್ ಮಟ್ಟದ AES-256 ಎನ್‌ಕ್ರಿಪ್ಷನ್‌ (ಬಿಟ್ಟ ನಂತರ ಡೇಟಾ ರಕ್ಷಣೆಗೆ), httpOnly ಕುಕಿ ದೃಢೀಕರಣ, Document & Legal Vault ಮೇಲೆ ಐಚ್ಚಿಕವಾಗಿ fingerprint / Face ID ಲಾಕ್, ಭಾರತದಲ್ಲಿಯೇ ಇರುವ MongoDB ಸಂಗ್ರಹಣೆ.",
        faq2Q: "NRI ಕುಟುಂಬಗಳು ಇದನ್ನು ಬಳಸಬಹುದೇ?",
        faq2A: "ಖಂಡಿತವಾಗಿ. ಹಲವಾರು ಕಾಲವಲಯಗಳಿಗೆ (multi-timezone) ಹೊಂದುವ ಸಹಾಯ, 10 ಭಾರತೀಯ ಭಾಷೆಗಳಲ್ಲಿ ಬ್ರೌಸರ್‌ನ ಭಾಷೆಯನ್ನು ಸ್ವಯಂ ಗುರುತಿಸುವ ವ್ಯವಸ್ಥೆ, ಮತ್ತು ಪ್ರತಿಯೊಬ್ಬ ಸಂಬಂಧಿ ಎಲ್ಲಿರುವರು ಎಂಬುದನ್ನು ತೋರಿಸುವ Family World Map ವಿಜೆಟ್ ಇದೆ.",
        faq3Q: "ಹಿರಿಯ ನಾಗರಿಕರಿಗೆ ಬಳಸಲು ಸುಲಭವೇ?",
        faq3A: "ಹೌದು. Senior Mode ನಲ್ಲಿ ಮೂರು ದೊಡ್ಡ ಬಟನ್‌ಗಳು ಮಾತ್ರ ಕಾಣಿಸುತ್ತವೆ (Photos / Story / Family). 22px ಅಕ್ಷರದ ಗಾತ್ರ, ದೊಡ್ಡ ಟಚ್ ಬಟನ್‌ಗಳು, ಮತ್ತು ಮೊದಲು ಧ್ವನಿ-ರೆಕಾರ್ಡಿಂಗ್‌ ಆಯ್ಕೆಯಿದೆ.",
        faq4Q: "ನಾವು 100+ ಸದಸ್ಯರನ್ನು ಸೇರಿಸಬಹುದೇ?",
        faq4A: "Free ಯೋಜನೆಯಲ್ಲಿ 25 ಸದಸ್ಯರ ತನಕ ಒಳಗೊಂಡಿದೆ; Family ₹999/ವರ್ಷ ಯೋಜನೆದಲ್ಲಿ ಅನಿಯಮಿತ ಸದಸ್ಯರು + 10 GB ಸಂಗ್ರಹಣೆ; Legacy ₹2999/ವರ್ಷ ಯೋಜನೆದಲ್ಲಿ Legal Vault, 100 GB, ಮುದ್ರಿತ ವಂಶವೃಕ್ಷ, ಮತ್ತು ಪ್ರಾಥಮ್ಯ ಸಹಾಯ (priority support) ದೊರಕುತ್ತದೆ.",
        faq5Q: "ಯಾವ ಭಾಷೆಗಳು ಲಭ್ಯ?",
        faq5A: "English, Hindi, Marathi, Tamil, Telugu, Kannada, Malayalam, Bengali, Gujarati ಮತ್ತು Punjabi — ಸಂಪೂರ್ಣ UI ಭಾಷಾಂತರ, ಮೊದಲು ಭೇಟಿ ನೀಡಿದಾಗ ಬ್ರೌಸರ್ ಭಾಷೆಯನ್ನು ಸ್ವಯಂ ಗುರುತಿಸಿ ಅದರಲ್ಲಿ ತೋರಿಸುತ್ತದೆ.",
        faq6Q: "ನಾವು ನಮ್ಮ ಡೇಟಾವನ್ನು ಹೊರತೆಗೆದುಕೊಳ್ಳಬಹುದೇ?",
        faq6A: "ಹೌದು. Settings → My Data → Download All My Data ಬಳಸಿ, ನಿಮ್ಮ ವಂಶವೃಕ್ಷ, ನೆನಪುಗಳು, ಕಥೆಗಳು ಮತ್ತು ಡಾಕ್ಯುಮೆಂಟ್‌ಗಳನ್ನು ಒಂದೇ ಆರ್ಕೈವ್​ ಫೈಲ್‌ನಲ್ಲಿ ರಫ್ತು ಮಾಡಬಹುದು (DPDP ನಿಯಮಗಳಿಗೆ ಅನುಗುಣ).",
        faq7Q: "Free ಯೋಜನೆಯ ನಂತರ ಏನು ಆಗುತ್ತದೆ?",
        faq7A: "ಇಲ್ಲಿ ಯಾವುದೂ ಟ್ರಯಲ್ ಇಲ್ಲ — Free ಯೋಜನೆ ಶಾಶ್ವತ. ನಿಮಗೆ 25 ಕ್ಕಿಂತ ಹೆಚ್ಚು ಸದಸ್ಯರು, AI biography ಅಥವಾ Legal Vault ಬೇಕಾಗುವಾಗ ಮಾತ್ರ ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಬಹುದು. ವಾರ್ಷಿಕ ಯೋಜನೆಗಳಿಗೆ 7 ದಿನಗಳ grace period ಮತ್ತು ಸಂಪೂರ್ಣ ಹಣ-ಹಿಂತಿರುಗಿಸುವ ಭರವಸೆ ಇದೆ.",
        faq8Q: "ಬಹಳಷ್ಟು ಕುಟುಂಬ ಸದಸ್ಯರು ಸೇರಿ ಬರೆಯಬಹುದೇ?",
        faq8A: "ಹೌದು. ಸಹೋದರರು, ತಂದೆ-ತಾಯಿ ಮತ್ತು ಮಾವ/ಮಾಮನವರು (ಸಂಬಂಧಿಕರು) ಅವರನ್ನು ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯಿಂದ ಆಹ್ವಾನಿಸಬಹುದು. ಪ್ರತಿ ವ್ಯಕ್ತಿಗೂ Family Head / Editor / Viewer ಎಂಬಾಗಿ ಪಾತ್ರ ನೀಡಬಹುದು — ಪ್ರತಿಯೊಂದು ಡಾಕ್ಯುಮೆಂಟಿಗೆ ಸೂಕ್ಷ್ಮ ಮಟ್ಟದ ಗೌಪ್ಯತಾ ನಿಯಂತ್ರಣಗಳಿವೆ.",
        mscTitle: "ಉಚಿತ · ಮೊಬೈಲ್ OTP ಸೈನ್‌ಅಪ್",
        mscDpdp: "DPDP ಅನುಸರಣೆ",
        mscStart: "ಉಚಿತವಾಗಿ ಪ್ರಾರಂಭಿಸಿ",
        qrEyebrow: "ನಿಮ್ಮ ಕುಟುಂಬವನ್ನು ನಿಮ್ಮ ಜೊತೆಯಲ್ಲಿ ಇಟ್ಟುಕೊಳ್ಳಿ",
        qrHeading: "ಒಮ್ಮೆ ಸ್ಕ್ಯಾನ್ ಮಾಡಿ. Family Repository ನೇರವಾಗಿ ನಿಮ್ಮ ಫೋನ್‌ನಲ್ಲಿ.",
        qrSub: "ಆ್ಯಪ್ ಇನ್‌ಸ್ಟಾಲ್ ಮಾಡಲು ನಿಮ್ಮ ಕ್ಯಾಮೆರಾವನ್ನು QR ಕೋಡ್ ಕಡೆ ತೋರಿಸಿ. Android ಮತ್ತು iPhone ಎರಡರಲ್ಲೂ ಕೆಲಸ ಮಾಡುತ್ತದೆ — ನಾವು ಸರಿಯಾದ ಸ್ಟೋರ್ ಅನ್ನು ಸ್ವಯಂ ಪಹಿಚಾನಿಸುತ್ತೇವೆ.",
        qrLi1: "Android ಮತ್ತು iPhone ಮೇಲೆ ಒಂದೇ-ಟ್ಯಾಪ್ ಇನ್‌ಸ್ಟಾಲ್",
        qrLi2: "iOS 14+ — App Store",
        qrLi3: "Android 8+ — Google Play",
        qrOrVisit: "ಅಥವಾ ಭೇಟಿ ನೀಡಿ",
        ftEyebrow: "ಮನೆಯಿಂದ ಹತ್ತಿರವಾಗಿರಿ",
        ftHeadline: "ನಿಮ್ಮ ಕುಟುಂಬದ ಪರಂಪರೆಯನ್ನು ಉಳಿಸಿಕೊಳ್ಳಿ.",
        ftJoinA: "ಭಾಗವಾಗಿರುವ",
        ftJoinB: "ಭಾರತೀಯ ಕುಟುಂಬಗಳಿಗೆ ಸೇರಿ.",
        ftNewsDesc: "ಪರಂಪರೆಯ ಕಥೆಗಳು, ಸಂಸ್ಕೃತಿ ಕುರಿತ ತಿಳುವಳಿಕೆಗಳು ಮತ್ತು ಉತ್ಪನ್ನ ಸುದ್ದಿಗಳು — ಪಾಕ್ಷಿಕವಾಗಿ ಒಂದ್ಸಲ. ಯಾವುದೇ spam ಇಲ್ಲ.",
        ftSubscribe: "ಸದಸ್ಯರಾಗಿ",
        ftJoining: "ಸೇರಿಸಲಾಗುತ್ತಿದೆ…",
        ftDpdpNote: "DPDP-compliant · ನಾವು ನಿಮ್ಮ ಮಾಹಿತಿಯನ್ನು ಯಾವತ್ತೂ ಮಾರಾಟ ಮಾಡುವುದಿಲ್ಲ",
        ftBrandDesc: "ಭಾರತವನ್ನು ಮೊದಲಿಗೆಯಾಗಿ ಇಡುವ, ಖಾಸಗಿ ಜಾಗ — ಇಲ್ಲಿ ಕುಟುಂಬಗಳು ತಮ್ಮ ಕಥೆಗಳನ್ನು ಸಂಗ್ರಹಿಸಿಕೊಳ್ಳುತ್ತಾರೆ, ಹಿರಿಯರ ಧ್ವನಿಗಳನ್ನು ದಾಖಲು ಮಾಡುತ್ತಾರೆ ಹಾಗೂ ತಮ್ಮ ಪರಂಪರೆಯನ್ನು ಮುಂದಿನ ತಲೆಮಾರುಗಳಿಗೆ ಹಸ್ತಾಂತರಿಸುತ್ತಾರೆ.",
        colCompany: "ಕಂಪನಿ",
        colFtServices: "ವಂಶವೃಕ್ಷ ಸೇವೆಗಳು",
        colAdminSupport: "ಆಡಳಿತ ಸಹಾಯ",
        colProduct: "ಉತ್ಪನ್ನಗಳು / ಸೇವೆಗಳು",
        colSupport: "ಸಹಾಯ ಮತ್ತು ಬೆಂಬಲ",
        colLegal: "ಕಾನೂನು ಸಂಬಂಧಿತ",
        colTechnical: "ತಾಂತ್ರಿಕ",
        colMethodology: "ವಿಧಾನಶಾಸ್ತ್ರ / ಅನುಸರಣಾ ಕ್ರಮ",
        badgeMii: "ಮೇಡ್ ಇನ್ ಇಂಡಿಯಾ · ಮುಂಬೈನಲ್ಲಿ ನಿರ್ಮಿತ",
        badgeDpdp: "DPDP Act 2023 ಅನುಸರಣೆಯಿದೆ",
        badgeIso: "ISO 27001 ಪ್ರಮಾಣಿತ",
        badgeSoc: "SOC 2 ಪ್ರಮಾಣಿತ",
        badgeEnc: "ಬ್ಯಾಂಕ್ ಮಟ್ಟದ ಎನ್‌ಕ್ರಿಪ್ಶನ್",
        wcu6T: "ಆರೋಗ್ಯ ಸಂಗ್ರಹ",
        wcu6D: "ಕುಟುಂಬದ ವೈದ್ಯಕೀಯ ಇತಿಹಾಸ, ಆರೋಗ್ಯ ಸ್ಥಿತಿಗಳು ಮತ್ತು ರಕ್ತ ಗುಂಪುಗಳು — ಎಲ್ಲವೂ ಒಂದೇ ಜಾಗದಲ್ಲಿ.",
        wcu7T: "ಕುಟುಂಬ ಕ್ಯಾಲೆಂಡರ್ ಮತ್ತು ಜ್ಞಾಪನೆಗಳು",
        wcu7D: "ಹುಟ್ಟುಹಬ್ಬಗಳು, ವಿವಾಹ ವಾರ್ಷಿಕೋತ್ಸವಗಳು, ಶ್ರಾದ್ಧ ಮತ್ತು ಹಬ್ಬಗಳು — ಯಾವುದೂ ಮಿಸ್ಸಾಗದಂತೆ.",
        wcu8T: "ಕಾನೂನು ಮತ್ತು ಪರಂಪರೆ ಸಂಗ್ರಹ ಕೋಣೆ",
        wcu8D: "ವಸಿಯತ್ತುಗಳು, ನಾಮನಿರ್ದೇಶಿತರು ಮತ್ತು ವಾರಸುದಾರರ ವಿವರಗಳು — ಬೇಕಾದಾಗ ತಕ್ಷಣ ಸಿಗುವಂತೆ.",
        wcu9T: "ಸಂಪ್ರದಾಯಗಳು ಮತ್ತು ಆಚರಣೆಗಳು",
        wcu9D: "ನಿಮ್ಮ ಕುಟುಂಬದಲ್ಲಿ ಹೇಗೆ ಏನು ಮಾಡುತ್ತಾರೆ — ಮರೆತುಹೋಗುವುದಕ್ಕೆ ಮುಂಚೆ ಬರೆದು ಉಳಿಸಿಕೊಳ್ಳಿ.",
        wcu10T: "ಪಾಕವಿಧಾನಗಳು ಮತ್ತು ಕುಟುಂಬದ ಊಟ",
        wcu10D: "ನಿಮ್ಮ ಮನೆಯಲ್ಲೇ ಮಾತ್ರ ಮಾಡುವ ಪದಾರ್ಥಗಳು, ಅವುಗಳಿಗೆ ಸಂಬಂಧಿಸಿದ ಕಥೆಗಳೊಂದಿಗೆ ಉಳಿಸಿಡಬಹುದು.",
        wcu11T: "ಸ್ಥಳಗಳು ಮತ್ತು ಪೂರ್ವಜರ ಊರು",
        wcu11D: "ನಿಮ್ಮ ಮೂಲಗಳು ನಕ್ಷೆಯಲ್ಲಿ — ಹಳ್ಳಿ, ಮನೆ ಮತ್ತು ಜಗತ್ತಿನಾದ್ಯಂತದ ಪ್ರಯಾಣಗಳು.",
        wcu12T: "ಕುಟುಂಬ ಸಂವಿಧಾನ ಮತ್ತು ಮೌಲ್ಯಗಳು",
        wcu12D: "ನಿಮ್ಮ ಕುಟುಂಬ ಜೀವನ ನಡೆಸುವ ತತ್ವಗಳು — ಒಪ್ಪಿಕೊಂಡು, ಬರಹದಲ್ಲಿ ದಾಖಲಿಸಿದವು.",
        wcu13T: "ಟೈಮ್ ಕ್ಯಾಪ್ಸುಲ್",
        wcu13D: "ಇಂದು ಬರೆದ ಸಂದೇಶಗಳು, ನೀವು ಆಯ್ಕೆಮಾಡಿದ ದಿನಾಂಕದಲ್ಲಿ ತೆರೆಯಲು ಮುಚ್ಚಿಡಲ್ಪಟ್ಟವು.",
        wcu14T: "ಕುಟುಂಬದ ಸಾಧನೆಗಳು ಮತ್ತು ವೀರರು",
        wcu14D: "ಮೈಲಿಗಲ್ಲುಗಳು, ಗೌರವಗಳು ಮತ್ತು ನಿಮ್ಮ ಕುಟುಂಬದ ಮೌನ ವೀರರು.",
        wcu15T: "ಜೀವನಚರಿತ್ರೆ ಮತ್ತು ಸ್ಮರಣಿಕೆ",
        wcu15D: "ಪೂರ್ಣ ಜೀವನಕತೆಗಳು, ನಮ್ಮ ಪರಿಣತಿ ಬರಹಗಾರರ ನೆರವಿನಿಂದ ಬರೆಯಲ್ಪಟ್ಟವು.",
        wcu16T: "AI ಕುಟುಂಬ ಸಲಕರಣೆಗಳು",
        wcu16D: "ಬರೆಯಲು, ಫೋಟೋಗಳನ್ನು ಪುನರುಜ್ಜೀವಿಸಲು ಮತ್ತು ಡಾಕ್ಯುಮೆಂಟರಿಗಳು ತಯಾರಿಸಲು ಮೃದು AI ಸಹಾಯ.",
        wcuSub: "ನಿಮ್ಮ ಕುಟುಂಬಕ್ಕೆ ಬೇಕಾಗಿರುವ ಹದಿನಾರು ದೈನಂದಿನ ವಿಷಯಗಳು — ಎಲ್ಲವೂ ಒಂದೇ ಖಾಸಗಿ, ಸುರಕ್ಷಿತ ಗೃಹದಲ್ಲಿ.",
    },
    ml: {
        heroFamiliesTrust: "ഇന്ത്യൻ കുടുംബങ്ങൾ ഞങ്ങളെ വിശ്വസിക്കുന്നു",
        heroTitleA: "നിങ്ങളുടെ കുടുംബത്തിന്റെ ചരിത്രം",
        heroTitleB: "സംരക്ഷിക്കപ്പെടുന്നത്",
        heroTitleC: "എന്നുമെന്നേക്കും.",
        heroSub: "നിങ്ങളുടെ കുടുംബവൃക്ഷം ഉണ്ടാക്കൂ, മുതിർന്നവരുടെ ശബ്‌ദരേഖകൾ സൂക്ഷിക്കൂ, ഫോട്ടോകളും രേഖകളും സുരക്ഷിതമായി നിലനിർത്തൂ — എല്ലാം നിങ്ങളുടെ സ്വന്തം ഭാഷയിൽ, ഇന്ത്യൻ കുടുംബങ്ങൾക്കായി ഒരുക്കിയ സ്വകാര്യ ഇടത്തിൽ.",
        heroCtaStart: "മൊബൈൽ OTP ഉപയോഗിച്ച് സൗജന്യമായി തുടങ്ങുക",
        heroCtaHow: "ഇത് എങ്ങനെ പ്രവർത്തിക്കുന്നു എന്ന് കാണുക",
        trustPrivate: "സ്വതവേ സ്വകാര്യത",
        trustLangs: "10 ഇന്ത്യൻ ഭാഷകൾ",
        trustFree: "തുടക്കം സൗജന്യം",
        fsdTitle: "മൊബൈൽ OTP ഉപയോഗിച്ച് സൗജന്യമായി തുടങ്ങുക",
        fsdSub: "ഒരു മിനിറ്റിനുള്ളിൽ ആരംഭിക്കാം — പൂർണ്ണമായും സൗജന്യം.",
        fsdP1T: "100% സൗജന്യ തുടക്കം",
        fsdP1D: "ക്രെഡിറ്റ് കാർഡ് ആവശ്യമില്ല, മറഞ്ഞ ചിലവുകളൊന്നുമില്ല. ഫാമിലി ട്രീ, ഫോട്ടോകൾ, കഥകൾ — എല്ലാം Free പ്ലാനിൽ ഉൾപ്പെടുന്നു.",
        fsdP2T: "നിങ്ങളുടെ മൊബൈൽ നമ്പർ മാത്രം",
        fsdP2D: "നിങ്ങളുടെ മൊബൈൽ നമ്പർ നൽകൂ → OTP ലഭിക്കും → പിന്നെ നിങ്ങൾക്കു വേഗം പ്രവേശിക്കാം. ഇമെയിലും പാസ്‌വേഡും ഓർമ്മിക്കേണ്ടതില്ല.",
        fsdP3T: "നിങ്ങളുടെ സ്വകാര്യതക്ക് മുൻഗണന",
        fsdP3D: "സ്വതവേ സ്വകാര്യമാണ് — നിങ്ങളുടെ വിവരങ്ങൾ കാണാൻ കഴിയുന്നത് നിങ്ങളുടെ കുടുംബത്തിനേയ്ക്ക് മാത്രം.",
        fsdContinue: "തുടരുക — സൗജന്യമായി തുടങ്ങുക",
        fsdLater: "പിന്നീട് നോക്കാം",
        dbTitle: "ഉൽപ്പന്ന ഡെമോകളും റീലുകളും",
        dbSub: "എങ്ങനെയാണ് പൂർണ്ണ കുടുംബവൃക്ഷവും ഓർമ്മകളും വാൾട്ടും സംസ്കാര ഫീച്ചറും പ്രവർത്തിക്കുന്നത് എന്ന് ചെറു വീഡിയോകളിലൂടെ കാണാം.",
        dbBtn: "ഡെമോകൾ കാണുക",
        dpHeading: "ഡെമോകൾ, റീലുകൾ & ഡോക്യുമെന്ററികൾ",
        dpSub: "പൂർണ്ണ കുടുംബവൃക്ഷ നിർമ്മാണത്തിൽ നിന്ന് ലെഗസി വാൾട്ടുവരെ — എല്ലാ ഉൽപ്പന്നങ്ങളും സേവനങ്ങളും വിശദമായി കാണിക്കപ്പെട്ടിരിക്കുന്നു.",
        dpFeaturedTag: "പ്രമുഖ ഡെമോ",
        dpAll: "എല്ലാം",
        dpComingSoon: "വീഡിയോ ഉടൻ ലഭ്യമാക്കും",
        navHome: "ഹോം",
        navAbout: "ഞങ്ങളേക്കുറിച്ച്",
        navProducts: "ഉൽപ്പന്നങ്ങളും സേവനങ്ങളും",
        navHowItWorks: "എങ്ങനെ പ്രവർത്തിക്കുന്നു",
        navFeatures: "ഫീച്ചറുകൾ",
        navSolutions: "പരിഹാരങ്ങൾ",
        navHelp: "സഹായം",
        navPackage: "പാക്കേജ്",
        navResources: "റിസോഴ്‌സുകൾ",
        navPricing: "വിലനിർണ്ണയം",
        navDemos: "ഡെമോകൾ",
        accMenuLabel: "സീനിയർ മോഡ്",
        accSenior: "സീനിയർ മോഡ്",
        accSeniorDesc: "വയോധികർക്കായി വലുതായ എഴുത്തും ബട്ടണുകളും",
        accTextSize: "എഴുത്തിന്റെ വലുപ്പം",
        howEyebrow: "എങ്ങനെ പ്രവർത്തിക്കുന്നു",
        howHeading: "കുടുംബവൃക്ഷം തയ്യാറാക്കാനുള്ള ലളിതമായ 5 ഘട്ടങ്ങൾ",
        how1T: "കുടുംബ മേധാവിയായി ലോഗിൻ ചെയ്യുക",
        how1D: "കുടുംബത്തിന്റെ പ്രധാന ഉത്തരവാദിയായിട്ടുള്ള നിങ്ങളുടെ ലോഗിൻ വിവരങ്ങൾ ഉപയോഗിച്ച് സൈൻ ഇൻ ചെയ്ത്, നിങ്ങളുടെ കുടുംബത്തിന്റെ പാരമ്പര്യം കൈകാര്യം ചെയ്യുക.",
        how2T: "കുടുംബാംഗങ്ങളെ ചേർക്കുക",
        how2D: "മാതാപിതാക്കളെയും, മുത്തശ്ശൻമാരെയും, മക്കളെയും, ജീവിത പങ്കാളികളെയും ചേർത്ത് നിങ്ങളുടെ പൂർണ്ണമായ കുടുംബവൃക്ഷം സൃഷ്ടിക്കുക.",
        how3T: "ഓർമ്മകളും കഥകളും അപ്‌ലോഡ് ചെയ്യുക",
        how3D: "എഴുത്തുകളും ചിത്രങ്ങളും ശബ്ദരേഖകളും എല്ലാം സുരക്ഷിതമായി സൂക്ഷിക്കുക — ഓരോ ഓർമ്മക്കും ഇവിടെ ഒരു സുരക്ഷിത വീട് ലഭിക്കും.",
        how4T: "കുടുംബത്തോടെ പങ്കിടുക",
        how4D: "പ്രിയപ്പെട്ടവരെ ക്ഷണിച്ച്, മുഴുവൻ കുടുംബവും ഈ ഓർമ്മകൾ കാണുകയും വീണ്ടും അനുഭവിക്കുകയും പുതിയത് ചേർക്കുകയും ചെയ്യാൻ അവസരം ഒരുക്കുക.",
        how5T: "അടുത്ത തലമുറ പാരമ്പര്യം തുടർന്നു കൊണ്ടുപോകുക",
        how5D: "നിങ്ങളുടെ മക്കളും കൊച്ചു മക്കളും ഈ നല്ല ചര്യ തുടരുന്നു — പാരമ്പര്യം ഒരിക്കലും അവസാനിക്കില്ല.",
        wcuEyebrow: "എന്തുകൊണ്ടാണ് കുടുംബങ്ങൾ ഞങ്ങളെ തിരഞ്ഞെടുക്കുന്നത്",
        wcuHeading: "നിങ്ങളുടെ കുടുംബത്തിന് ഏറ്റവും പ്രിയപ്പെട്ടതെല്ലാം ഒരുമിച്ചു സൂക്ഷിക്കാൻ ഒരു വീടു",
        wcu1T: "കുടുംബ വംശവൃക്ഷം",
        wcu1D: "ആറ് തലമുറകൾ, ഓരോ ശാഖയും — എല്ലാവർക്കും വായിച്ച് മനസ്സിലാക്കാൻ കഴിയുന്ന വൃക്ഷരൂപത്തിൽ.",
        wcu2T: "ഫോട്ടോകളും ഓർമ്മകളും",
        wcu2D: "ഫോട്ടോകൾ, കുറിപ്പുകൾ, നിമിഷങ്ങൾ — സുരക്ഷിതമായി സൂക്ഷിച്ച് എളുപ്പത്തിൽ കണ്ടെത്താൻ.",
        wcu3T: "ശബ്ദവും ഓഡിയോ കഥകളും",
        wcu3D: "മുതിർന്നവരെ അവരുടെ സ്വന്തം ശബ്ദത്തിലും സ്വന്തം ഭാഷയിലും റെക്കോർഡ് ചെയ്യുക.",
        wcu4T: "വീഡിയോ പൈതൃകം",
        wcu4D: "മുന്നിലുള്ള തലമുറകൾക്കായി സൂക്ഷിച്ചിരിക്കുന്ന വീഡിയോ സന്ദേശങ്ങളും വസിയത്തുകളും.",
        wcu5T: "രേഖകളുടെ സുരക്ഷിത ശേഖരം",
        wcu5D: "സർട്ടിഫിക്കറ്റുകൾ, പത്രങ്ങൾ, രേഖകൾ — ക്രമപ്പെടുത്തി എൻക്രിപ്റ്റ് ചെയ്ത്.",
        wcuCtaT: "ഇന്നുതന്നെ നിങ്ങളുടെ കുടുംബത്തിന്റെ പാരമ്പര്യം തുടങ്ങൂ",
        wcuCtaD: "തുടങ്ങാൻ ഫ്രീ — നിങ്ങളുടെ മൊബൈൽ നമ്പർ മാത്രം മതി. നിങ്ങളുടെ കൊച്ചുമക്കൾ നിങ്ങളോട് നന്ദി പറയും.",
        wcuCtaBtn: "ഫ്രീ ആയി തുടങ്ങൂ",
        jfEyebrow: "നിങ്ങളുടെ യാത്ര",
        jfHeading: "ഇന്നുമുതൽ ശാശ്വതതയിലേക്ക് മൂന്ന് ലളിതമായ ഘട്ടങ്ങൾ",
        jfSub: "മിക്കയും കുടുംബങ്ങളും ഒന്നാം ഘട്ടം രണ്ട് മിനിറ്റിനുള്ളിൽ പൂർത്തിയാക്കുന്നു. യാത്രയാകട്ടെ ഒരു മുഴുവൻ ജീവിതകാലം നീണ്ടുനിൽക്കും.",
        jf1T: "നിങ്ങളുടെ കുടുംബത്തെ ചേർക്കുക",
        jf1D: "60 സെക്കൻഡിനുള്ളിൽ മൊബൈൽ OTP സൈൻഅപ്പ്. മാതാപിതാക്കൾ, ജീവിത പങ്കാളി, മക്കൾ എന്നിവരെ ഓരോരുത്തരെയും ചേർക്കൂ — ടൈപ്പ് ചെയ്യാൻ സമയം എടുക്കുന്നുവെന്ന് തോന്നിയാൽ, അവരുടെ പേരുകൾ ഹിന്ദി/മറാഠി ഭാഷയിൽ സംസാരിച്ച് ചേർത്താൽ മതി.",
        jf1B1: "ഒരിക്കലും പാസ്‌വേഡ് വേണ്ട",
        jf1B2: "10 ഇന്ത്യൻ ഭാഷകളിൽ വോയ്സ് ഇൻപുട്ട്",
        jf1B3: "ബന്ധങ്ങൾ സ്വയം പൂരിപ്പിക്കും",
        jf2T: "കഥകളും ഫോട്ടോകളും സേവ് ചെയ്യുക",
        jf2D: "നിങ്ങളുടെ ദാദിയുടെ (പട്ടിയുടെ) കഥകൾ റെക്കോർഡ് ചെയ്യൂ, വിവാഹവും ഉത്സവങ്ങളുടെയും ഫോട്ടോകൾ അപ്‌ലോഡ് ചെയ്യൂ, ആൽബങ്ങളായി ക്രമീകരിക്കൂ. AI നിങ്ങളുടെ ഭാഷയിൽ വോയ്സ് ട്രാൻസ്ക്രൈബ് ചെയ്യും.",
        jf2B1: "ഓഡിയോ + ഫോട്ടോകൾ + ഡോക്യുമെന്റുകൾ",
        jf2B2: "നിങ്ങളുടെ ട്രീയിലെ ആളുകളെ ടാഗ് ചെയ്യൂ",
        jf2B3: "Whisper ട്രാൻസ്ക്രിപ്ഷൻ",
        jf3T: "എന്നും സംരക്ഷിച്ച് സുരക്ഷിതമായി പങ്കിടുക",
        jf3D: "എൻക്രിപ്റ്റ് ചെയ്ത ഇന്ത്യൻ സർവർ സ്റ്റോറേജ്. ഓഡിയോ ഉപയോഗിച്ച് വിൽ (will) കരടുകൾ തയ്യാറാക്കാം. കൊച്ചു കൊച്ചു മക്കൾക്കായി ടൈം-ക്യാപ്സ്യൂളുകൾ ഷെഡ്യൂൾ ചെയ്യാം. രൂപകൽപ്പനയിൽ തന്നെ DPDP അനുസരിച്ചുള്ളതു.",
        jf3B1: "AES-256 എൻക്രിപ്ഷൻ",
        jf3B2: "ബയോമെട്രിക് സുരക്ഷയുള്ള വോൾട്ടുകൾ",
        jf3B3: "എപ്പോഴും നിങ്ങളുടെ കുടുംബത്തിനുള്ളിൽതന്നെ നിലനിൽക്കും",
        jfCta: "ഇപ്പോൾ തന്നെ സ്റ്റെപ്പ് 1 ആരംഭിക്കുക",
        jfNote: "ആദ്യ 25 കുടുംബാംഗങ്ങൾക്ക് പൂർണ്ണമായും സൗജന്യം, എന്നും. ആവശ്യമായി വരുമ്പോൾ മാത്രം അപ്‌ഗ്രേഡ് ചെയ്യാം.",
        featEyebrow: "സവിശേഷതകൾ",
        featHeading: "ഒരു കുടുംബത്തിന് ഒരുമിച്ച് ഓർത്തു സൂക്ഷിക്കാൻ വേണ്ടതെല്ലാം",
        wwhEyebrow: "ഒരു മുന്നറിയിപ്പുകാരമായ അനുഭവം",
        wwhTitleA: "എന്താണ് സംഭവിക്കുക",
        wwhTitleB: "നമ്മുടെ കഥ നമ്മൾ സൂക്ഷിക്കാതെ പോയാൽ?",
        wwhHintDesktop: "ഓട്ടോ-പ്ലേ 3 സെക്കൻഡ് ഇടവിട്ട് · പോസ് ചെയ്യാൻ ഹോവർ ചെയ്യുക · സ്വൈപ്പ് ചെയ്യാം, ← → അല്ലെങ്കിൽ ഡോട്ടുകൾ ഉപയോഗിച്ച് ബ്രൗസ് ചെയ്യാം.",
        wwhHintMobile: "ഓട്ടോ-പ്ലേ · സ്വൈപ്പ് ചെയ്ത് ബ്രൗസ് ചെയ്യാം.",
        ppHeading: "കുടുംബചരിത്രം സംരക്ഷിക്കാത്ത പക്ഷം എന്താണ് സംഭവിക്കുക?",
        pp1: "മുതിർന്നവരുടെ ഓർമ്മകൾ എന്നും ഇല്ലാതായി പോകും",
        pp2: "പഴയ ഫോട്ടോകൾ നഷ്ടപ്പെടാനോ കേടാകാനോ സാധ്യത കൂടുതലാണ്",
        pp3: "കുട്ടികൾക്ക് സ്വന്തം വേരുകളോട് ഉള്ള ബന്ധം ദുർബലമാകും",
        pp4: "പാരമ്പര്യങ്ങൾ ഓരോ തലമുറയിലും മങ്ങിയ് പോകും",
        tEyebrow: "സാക്ഷ്യപത്രങ്ങൾ",
        tHeadA: "രാജ്യമെങ്ങുമുള്ള കുടുംബങ്ങൾ -",
        tIndia: "ഇന്ത്യ",
        tHeadB: "ഞങ്ങളെ വിശ്വസിക്കുക",
        tSub: "യഥാർത്ഥ കുടുംബങ്ങൾ, യഥാർത്ഥ ജീവിതകഥകൾ — എന്നും സുരക്ഷിതമായി സൂക്ഷിക്കുന്നു.",
        faqHeading: "അടിക്കടി ചോദിക്കപ്പെടുന്ന ചോദ്യങ്ങൾ",
        faq1Q: "ഞങ്ങളുടെ കുടുംബ ഡാറ്റ സുരക്ഷിതമാണോ?",
        faq1A: "അതെ. ബാങ്ക് നിലവാരത്തിലുള്ള AES-256 എൻക്രിപ്ഷൻ (at rest), httpOnly cookie auth, Document & Legal Vault-ിനു ഐച്ഛികമായ fingerprint / Face ID ലോക്ക്, ഇന്ത്യയിൽ ഉള്ള MongoDB സ്റ്റോറേജ് എന്നിവ ഉപയോഗിക്കുന്നു.",
        faq2Q: "NRI കുടുംബങ്ങൾക്കും ഇത് ഉപയോഗിക്കാൻ സാധിക്കുമോ?",
        faq2A: "തീർച്ചയായും. ഒന്നിലധികം സമയംമേഖലകൾക്ക് പിന്തുണ, 10 ഇന്ത്യൻ ഭാഷകളിൽ ബ്രൗസർ ഭാഷ auto-detection, കൂടാതെ ഓരോ ബന്ധുവും എവിടെ താമസിക്കുന്നു എന്ന് കാണിക്കുന്ന Family World Map widget എന്നിവ ഉണ്ട്.",
        faq3Q: "മൂത്തവർക്കും (സീനിയേഴ്സിനും) ഇത് എളുപ്പമാണോ?",
        faq3A: "അതെ. Senior Mode-ൽ 3 എണ്ണം മാത്രം, വലുതായ ബട്ടണുകളാണ് കാണുക (Photos / Story / Family). 22px ഫോണ്ട്, വലുതായി ടാപ്പ് ചെയ്യാൻ പറ്റുന്ന ബട്ടണുകൾ, ആദ്യം തന്നെ voice-recording സൗകര്യം എന്നിവയും ഉണ്ട്.",
        faq4Q: "100-ലധികം കുടുംബാംഗങ്ങളെ ചേർക്കാമോ?",
        faq4A: "Free പ്ലാനിൽ 25 പേരെ വരെ ഉൾപ്പെടുന്നു; Family ₹999/yr പ്ലാനിൽ പരമാവധി ആളുകൾക്കും 10 GB സ്റ്റോറേജിനും സൗകര്യം; Legacy ₹2999/yr പ്ലാനിൽ Legal Vault, 100 GB, പ്രിന്റ് ചെയ്ത family tree, priority support എന്നിവയും ലഭിക്കും.",
        faq5Q: "ഏത് ഭാഷകളിലാണ് സൗകര്യമുള്ളത്?",
        faq5A: "English, Hindi, Marathi, Tamil, Telugu, Kannada, Malayalam, Bengali, Gujarati, Punjabi — മുഴുവൻ UI-വും ഈ ഭാഷകളിലേക്ക് തർജിമ ചെയ്തിട്ടുണ്ട്, ആദ്യമായി വരുമ്പോൾ ബ്രൗസറിലെ ഭാഷ auto-detected ആണ്.",
        faq6Q: "ഞങ്ങളുടെ ഡാറ്റ export ചെയ്യാൻ പറ്റുമോ?",
        faq6A: "അതെ. Settings → My Data → Download All My Data ഉപയോഗിച്ച് നിങ്ങളുടെ tree, ഓർമ്മകൾ, കഥകൾ, രേഖകൾ എന്നിവ ഒറ്റ archive ആയി ഡൗൺലോഡ് ചെയ്യാം (DPDP-compliant).",
        faq7Q: "Free trial കഴിഞ്ഞാൽ എന്തു സംഭവിക്കും?",
        faq7A: "ഇവിടെ trial ഒന്നുമില്ല — Free പ്ലാൻ സ്ഥിരമാണ്. 25-ൽ കൂടുതൽ അംഗങ്ങൾ, AI biography, അല്ലെങ്കിൽ Legal Vault വേണമെങ്കിൽ മാത്രമേ upgrade ആവശ്യമുള്ളൂ. വാർഷിക പ്ലാനുകൾക്ക് 7 ദിവസത്തെ grace period-ും പൂർണ്ണമായ money-back guarantee-യും ഞങ്ങൾ നൽകുന്നു.",
        faq8Q: "ഒരുമിച്ച് നിരവധി കുടുംബാംഗങ്ങൾ ചേർന്നു സംഭാവന ചെയ്യാമോ?",
        faq8A: "അതെ. സഹോദരങ്ങളെ, മാതാപിതാക്കളെ, കസിൻമാരെ വരെ mobile നമ്പർ ഉപയോഗിച്ച് ക്ഷണിക്കാം. എല്ലാവർക്കും Family Head / Editor / Viewer എന്നിങ്ങനെ ഒരു role നൽകാം — ഓരോ document-നുമായി വേറിട്ട privacy control-ുകളും ഉണ്ട്.",
        mscTitle: "സൗജന്യം · മൊബൈൽ OTP സൈൻഅപ്പ്",
        mscDpdp: "DPDP നിയമാനുസൃതം",
        mscStart: "സൗജന്യമായി തുടങ്ങുക",
        qrEyebrow: "നിങ്ങളുടെ കുടുംബത്തെ നിങ്ങളൊപ്പമാക്കി കൊണ്ടുപോകൂ",
        qrHeading: "ഒരിക്കൽ സ്കാൻ ചെയ്‌താൽ മതി. Family Repository നിങ്ങളുടെ ഫോണിൽ.",
        qrSub: "ആപ്പ് ഇൻസ്റ്റാൾ ചെയ്യാൻ QR കോഡിലേക്ക് നിങ്ങളുടെ ക്യാമറ തിരിക്കുക. Android, iPhone രണ്ടിലും പ്രവർത്തിക്കും — നിങ്ങൾക്കുള്ള ശരിയായ സ്റ്റോർ ഞങ്ങൾ തന്നെ കണ്ടെത്തും.",
        qrLi1: "Android & iPhone-ൽ ഒരുതപ്പിൽ ഇൻസ്റ്റാൾ",
        qrLi2: "iOS 14+ — App Store",
        qrLi3: "Android 8+ — Google Play",
        qrOrVisit: "അല്ലെങ്കിൽ സന്ദർശിക്കുക",
        ftEyebrow: "വീട്ടിനോട് അടുപ്പമായി ഇരിക്കുക",
        ftHeadline: "നിങ്ങളുടെ കുടുംബത്തിന്റെ പാരമ്പര്യം സംരക്ഷിക്കുക.",
        ftJoinA: "ചേരൂ",
        ftJoinB: "ഇന്ത്യൻ കുടുംബങ്ങളോടൊപ്പം.",
        ftNewsDesc: "പാരമ്പര്യകഥകൾ, സംസ്കാരത്തിന്റെ ചെറിയ അറിവുകൾ, ഉൽപ്പന്ന അപ്‌ഡേറ്റുകൾ — രണ്ടാഴ്ചയിൽ ഒരിക്കൽ മാത്രം. ഒരിക്കലും സ്പാം ഇല്ല.",
        ftSubscribe: "സബ്സ്ക്രൈബ് ചെയ്യുക",
        ftJoining: "ചേരുന്നു…",
        ftDpdpNote: "DPDP അനുസൃതം · നിങ്ങളുടെ ഡാറ്റ ഒരിക്കലും ഞങ്ങൾ വിൽക്കുന്നില്ല",
        ftBrandDesc: "കുടുംബങ്ങൾ അവരുടെ കഥകൾ സൂക്ഷിക്കുകയും, മൂത്തവരുടെ ശബ്ദം റെക്കോർഡ് ചെയ്യുകയും, അവരുടെ പാരമ്പര്യം തലമുറകൾക്ക് കൈമാറുകയും ചെയ്യുന്ന ഒരു സ്വകാര്യ, ഇന്ത്യാ-ആദ്യം ഇടം.",
        colCompany: "കമ്പനി",
        colFtServices: "കുടുംബവൃക്ഷ സേവനങ്ങൾ",
        colAdminSupport: "അഡ്മിൻ സഹായം",
        colProduct: "ഉൽപ്പന്നങ്ങൾ / സേവനങ്ങൾ",
        colSupport: "സഹായവും പിന്തുണയും",
        colLegal: "നിയമപരമായത്",
        colTechnical: "സാങ്കേതികം",
        colMethodology: "രീതി / അനുസരണം",
        badgeMii: "Made in India · മുംബൈയിൽ നിർമിച്ചത്",
        badgeDpdp: "DPDP Act 2023 പ്രകാരം അനുസൃതം",
        badgeIso: "ISO 27001 സർട്ടിഫൈഡ്",
        badgeSoc: "SOC 2 സർട്ടിഫൈഡ്",
        badgeEnc: "ബാങ്ക് നിലവാരമുള്ള എൻക്രിപ്ഷൻ",
        wcu6T: "ആരോഗ്യ ശേഖര കേന്ദ്രം",
        wcu6D: "കുടുംബ മെഡിക്കൽ ചരിത്രം, രോഗാവസ്ഥകൾ, രക്തഗ്രൂപ്പുകൾ — എല്ലാം ഒരിടത്ത്.",
        wcu7T: "കുടുംബ കലണ്ടറും ഓർമ്മിപ്പികളും",
        wcu7D: "ജന്മദിനങ്ങൾ, വിവാഹ വാർഷികങ്ങൾ, ശ്രാദ്ധവും ഉത്സവങ്ങളും — ഒന്നും മറക്കാതെ.",
        wcu8T: "നിയമ-പൈതൃക സുരക്ഷിത ശേഖരം",
        wcu8D: "വസിയത്തുകൾ, നോമിനികൾ, അവകാശ വിവരങ്ങൾ — വേണ്ട സമയത്ത് ഉണ്ടാകുന്ന വിധം.",
        wcu9T: "ആചാരങ്ങളും ചടങ്ങുകളും",
        wcu9D: "നിങ്ങളുടെ കുടുംബം കാര്യങ്ങൾ ചെയ്യുന്ന രീതി — മറക്കപ്പെടുന്നതിന് മുമ്പ് എഴുതി വെക്കുന്നത്.",
        wcu10T: "റസിപ്പികളും കുടുംബ ഭക്ഷണവും",
        wcu10D: "നിങ്ങളുടെ കുടുംബം മാത്രം ഉണ്ടാക്കുന്ന വിഭവങ്ങൾ, അവയ്ക്ക് പിന്നിലെ കഥകളോടെ ചേർത്ത് സംരക്ഷിച്ച് വെക്കുക.",
        wcu11T: "സ്ഥലങ്ങളും പാരമ്പര്യ ഗ്രാമവും",
        wcu11D: "നിങ്ങളുടെ വേര് വരച്ചുകാണിക്കുന്ന ഒരു മാപ്പ് — ഗ്രാമം, വീട്, ലോകമെങ്ങുമുള്ള യാത്രകള്‍.",
        wcu12T: "കുടുംബ ഭരണഘടനയും മൂല്യങ്ങളും",
        wcu12D: "നിങ്ങളുടെ കുടുംബം പാലിക്കാന്‍ സമ്മതിച്ച് രേഖപ്പെടുത്തുന്ന ആചാരങ്ങളും സിദ്ധാന്തങ്ങളും.",
        wcu13T: "സ്മൃതി കുപ്പി (Time Capsule)",
        wcu13D: "ഇന്ന് മുദ്രവെക്കുന്ന സന്ദേശങ്ങള്‍, നിങ്ങള്‍ തെരഞ്ഞെടുക്കുന്ന തീയതിയില്‍ തുറക്കുന്നതിനായി.",
        wcu14T: "കുടുംബ നേട്ടങ്ങളും വീരരും",
        wcu14D: "നേട്ടങ്ങള്‍, ബഹുമതികള്‍, നിങ്ങളുടെ കുടുംബത്തിലെ അറിയപ്പെടാത്ത വീരന്മാര്‍.",
        wcu15T: "ജീവചരിത്രവും സ്മരണകളും",
        wcu15D: "നിങ്ങളുടെ പൂര്‍ണ ജീവിതകഥകള്‍, ഞങ്ങളുടെ വിദഗ്‌ധരായ എഴുത്തുകാരുടെ സഹായത്തോടെ തയ്യാറാക്കുന്നത്.",
        wcu16T: "AI കുടുംബ ഉപകരണങ്ങള്‍",
        wcu16D: "എഴുതാന്‍, പഴയ ഫോട്ടോകള്‍ പുനരുദ്ധരിക്കാന്‍, ഡോക്ക്യുമെന്ററികള്‍ സൃഷ്ടിക്കാന്‍ സഹായിക്കുന്ന സൗമ്യമായ AI സഹായം.",
        wcuSub: "നിങ്ങളുടെ കുടുംബത്തിന് ആവശ്യമുള്ള പതിനാറ് ദൈനംദിന കാര്യങ്ങള്‍ — എല്ലാം ഒരൊറ്റ സ്വകാര്യവും സുരക്ഷിതവുമായ വേദിയില്‍.",
    },
    pa: {
        heroFamiliesTrust: "ਭਾਰਤੀ ਪਰਿਵਾਰ ਸਾਡਾ ਭਰੋਸਾ ਕਰਦੇ ਹਨ",
        heroTitleA: "ਤੁਹਾਡੇ ਪਰਿਵਾਰ ਦੀ ਹਿਸਟਰੀ",
        heroTitleB: "ਸੰਭਾਲੀ ਹੋਈ",
        heroTitleC: "ਹਮੇਸ਼ਾਂ ਲਈ।",
        heroSub: "ਆਪਣਾ ਪਰਿਵਾਰਕ ਵੰਸ਼–ਵ੍ਰੁੱਖ ਬਣਾਓ, ਵੱਡਿਆਂ ਦੀਆਂ ਆਵਾਜ਼ਾਂ ਰਿਕਾਰਡ ਕਰੋ, ਫੋਟੋਆਂ ਤੇ ਦਸਤਾਵੇਜ਼ ਸੰਭਾਲੋ — ਇਹ ਸਭ ਕੁਝ ਇੱਕ ਨਿੱਜੀ ਜਗ੍ਹਾ ਵਿੱਚ, ਜੋ ਭਾਰਤੀ ਪਰਿਵਾਰਾਂ ਲਈ, ਤੁਹਾਡੀ ਆਪਣੀ ਭਾਸ਼ਾ ਵਿੱਚ ਤਿਆਰ ਕੀਤੀ ਗਈ ਹੈ।",
        heroCtaStart: "ਮੋਬਾਈਲ OTP ਨਾਲ ਮੁਫ਼ਤ ਸ਼ੁਰੂ ਕਰੋ",
        heroCtaHow: "ਇਹ ਕਿਵੇਂ ਕੰਮ ਕਰਦਾ ਹੈ, ਵੇਖੋ",
        trustPrivate: "ਮੂਲ ਰੂਪ ਵਿੱਚ ਨਿੱਜੀ",
        trustLangs: "10 ਭਾਰਤੀ ਭਾਸ਼ਾਵਾਂ",
        trustFree: "ਸ਼ੁਰੂਆਤ ਮੁਫ਼ਤ",
        fsdTitle: "ਮੋਬਾਈਲ OTP ਨਾਲ ਮੁਫ਼ਤ ਸ਼ੁਰੂ ਕਰੋ",
        fsdSub: "ਸਿਰਫ਼ 1 ਮਿੰਟ ਵਿੱਚ ਸ਼ੁਰੂ ਕਰੋ — ਬਿਲਕੁਲ ਮੁਫ਼ਤ।",
        fsdP1T: "100% ਮੁਫ਼ਤ ਸ਼ੁਰੂਆਤ",
        fsdP1D: "ਕੋਈ ਕ੍ਰੈਡਿਟ ਕਾਰਡ ਨਹੀਂ, ਕੋਈ ਛੁਪੇ ਹੋਏ ਖਰਚੇ ਨਹੀਂ। ਫੈਮਿਲੀ ਟਰੀ, ਫੋਟੋਆਂ ਅਤੇ ਕਹਾਣੀਆਂ — ਇਹ ਸਭ ਕੁਝ Free ਪਲਾਨ ਵਿੱਚ ਸ਼ਾਮਲ ਹੈ।",
        fsdP2T: "ਸਿਰਫ਼ ਤੁਹਾਡਾ ਮੋਬਾਈਲ ਨੰਬਰ",
        fsdP2D: "ਆਪਣਾ ਮੋਬਾਈਲ ਨੰਬਰ ਦਿਓ → OTP ਪ੍ਰਾਪਤ ਕਰੋ → ਅਤੇ ਅੰਦਰ ਆ ਜਾਓ। ਕੋਈ ਈਮੇਲ ਜਾਂ ਪਾਸਵਰਡ ਯਾਦ ਰੱਖਣ ਦੀ ਲੋੜ ਨਹੀਂ।",
        fsdP3T: "ਸਭ ਤੋਂ ਪਹਿਲਾਂ ਤੁਹਾਡੀ ਪਰਦੇਦਾਰੀ",
        fsdP3D: "ਮੂਲ ਰੂਪ ਵਿੱਚ ਨਿੱਜੀ — ਤੁਹਾਡਾ ਡਾਟਾ ਸਿਰਫ਼ ਤੁਹਾਡਾ ਪਰਿਵਾਰ ਹੀ ਦੇਖ ਸਕਦਾ ਹੈ।",
        fsdContinue: "ਜਾਰੀ ਰੱਖੋ — ਮੁਫ਼ਤ ਸ਼ੁਰੂ ਕਰੋ",
        fsdLater: "ਬਾਅਦ ਵਿੱਚ ਵੇਖਾਂਗਾ/ਵੇਖਾਂਗੀ",
        dbTitle: "ਉਤਪਾਦ ਡੈਮੋ ਅਤੇ ਰੀਲਾਂ",
        dbSub: "ਛੋਟੀਆਂ ਵੀਡੀਓਜ਼ ਵਿੱਚ ਵੇਖੋ ਕਿ ਪੂਰਾ ਪਰਿਵਾਰਿਕ ਵੰਸ਼ਾਵਲੀ ਚਾਰਟ, ਯਾਦਾਂ, ਤਿਜੋਰੀ ਅਤੇ ਸਭਿਆਚਾਰ ਵਾਲੀਆਂ ਸਾਰੀਆਂ ਸੁਵਿਧਾਵਾਂ ਕਿਵੇਂ ਕੰਮ ਕਰਦੀਆਂ ਹਨ।",
        dbBtn: "ਡੈਮੋ ਵੇਖੋ",
        dpHeading: "ਡੈਮੋ, ਰੀਲਾਂ ਅਤੇ ਡੌਕੂਮੈਂਟਰੀਆਂ",
        dpSub: "ਹਰ ਉਤਪਾਦ ਅਤੇ ਸੇਵਾ ਦਾ ਡੈਮੋ — ਪੂਰਾ ਪਰਿਵਾਰਿਕ ਵੰਸ਼ਾਵਲੀ ਚਾਰਟ ਬਣਾਉਣ ਤੋਂ ਲੈ ਕੇ ਲੈਗੇਸੀ ਤਿਜੋਰੀ ਤੱਕ।",
        dpFeaturedTag: "ਚੁਣਿਆ ਹੋਇਆ ਡੈਮੋ",
        dpAll: "ਸਭ",
        dpComingSoon: "ਵੀਡੀਓ ਜਲਦੀ ਆ ਰਹੀ ਹੈ",
        navHome: "ਹੋਮ",
        navAbout: "ਸਾਡੇ ਬਾਰੇ",
        navProducts: "ਉਤਪਾਦ ਅਤੇ ਸੇਵਾਵਾਂ",
        navHowItWorks: "ਇਹ ਕਿਵੇਂ ਕੰਮ ਕਰਦਾ ਹੈ",
        navFeatures: "ਖ਼ਾਸੀਤਾਂ",
        navSolutions: "ਹੱਲ",
        navHelp: "ਮਦਦ",
        navPackage: "ਪੈਕੇਜ",
        navResources: "ਸਰੋਤ",
        navPricing: "ਕੀਮਤਾਂ",
        navDemos: "ਡੈਮੋ",
        accMenuLabel: "ਸੀਨੀਅਰ ਮੋਡ",
        accSenior: "ਸੀਨੀਅਰ ਮੋਡ",
        accSeniorDesc: "ਵੱਡਾ ਲਿਖਤ ਅਤੇ ਵੱਡੇ ਬਟਨ ਬਜ਼ੁਰਗਾਂ ਲਈ",
        accTextSize: "ਲਿਖਤ ਦਾ ਆਕਾਰ",
        howEyebrow: "ਇਹ ਕਿਵੇਂ ਕੰਮ ਕਰਦਾ ਹੈ",
        howHeading: "ਪਰਿਵਾਰ ਵ੍ਰਿਕਸ਼ ਬਣਾਉਣ ਲਈ ਆਸਾਨ 5 ਕਦਮ",
        how1T: "ਪਰਿਵਾਰ ਦੇ ਮੁਖੀ ਵਜੋਂ ਲਾਗਇਨ ਕਰੋ",
        how1D: "ਪਰਿਵਾਰ ਦੇ ਮੁਖੀ ਵਜੋਂ ਆਪਣੇ ਕ੍ਰੈਡੈਂਸ਼ਲ ਨਾਲ ਸਾਈਨ ਇਨ ਕਰੋ ਅਤੇ ਆਪਣੇ ਪਰਿਵਾਰ ਦੀ ਵਿਰਾਸਤ ਦੀ ਜ਼ਿੰਮੇਵਾਰੀ ਆਪਣੇ ਹੱਥ ਵਿੱਚ ਲਓ।",
        how2T: "ਪਰਿਵਾਰਕ ਮੈਂਬਰ ਸ਼ਾਮਲ ਕਰੋ",
        how2D: "ਮਾਤਾ–ਪਿਤਾ, ਦਾਦਾ–ਦਾਦੀ, ਬੱਚੇ ਅਤੇ ਜੀਵਨ ਸਾਥੀ ਜੋੜ ਕੇ ਆਪਣਾ ਪੂਰਾ ਪਰਿਵਾਰਕ ਵ੍ਰਿਕਸ਼ ਬਣਾਓ।",
        how3T: "ਯਾਦਾਂ ਅਤੇ ਕਹਾਣੀਆਂ ਅਪਲੋਡ ਕਰੋ",
        how3D: "ਲਿਖਤ, ਤਸਵੀਰਾਂ ਅਤੇ ਆਡੀਓ ਸੰਭਾਲੋ — ਹਰ ਇੱਕ ਯਾਦ ਨੂੰ ਇੱਕ ਸੁਰੱਖਿਅਤ ਥਾਂ ਮਿਲੇਗੀ।",
        how4T: "ਪਰਿਵਾਰ ਨਾਲ ਸਾਂਝਾ ਕਰੋ",
        how4D: "ਸਨੇਹੀਆਂ ਨੂੰ ਨਿਯੋਤਾ ਭੇਜੋ ਤਾਂ ਕਿ ਸਾਰਾ ਪਰਿਵਾਰ ਇਸ ਖਜ਼ਾਨੇ ਨੂੰ ਵੇਖ ਸਕੇ, ਮੁੜ ਜੀ ਸਕੇ ਅਤੇ ਇਸ ਵਿੱਚ ਆਪਣਾ ਯੋਗਦਾਨ ਦੇ ਸਕੇ।",
        how5T: "ਅਗਲੀ ਪੀੜ੍ਹੀ ਵਿਰਾਸਤ ਨੂੰ ਅੱਗੇ ਲੈ ਕੇ ਜਾਂਦੀ ਹੈ",
        how5D: "ਤੁਹਾਡੇ ਬੱਚੇ ਅਤੇ ਪੌਤਰੇ–ਪੋਤੀਆਂ ਇਹ ਪਰੰਪਰਾ ਜਾਰੀ ਰੱਖਦੇ ਹਨ — ਵਿਰਾਸਤ ਕਦੇ ਰੁਕਦੀ ਨਹੀਂ।",
        wcuEyebrow: "ਪਰਿਵਾਰ ਸਾਨੂੰ ਕਿਉਂ ਚੁਣਦੇ ਹਨ",
        wcuHeading: "ਤੁਹਾਡੇ ਪਰਿਵਾਰ ਦੀਆਂ ਸਾਰੀਆਂ ਪਿਆਰੀਆਂ ਚੀਜ਼ਾਂ ਲਈ ਇੱਕ ਹੀ ਘਰ",
        wcu1T: "ਖਾਨਦਾਨੀ ਵਿਰਖ",
        wcu1D: "ਛੇ ਪੀੜੀਆਂ, ਹਰ ਟਾਹਣੀ — ਇੱਕ ਅਜੇਹੇ ਵਿਰਖ ਵਿਚ ਨਕਸ਼ਾਬੰਦੀ, ਜੋ ਹਰ ਕੋਈ ਆਸਾਨੀ ਨਾਲ ਸਮਝ ਸਕੇ।",
        wcu2T: "ਤਸਵੀਰਾਂ ਅਤੇ ਯਾਦਾਂ",
        wcu2D: "ਤਸਵੀਰਾਂ, ਨੋਟ ਅਤੇ ਪਲ — ਸੁਰੱਖਿਅਤ ਸੰਭਾਲੇ ਹੋਏ ਤੇ ਆਸਾਨੀ ਨਾਲ ਲੱਭਣ ਵਾਲੇ।",
        wcu3T: "ਆਵਾਜ਼ ਅਤੇ ਆਡੀਓ ਕਹਾਣੀਆਂ",
        wcu3D: "ਵੱਡਿਆਂ ਦੀਆਂ ਗੱਲਾਂ ਉਹਨਾਂ ਦੀ ਆਪਣੀ ਆਵਾਜ਼ ਤੇ ਆਪਣੀ ਬੋਲੀ ਵਿੱਚ ਰਿਕਾਰਡ ਕਰੋ।",
        wcu4T: "ਵੀਡੀਓ ਵਿਰਾਸਤ",
        wcu4D: "ਵੀਡੀਓ ਸੁਨੇਹੇ ਅਤੇ ਵਸੀਆਂਤਾਂ — ਆਉਣ ਵਾਲੀਆਂ ਪੀੜੀਆਂ ਲਈ ਸੰਭਾਲ ਕੇ ਰੱਖੀਆਂ।",
        wcu5T: "ਦਸਤਾਵੇਜ਼ ਤਿਜੋਰੀ",
        wcu5D: "ਸਰਟੀਫਿਕੇਟ, ਰਜਿਸਟਰੀਆਂ ਅਤੇ ਕਾਗਜ਼ — ਤਰਤੀਬਬੰਦ ਅਤੇ ਇਨਕ੍ਰਿਪਟ ਕੀਤੇ ਹੋਏ।",
        wcuCtaT: "ਅੱਜ ਤੋਂ ਹੀ ਆਪਣੇ ਪਰਿਵਾਰ ਦੀ ਵਿਰਾਸਤ ਸ਼ੁਰੂ ਕਰੋ",
        wcuCtaD: "ਸ਼ੁਰੂਆਤ ਪੂਰੀ ਤਰ੍ਹਾਂ ਮੁਫ਼ਤ — ਸਿਰਫ਼ ਤੁਹਾਡਾ ਮੋਬਾਈਲ ਨੰਬਰ। ਤੁਹਾਡੇ ਪੋਤੇ–ਪੋਤੀਆਂ ਤੁਹਾਡਾ ਧੰਨਵਾਦ ਕਰਨਗੇ।",
        wcuCtaBtn: "ਮੁਫ਼ਤ ਸ਼ੁਰੂ ਕਰੋ",
        jfEyebrow: "ਤੁਹਾਡਾ ਸਫ਼ਰ",
        jfHeading: "ਅੱਜ ਤੋਂ ਹਮੇਸ਼ਾਂ ਲਈ ਸਿਰਫ਼ ਤਿੰਨ ਆਸਾਨ ਕਦਮ",
        jfSub: "ਜ਼ਿਆਦਾਤਰ ਪਰਿਵਾਰ ਪਹਿਲਾ ਕਦਮ ਦੋ ਮਿੰਟ ਤੋਂ ਘੱਟ ਸਮੇਂ ਵਿੱਚ ਪੂਰਾ ਕਰ ਲੈਂਦੇ ਹਨ। ਪਰ ਸਫ਼ਰ ਆਪ ਜੀਵਨ ਭਰ ਚੱਲ ਸਕਦਾ ਹੈ।",
        jf1T: "ਆਪਣਾ ਪਰਿਵਾਰ ਜੋੜੋ",
        jf1D: "ਮੋਬਾਈਲ OTP ਨਾਲ 60 ਸੈਕਿੰਡ ਵਿੱਚ ਸਾਇਨਅੱਪ। ਮਾਤਾ–ਪਿਤਾ, ਜੀਵਨ ਸਾਥੀ, ਬੱਚੇ ਇਕ–ਇਕ ਕਰਕੇ ਜੋੜੋ — ਜੇ ਟਾਈਪ ਕਰਨਾ ਹੌਲੀ ਲੱਗੇ ਤਾਂ ਉਨ੍ਹਾਂ ਦੇ ਨਾਂ ਹਿੰਦੀ/ਮਰਾਠੀ ਵਿੱਚ ਬੋਲ ਕੇ ਦੱਸੋ।",
        jf1B1: "ਕੋਈ ਪਾਸਵਰਡ ਨਹੀਂ",
        jf1B2: "ਆਵਾਜ਼ ਇੰਪੁੱਟ 10 ਭਾਰਤੀ ਭਾਸ਼ਾਵਾਂ ਵਿੱਚ",
        jf1B3: "ਰਿਸ਼ਤੇ ਆਪਣੇ ਆਪ ਭਰ ਜਾਂਦੇ ਹਨ",
        jf2T: "ਕਹਾਣੀਆਂ ਅਤੇ ਫੋਟੋ ਸੰਭਾਲੋ",
        jf2D: "ਆਪਣੀ ਦਾਦੀ ਦੀਆਂ ਕਹਾਣੀਆਂ ਰਿਕਾਰਡ ਕਰੋ, ਵਿਆਹ ਅਤੇ ਤਿਉਹਾਰਾਂ ਦੀਆਂ ਫੋਟੋਆਂ ਅੱਪਲੋਡ ਕਰੋ, ਉਨ੍ਹਾਂ ਨੂੰ ਐਲਬਮਾਂ ਵਿੱਚ ਸਜਾਓ। AI ਤੁਹਾਡੀ ਭਾਸ਼ਾ ਵਿੱਚ ਆਵਾਜ਼ ਨੂੰ ਲਿਖਤ ਵਿੱਚ ਬਦਲ ਦਿੰਦੀ ਹੈ।",
        jf2B1: "ਆਡੀਓ + ਫੋਟੋਆਂ + ਦਸਤਾਵੇਜ਼",
        jf2B2: "ਆਪਣੇ ਟ੍ਰੀ ਵਿਚੋਂ ਲੋਕਾਂ ਨੂੰ ਟੈਗ ਕਰੋ",
        jf2B3: "Whisper ਟ੍ਰਾਂਸਕ੍ਰਿਪਸ਼ਨ",
        jf3T: "ਹਮੇਸ਼ਾਂ ਲਈ ਸੰਭਾਲੋ, ਸੁਰੱਖਿਅਤ ਤਰੀਕੇ ਨਾਲ ਸਾਂਝਾ ਕਰੋ",
        jf3D: "ਇੰਕ੍ਰਿਪਟ ਕੀਤੀ ਹੋਈ ਭਾਰਤੀ ਸਰਵਰ ਸਟੋਰੇਜ। ਆਡੀਓ ਨਾਲ ਵਸਿਯਤਾਂ ਦੇ ਮਸੌਦੇ ਬਣਾਓ। ਪੋਤਰੇ–ਪੋਤਰੀਆਂ ਲਈ ਟਾਇਮ ਕੈਪਸੂਲ ਤਹਿ ਕਰੋ। ਡਿਜ਼ਾਇਨ ਰਾਹੀਂ DPDP-ਅਨੁਕੂਲ।",
        jf3B1: "AES-256 ਇੰਕ੍ਰਿਪਸ਼ਨ",
        jf3B2: "ਬਾਇਓਮੈਟਰਿਕ ਨਾਲ ਸੁਰੱਖਿਅਤ ਤਿਜੋਰੀਆਂ",
        jf3B3: "ਹਮੇਸ਼ਾ ਤੁਹਾਡੇ ਪਰਿਵਾਰ ਵਿਚ ਹੀ ਰਹਿੰਦਾ ਹੈ",
        jfCta: "ਹੁਣੇ ਕਦਮ 1 ਸ਼ੁਰੂ ਕਰੋ",
        jfNote: "ਪਹਿਲੇ 25 ਪਰਿਵਾਰਕ ਮੈਂਬਰਾਂ ਲਈ ਹਮੇਸ਼ਾਂ ਮੁਫ਼ਤ। ਜਦੋਂ ਲੋੜ ਵਧੇ ਤਾਂ ਹੀ ਅੱਪਗ੍ਰੇਡ ਕਰੋ।",
        featEyebrow: "ਖਾਸੀਆਂ",
        featHeading: "ਜੋ ਕੁਝ ਵੀ ਪਰਿਵਾਰ ਨੂੰ ਇਕੱਠੇ ਯਾਦ ਰੱਖਣ ਲਈ ਚਾਹੀਦਾ ਹੈ",
        wwhEyebrow: "ਇੱਕ ਚੇਤਾਵਨੀ ਭਰੀ ਕਹਾਣੀ",
        wwhTitleA: "ਕੀ ਹੋਵੇਗਾ",
        wwhTitleB: "ਜੇ ਅਸੀਂ ਆਪਣੀ ਕਹਾਣੀ ਸੰਭਾਲ ਕੇ ਨਾ ਰੱਖੀ?",
        wwhHintDesktop: "ਹਰ 3 ਸਕਿੰਟ ਬਾਅਦ ਆਪਣੇ ਆਪ ਚੱਲਦਾ ਹੈ · ਰੋਕਣ ਲਈ ਹਵਰ ਕਰੋ · ਵੇਖਣ ਲਈ ਸਵਾਈਪ ਕਰੋ, ← → ਜਾਂ ਡਾਟਾਂ ਵਰਤੋ।",
        wwhHintMobile: "ਆਪਣੇ ਆਪ ਚੱਲਦਾ ਹੈ · ਵੇਖਣ ਲਈ ਸਵਾਈਪ ਕਰੋ।",
        ppHeading: "ਕੀ ਹੁੰਦਾ ਹੈ ਜੇ ਪਰਿਵਾਰਕ ਇਤਿਹਾਸ ਸੰਭਾਲਿਆ ਨਾ ਜਾਵੇ?",
        pp1: "ਵੱਡਿਆਂ ਦੀਆਂ ਯਾਦਾਂ ਹਮੇਸ਼ਾਂ ਲਈ ਗਾਇਬ ਹੋ ਜਾਂਦੀਆਂ ਹਨ",
        pp2: "ਪੁਰਾਣੀਆਂ ਫੋਟੋਆਂ ਖੋ ਜਾਂਦੀਆਂ ਜਾਂ ਖ਼ਰਾਬ ਹੋ ਜਾਂਦੀਆਂ ਹਨ",
        pp3: "ਬੱਚਿਆਂ ਦਾ ਆਪਣੀਆਂ ਜੜ੍ਹਾਂ ਨਾਲ ਨਾਤਾ ਟੁੱਟ ਜਾਂਦਾ ਹੈ",
        pp4: "ਹਰ ਪੀੜ੍ਹੀ ਨਾਲ ਰਿਵਾਜ ਹੌਲੇ–ਹੌਲੇ ਮੁੱਕ ਜਾਂਦੇ ਹਨ",
        tEyebrow: "ਗਵਾਹੀਆਂ",
        tHeadA: "ਪਰਿਵਾਰਾਂ ਵਿੱਚ",
        tIndia: "ਭਾਰਤ",
        tHeadB: "ਸਾਡੇ ਤੇ ਭਰੋਸਾ ਕਰੋ",
        tSub: "ਅਸਲੀ ਪਰਿਵਾਰ, ਅਸਲੀ ਜ਼ਿੰਦਗੀ ਦੀਆਂ ਕਹਾਣੀਆਂ – ਹਮੇਸ਼ਾਂ ਲਈ ਸੰਭਾਲ ਕੇ ਰੱਖੀਆਂ ਜਾਂਦੀਆਂ ਹਨ।",
        faqHeading: "ਅਕਸਰ ਪੁੱਛੇ ਜਾਣ ਵਾਲੇ ਸਵਾਲ",
        faq1Q: "ਕੀ ਸਾਡਾ ਪਰਿਵਾਰਕ ਡਾਟਾ ਸੁਰੱਖਿਅਤ ਹੈ?",
        faq1A: "ਹਾਂ। ਬੈਂਕ-ਲੇਵਲ AES-256 ਇਨਕ੍ਰਿਪਸ਼ਨ (ਸਟੋਰ ਹੋਏ ਡਾਟਾ ਲਈ), httpOnly ਕੁਕੀ ਆਥ, Document & Legal Vault ‘ਤੇ ਵਿਕਲਪੀ ਫਿੰਗਰਪ੍ਰਿੰਟ/Face ID ਲੌਕ, ਅਤੇ ਭਾਰਤ ਵਿੱਚ ਸਥਿਤ MongoDB ਸਟੋਰੇਜ।",
        faq2Q: "ਕੀ NRI ਪਰਿਵਾਰ ਇਹ ਵਰਤ ਸਕਦੇ ਹਨ?",
        faq2A: "ਬਿਲਕੁਲ। ਮਲਟੀ-ਟਾਈਮਜ਼ੋਨ ਸਹਾਇਤਾ, 10 ਭਾਰਤੀ ਭਾਸ਼ਾਵਾਂ ਵਿੱਚ ਬਰਾਊਜ਼ਰ ਭਾਸ਼ਾ ਦੀ ਆਟੋ-ਡਿਟੈਕਸ਼ਨ, ਅਤੇ ਇੱਕ Family World Map ਵਿਜ਼ਟ ਜੋ ਦਿਖਾਉਂਦਾ ਹੈ ਕਿ ਹਰ ਰਿਸ਼ਤੇਦਾਰ ਕਿੱਥੇ ਰਹਿੰਦਾ ਹੈ।",
        faq3Q: "ਕੀ ਇਹ ਸੀਨੀਅਰ ਸਿਟੀਜ਼ਨ ਲਈ ਆਸਾਨ ਹੈ?",
        faq3A: "ਹਾਂ। Senior Mode ਵਿੱਚ ਸਿਰਫ 3 ਵੱਡੇ ਬਟਨ ਦਿਖਾਈ ਦੇਂਦੇ ਹਨ (Photos / Story / Family)। 22px ਫੋਂਟ, ਵੱਡੇ ਟੈਪ ਟਾਰਗਟ, ਅਤੇ ਸਭ ਤੋਂ ਪਹਿਲਾਂ ਵੌਇਸ-ਰਿਕਾਰਡਿੰਗ।",
        faq4Q: "ਕੀ ਅਸੀਂ 100+ ਪਰਿਵਾਰਕ ਮੈਂਬਰ ਜੋੜ ਸਕਦੇ ਹਾਂ?",
        faq4A: "ਫ੍ਰੀ ਪਲਾਨ ਵਿੱਚ 25 ਮੈਂਬਰ ਸ਼ਾਮਲ ਹਨ; Family ₹999/ਸਾਲ ‘ਤੇ ਅਨਲਿਮਟਿਡ ਮੈਂਬਰ + 10 GB ਸਟੋਰੇਜ ਮਿਲਦੀ ਹੈ; Legacy ₹2999/ਸਾਲ ‘ਤੇ Legal Vault, 100 GB, ਛਪੀ ਹੋਈ ਫੈਮਿਲੀ ਟ੍ਰੀ, ਅਤੇ ਪ੍ਰਾਇਓਰਿਟੀ ਸਹਾਇਤਾ ਮਿਲਦੀ ਹੈ।",
        faq5Q: "ਕਿਹੜੀਆਂ ਭਾਸ਼ਾਵਾਂ ਨੂੰ ਸਹਾਰਾ ਮਿਲਦਾ ਹੈ?",
        faq5A: "English, Hindi, Marathi, Tamil, Telugu, Kannada, Malayalam, Bengali, Gujarati ਅਤੇ Punjabi — ਪੂਰੇ UI ਦੀ ਟ੍ਰਾਂਸਲੇਸ਼ਨ, ਨਾਲ ਹੀ ਪਹਿਲੀ ਵਾਰ ਆਉਣ ‘ਤੇ ਬਰਾਊਜ਼ਰ ਭਾਸ਼ਾ ਆਟੋ-ਡਿਟੈਕਟ ਹੁੰਦੀ ਹੈ।",
        faq6Q: "ਕੀ ਅਸੀਂ ਆਪਣਾ ਡਾਟਾ ਐਕਸਪੋਰਟ ਕਰ ਸਕਦੇ ਹਾਂ?",
        faq6A: "ਹਾਂ। Settings → My Data → Download All My Data ਤੋਂ ਤੁਹਾਡਾ ਟਰੀ, ਯਾਦਾਂ, ਕਹਾਣੀਆਂ ਅਤੇ ਦਸਤਾਵੇਜ਼ ਇੱਕੋ ਆਰਕਾਈਵ ਵਿੱਚ ਐਕਸਪੋਰਟ ਹੁੰਦੇ ਹਨ (DPDP-ਕੰਪਲਾਇੰਟ)।",
        faq7Q: "ਫ੍ਰੀ ਟਰਾਇਲ ਖਤਮ ਹੋਣ ਤੋਂ ਬਾਅਦ ਕੀ ਹੁੰਦਾ ਹੈ?",
        faq7A: "ਕੋਈ ਟਰਾਇਲ ਨਹੀਂ — ਫ੍ਰੀ ਪਲਾਨ ਸਥਾਈ ਹੈ। ਜਦੋਂ ਤੁਹਾਨੂੰ >25 ਮੈਂਬਰ, AI biography ਜਾਂ Legal Vault ਦੀ ਲੋੜ ਪਏ, ਤਦ ਹੀ ਅਪਗ੍ਰੇਡ ਕਰੋ। ਸਾਡੇ ਕੋਲ 7 ਦਿਨ ਦੀ ਗ੍ਰੇਸ ਪੀਰੀਅਡ ਅਤੇ ਸਾਲਾਨਾ ਪਲਾਨਾਂ ‘ਤੇ ਪੂਰੀ ਪੈਸੇ-ਵਾਪਸੀ ਗਾਰੰਟੀ ਹੈ।",
        faq8Q: "ਕੀ ਕਈ ਮੈਂਬਰ ਮਿਲ ਕੇ ਯੋਗਦਾਨ ਦੇ ਸਕਦੇ ਹਨ?",
        faq8A: "ਹਾਂ। ਭਰਾ-ਭੈਣਾਂ, ਮਾਤਾ-ਪਿਤਾ ਅਤੇ ਕਜ਼ਨਜ਼ ਨੂੰ ਮੋਬਾਈਲ ਨੰਬਰ ਰਾਹੀਂ ਨਿਯੋਤਾ ਭੇਜੋ। ਹਰ ਕਿਸੇ ਨੂੰ ਇੱਕ ਰੋਲ ਮਿਲਦਾ ਹੈ: Family Head / Editor / Viewer — ਹਰ ਦਸਤਾਵੇਜ਼ ਲਈ ਵੱਖ-ਵੱਖ ਪ੍ਰਾਇਵੇਸੀ ਕੰਟਰੋਲ ਦੇ ਨਾਲ।",
        mscTitle: "ਮੁਫ਼ਤ · ਮੋਬਾਈਲ OTP ਸਾਈਨਅੱਪ",
        mscDpdp: "DPDP ਅਨੁਕੂਲ",
        mscStart: "ਮੁਫ਼ਤ ਸ਼ੁਰੂ ਕਰੋ",
        qrEyebrow: "ਆਪਣੇ ਪਰਿਵਾਰ ਨੂੰ ਆਪਣੇ ਨਾਲ ਰੱਖੋ",
        qrHeading: "ਇੱਕ ਵਾਰ ਸਕੈਨ ਕਰੋ। ਪਰਿਵਾਰਕ ਭੰਡਾਰ ਤੁਹਾਡੇ ਫੋਨ ਤੇ।",
        qrSub: "ਐਪ ਇੰਸਟਾਲ ਕਰਨ ਲਈ ਆਪਣੇ ਕੈਮਰੇ ਨੂੰ QR ਕੋਡ ਵੱਲ ਮੋੜੋ। Android ਅਤੇ iPhone ਦੋਵਾਂ ਤੇ ਕੰਮ ਕਰਦਾ ਹੈ — ਅਸੀਂ ਆਪਣੇ ਆਪ ਸਹੀ ਸਟੋਰ ਪਹਚਾਣ ਲੈਂਦੇ ਹਾਂ।",
        qrLi1: "Android ਅਤੇ iPhone ‘ਤੇ ਇੱਕ-ਟੈਪ ਇੰਸਟਾਲ",
        qrLi2: "iOS 14+ — App Store",
        qrLi3: "Android 8+ — Google Play",
        qrOrVisit: "ਜਾਂ ਜਾਓ",
        ftEyebrow: "ਘਰ ਨਾਲ ਨੇੜੇ ਰਹੋ",
        ftHeadline: "ਆਪਣੇ ਪਰਿਵਾਰ ਦੀ ਵਿਰਾਸਤ ਸੰਭਾਲੋ।",
        ftJoinA: "ਜੁੜੋ",
        ftJoinB: "ਭਾਰਤੀ ਪਰਿਵਾਰਾਂ ਨਾਲ।",
        ftNewsDesc: "ਵਿਰਾਸਤੀ ਕਹਾਣੀਆਂ, ਸੰਸਕ੍ਰਿਤੀ ਦੇ ਨੁਕਤੇ, ਅਤੇ ਉਤਪਾਦ ਖ਼ਬਰਾਂ — ਪੰਦਰਵੇਂ ਵਿੱਚ ਇੱਕ ਵਾਰ। ਕਦੇ ਵੀ ਸਪੈਮ ਨਹੀਂ।",
        ftSubscribe: "ਸਬਸਕ੍ਰਾਈਬ ਕਰੋ",
        ftJoining: "ਜੁੜ ਰਹੇ ਹੋ…",
        ftDpdpNote: "DPDP-ਅਨੁਕੂਲ · ਅਸੀਂ ਤੁਹਾਡਾ ਡਾਟਾ ਕਦੇ ਨਹੀਂ ਵੇਚਦੇ",
        ftBrandDesc: "ਇੱਕ ਨਿਜੀ, ਭਾਰਤ-ਪਹਿਲਾਂ ਥਾਂ, ਜਿਥੇ ਪਰਿਵਾਰ ਆਪਣੀਆਂ ਕਹਾਣੀਆਂ ਸੰਭਾਲਦੇ ਹਨ, ਬਜ਼ੁਰਗਾਂ ਦੀਆਂ ਆਵਾਜ਼ਾਂ ਰਿਕਾਰਡ ਕਰਦੇ ਹਨ, ਅਤੇ ਆਪਣੀ ਵਿਰਾਸਤ ਪੀੜ੍ਹੀਆਂ ਤੱਕ ਪਹੁੰਚਾਉਂਦੇ ਹਨ।",
        colCompany: "ਕੰਪਨੀ",
        colFtServices: "ਪਰਿਵਾਰ ਵ੍ਰਿਕਸ਼ ਸੇਵਾਵਾਂ",
        colAdminSupport: "ਐਡਮਿਨ ਸਹਾਇਤਾ",
        colProduct: "ਉਤਪਾਦ / ਸੇਵਾਵਾਂ",
        colSupport: "ਸਹਾਇਤਾ ਅਤੇ ਮਦਦ",
        colLegal: "ਕਾਨੂੰਨੀ",
        colTechnical: "ਤਕਨੀਕੀ",
        colMethodology: "ਤਰੀਕਾ / ਅਨੁਕੂਲਤਾ",
        badgeMii: "ਮੇਡ ਇਨ ਇੰਡੀਆ · ਮੁੰਬਈ ਵਿੱਚ ਤਿਆਰ",
        badgeDpdp: "DPDP Act 2023 ਅਨੁਕੂਲ",
        badgeIso: "ISO 27001 ਪ੍ਰਮਾਣਿਤ",
        badgeSoc: "SOC 2 ਪ੍ਰਮਾਣਿਤ",
        badgeEnc: "ਬੈਂਕ-ਪੱਧਰੀ ਇਨਕ੍ਰਿਪਸ਼ਨ",
        wcu6T: "ਸਿਹਤ ਰਿਪੋਜ਼ਟਰੀ",
        wcu6D: "ਪਰਿਵਾਰ ਦੀ ਮੈਡੀਕਲ ਇਤਿਹਾਸ, ਬਿਮਾਰੀਆਂ ਅਤੇ ਖੂਨ ਦੇ ਗਰੁੱਪ — ਸਭ ਕੁਝ ਇਕ ਹੀ ਜਗ੍ਹਾ ਤੇ।",
        wcu7T: "ਪਰਿਵਾਰ ਕੈਲੰਡਰ ਅਤੇ ਯਾਦ ਦਿਹਾਣੀਆਂ",
        wcu7D: "ਜਨਮਦਿਨ, ਵਿਆਹ ਦੀਆਂ ਸਾਲਗਿਰ੍ਹਾਂ, ਸ਼ਰਾਧ ਅਤੇ ਤਿਉਹਾਰ — ਕੁਝ ਵੀ ਨਾ ਛੁੱਟੇ।",
        wcu8T: "ਕਾਨੂੰਨੀ ਅਤੇ ਵਿਰਾਸਤ ਤਿਜੋਰੀ",
        wcu8D: "ਵਸੀਅਤਾਂ, ਨੋਮੀਨੀ ਅਤੇ ਉੱਤਰਾਧਿਕਾਰੀ ਜਾਣਕਾਰੀ — ਲੋੜ ਪੈਣ ਤੇ ਤੁਰੰਤ ਤਿਆਰ।",
        wcu9T: "ਰਿਵਾਜ ਅਤੇ ਰਸਮਾਂ",
        wcu9D: "ਤੁਹਾਡੇ ਪਰਿਵਾਰ ਵਿੱਚ ਕੰਮ ਕਿਵੇਂ ਹੁੰਦੇ ਹਨ — ਭੁੱਲਣ ਤੋਂ ਪਹਿਲਾਂ ਲਿਖ ਕੇ ਸੰਭਾਲੇ ਹੋਏ।",
        wcu10T: "ਵਿਅੰਜਨ ਅਤੇ ਖਾਨਦਾਨੀ ਖਾਣਾ",
        wcu10D: "ਓਹ ਪਕਵਾਨ ਜੋ ਸਿਰਫ ਤੁਹਾਡਾ ਪਰਿਵਾਰ ਬਣਾਉਂਦਾ ਹੈ — ਉਹਨਾਂ ਪਿੱਛੇ ਦੀਆਂ ਕਹਾਣੀਆਂ ਸਮੇਤ ਸੰਭਾਲ ਕੇ ਰੱਖੋ।",
        wcu11T: "ਥਾਵਾਂ ਅਤੇ ਪਿਤਰਾਂ ਦਾ ਪਿੰਡ",
        wcu11D: "ਨਕਸ਼ੇ ‘ਤੇ ਤੁਹਾਡੀਆਂ ਜੜ੍ਹਾਂ — ਪਿੰਡ, ਘਰ ਅਤੇ ਦੁਨੀਆ ਭਰ ਦੀਆਂ ਯਾਤਰਾਵਾਂ।",
        wcu12T: "ਪਰਿਵਾਰਕ ਸੰਵਿਧਾਨ ਅਤੇ ਮੂਲ ਮੁੱਲ",
        wcu12D: "ਉਹ ਸਿਧਾਂਤ ਜਿਨ੍ਹਾਂ ‘ਤੇ ਤੁਹਾਡਾ ਪਰਿਵਾਰ ਚਲਦਾ ਹੈ, ਸਾਂਝੇ ਫ਼ੈਸਲੇ ਨਾਲ ਲਿਖਤ ਵਿੱਚ।",
        wcu13T: "ਟਾਈਮ ਕੈਪਸੂਲ",
        wcu13D: "ਅੱਜ ਲਿਖੇ ਸੁਨੇਹੇ, ਉਸ ਤਾਰੀਖ਼ ਨੂੰ ਖੋਲ੍ਹਣ ਲਈ ਜੋ ਤੁਸੀਂ ਚੁਣੋ।",
        wcu14T: "ਪਰਿਵਾਰਕ ਉਪਲਬਧੀਆਂ ਅਤੇ ਹੀਰੋ",
        wcu14D: "ਮਹੱਤਵਪੂਰਨ ਮੋੜ, ਸਨਮਾਨ ਅਤੇ ਤੁਹਾਡੇ ਪਰਿਵਾਰ ਦੇ ਅਣਸੁਣੇ ਹੀਰੋ।",
        wcu15T: "ਜੀਵਨੀ ਅਤੇ ਯਾਦਾਂ",
        wcu15D: "ਪੂਰੀ ਜ਼ਿੰਦਗੀ ਦੀਆਂ ਕਹਾਣੀਆਂ, ਸਾਡੇ ਮਾਹਿਰ ਲੇਖਕਾਂ ਦੀ ਮਦਦ ਨਾਲ ਲਿਖੀਆਂ ਹੋਈਆਂ।",
        wcu16T: "AI ਪਰਿਵਾਰਕ ਸੰਦ",
        wcu16D: "ਲਿਖਣ, ਫ਼ੋਟੋ ਬਹਾਲ ਕਰਨ ਅਤੇ ਡੌਕਯੂਮੈਂਟਰੀ ਬਣਾਉਣ ਲਈ ਨਰਮ AI ਸਹਾਇਤਾ।",
        wcuSub: "ਰੋਜ਼ਾਨਾ ਪਰਿਵਾਰ ਲਈ ਲੋੜੀਂਦੀਆਂ ਸੋਲ੍ਹਾਂ ਚੀਜ਼ਾਂ — ਸਭ ਕੁਝ ਇੱਕ ਨਿੱਜੀ, ਸੁਰੱਖਿਅਤ ਘਰ ਵਿੱਚ।",
    },
};

Object.entries(LANDING).forEach(([code, dict]) => {
    STRINGS[code] = Object.assign(STRINGS[code] || {}, dict);
});
